window.RomaniaCountyCitiesData = {
  "countries": {
    "Romania": {
      "Alba": [
        "Abrud",
        "Abrud-Sat",
        "Achimetesti",
        "Acmariu",
        "Aiud",
        "Aiudul de Sus",
        "Alba Iulia",
        "Albac",
        "Alecus",
        "Almasu de Mijloc",
        "Almasu Mare",
        "Ampoita",
        "Anghelesti",
        "Arieseni",
        "Aronesti",
        "Arti",
        "Asinip",
        "Avram Iancu",
        "Avramesti",
        "Baba",
        "Bacainti",
        "Badai",
        "Bagau",
        "Bai",
        "Baia de Aries",
        "Balcaciu",
        "Balesti",
        "Balesti-Catun",
        "Balmosesti",
        "Balomiru de Camp",
        "Barabant",
        "Barasti",
        "Barbesti",
        "Bardesti",
        "Barlesti",
        "Barlesti-Catun",
        "Barsana",
        "Barzan",
        "Barzogani",
        "Bazesti",
        "Beldiu",
        "Benic",
        "Berghin",
        "Beta",
        "Bidigesti",
        "Biharia",
        "Biia",
        "Bilanesti",
        "Bisericani",
        "Bistra",
        "Blaj",
        "Blandiana",
        "Blidesti",
        "Bobaresti",
        "Bocesti",
        "Bocsitura",
        "Bodesti",
        "Bodresti",
        "Bogdanesti",
        "Boglesti",
        "Boldesti",
        "Bolovanesti",
        "Boncesti",
        "Bordestii Poieni",
        "Borlesti",
        "Botani",
        "Botesti",
        "Boz",
        "Bradeana",
        "Bradesti",
        "Bradet",
        "Brazesti",
        "Bubesti",
        "Bucerdea Granoasa",
        "Bucerdea Vanoasa",
        "Bucium",
        "Bucium-Sat",
        "Bucuru",
        "Budaiesti",
        "Budeni",
        "Bulbuc",
        "Buninginea",
        "Bunta",
        "Burzesti",
        "Burzonesti",
        "Butesti",
        "Calene",
        "Calnic",
        "Calugaresti",
        "Campeni",
        "Campu Goblii",
        "Candesti",
        "Capalna",
        "Capalna de Jos",
        "Captalan",
        "Capu Dealului",
        "Capud",
        "Carasti",
        "Carpen",
        "Carpenii de Sus",
        "Carpinis",
        "Cartulesti",
        "Casa de Piatra",
        "Casoaia",
        "Cenade",
        "Cerbu",
        "Cergau Mare",
        "Cergau Mic",
        "Certege",
        "Ceru-Bacainti",
        "Cetatea de Balta",
        "Cetea",
        "Cheia",
        "Cheile Cibului",
        "Cheleteni",
        "Cib",
        "Cicard",
        "Cicau",
        "Cioara de Sus",
        "Ciocasu",
        "Cionesti",
        "Cistei",
        "Cisteiu de Mures",
        "Ciuculesti",
        "Ciugud",
        "Ciugudu de Jos",
        "Ciugudu de Sus",
        "Ciuguzel",
        "Ciuldesti",
        "Ciumbrud",
        "Ciuruleasa",
        "Coasta Hentii",
        "Coasta Vascului",
        "Cobles",
        "Cocesti",
        "Cocosesti",
        "Cojocani",
        "Coleseni",
        "Colibi",
        "Coltesti",
        "Copand",
        "Corna",
        "Cornu",
        "Coroiesti",
        "Cortesti",
        "Coslariu",
        "Coslariu Nou",
        "Costesti",
        "Cotorasti",
        "Craciunelu de Jos",
        "Craciunelu de Sus",
        "Craiva",
        "Cretesti",
        "Cricau",
        "Criseni",
        "Cristesti",
        "Cucuta",
        "Cugir",
        "Culdesti",
        "Cunta",
        "Curaturi",
        "Curmatura",
        "Curpeni",
        "Cut",
        "Daia Romana",
        "Dambureni",
        "Dandut",
        "Darlesti",
        "Daroaia",
        "Deal",
        "Dealu Bajului",
        "Dealu Bistrii",
        "Dealu Capsei",
        "Dealu Caselor",
        "Dealu Crisului",
        "Dealu Dostatului",
        "Dealu Ferului",
        "Dealu Frumos",
        "Dealu Geoagiului",
        "Dealu Goiesti",
        "Dealu Lamasoi",
        "Dealu Muntelui",
        "Dealu Ordancusii",
        "Dealu Roatei",
        "Decea",
        "Deleni-Obarsie",
        "Deoncesti",
        "Deve",
        "Dilimani",
        "Dobra",
        "Dobresti",
        "Dobrot",
        "Dogaresti",
        "Dolesti",
        "Doptau",
        "Dos",
        "Dostat",
        "Dosu Luncii",
        "Dosu Vasesti",
        "Dragoiesti-Lunca",
        "Drambar",
        "Drasov",
        "Dric",
        "Duduieni",
        "Dumacesti",
        "Dumbrava",
        "Dumbravita",
        "Dumesti",
        "Dumitra",
        "Dupa Deal",
        "Dupa Plese",
        "Durasti",
        "Faget",
        "Fagetu de Jos",
        "Fagetu de Sus",
        "Fantanele",
        "Farau",
        "Fata",
        "Fata Abrudului",
        "Fata Cristesei",
        "Fata Lapusului",
        "Fata Pietrii",
        "Fata-Lazesti",
        "Feisa",
        "Fenes",
        "Feresti",
        "Fericet",
        "Feteni",
        "Ficaresti",
        "Flitesti",
        "Floresti",
        "Furduiesti",
        "Gabud",
        "Galati",
        "Galbena",
        "Galda de Jos",
        "Galda de Sus",
        "Galtiu",
        "Gambas",
        "Ganesti",
        "Garbova",
        "Garbova de Jos",
        "Garbova de Sus",
        "Garbovita",
        "Garda de Sus",
        "Garda Seaca",
        "Garda-Barbulesti",
        "Garde",
        "Geamana",
        "Geoagiu de Sus",
        "Geogel",
        "Geomal",
        "Ghedulesti",
        "Ghetari",
        "Ghioncani",
        "Ghirbom",
        "Giurgiut",
        "Gligoresti",
        "Glod",
        "Glogovet",
        "Goasele",
        "Goiesti",
        "Gojeiesti",
        "Gorgan",
        "Grosi",
        "Gura Ariesului",
        "Gura Cornei",
        "Gura Cutului",
        "Gura Izbitei",
        "Gura Rosiei",
        "Gura Sohodol",
        "Hadarau",
        "Haiducesti",
        "Hanasesti",
        "Hapria",
        "Harasti",
        "Hategana",
        "Heleresti",
        "Helesti",
        "Henig",
        "Heria",
        "Hoanca",
        "Hodisesti",
        "Hodobana",
        "Holobani",
        "Hoparta",
        "Horea",
        "Hudricesti",
        "Huzaresti",
        "Iacobesti",
        "Ibru",
        "Iclod",
        "Ighiel",
        "Ighiu",
        "Ignatesti",
        "Iliesti",
        "Incesti",
        "Inoc",
        "Intregalde",
        "Inuri",
        "Isca",
        "Ivanis",
        "Izbicioara",
        "Izbita",
        "Izlaz",
        "Izvoarele",
        "Izvoru Ampoiului",
        "Jeflesti",
        "Jidostina",
        "Jidvei",
        "Jojei",
        "Joldisesti",
        "Jurcuiesti",
        "Lancram",
        "Laz",
        "Lazesti",
        "Lazuri",
        "Lehesti",
        "Leorint",
        "Lespezea",
        "Limba",
        "Lipaia",
        "Livezile",
        "Lodroman",
        "Loman",
        "Lopadea Noua",
        "Lopadea Veche",
        "Luminesti",
        "Lunca",
        "Lunca Ampoitei",
        "Lunca Bisericii",
        "Lunca de Jos",
        "Lunca Goiesti",
        "Lunca Larga",
        "Lunca Merilor",
        "Lunca Metesului",
        "Lunca Muresului",
        "Lunca Tarnavei",
        "Lunca Vesesti",
        "Lupaiesti",
        "Lupsa",
        "Lupseni",
        "Lupu",
        "Lupulesti",
        "Macaresti",
        "Maghierat",
        "Magina",
        "Magura",
        "Mahaceni",
        "Mamaligani",
        "Manarade",
        "Manastire",
        "Mancesti",
        "Margaia",
        "Margineni",
        "Marinesti",
        "Martesti",
        "Martinie",
        "Matacina",
        "Matei",
        "Matisesti",
        "Medresti",
        "Medves",
        "Mereteu",
        "Mescreac",
        "Mesentea",
        "Metes",
        "Micesti",
        "Micoslaca",
        "Mihaiesti",
        "Mihalt",
        "Mihoesti",
        "Miraslau",
        "Modolesti",
        "Mogos",
        "Moraresti",
        "Morcanesti",
        "Motorasti",
        "Mugesti",
        "Muncelu",
        "Munesti",
        "Muntari",
        "Mununa",
        "Musca",
        "Nadastia",
        "Namas",
        "Napaiesti",
        "Necrilesti",
        "Necsesti",
        "Negesti",
        "Negresti",
        "Nelegesti",
        "Nemesi",
        "Nicoresti",
        "Niculesti",
        "Noslac",
        "Novacesti",
        "Oarda",
        "Obreja",
        "Ocna Mures",
        "Ocnisoara",
        "Ocoale",
        "Ocolis",
        "Odverem",
        "Ohaba",
        "Oidesti",
        "Oiejdea",
        "Olteni",
        "Oncesti",
        "Orasti",
        "Orgesti",
        "Ormenis",
        "Paclisa",
        "Padure",
        "Padurea",
        "Pagida",
        "Panade",
        "Panca",
        "Pantesti",
        "Parau Gruiului",
        "Parau lui Mihai",
        "Parau-Carbunari",
        "Pastesti",
        "Patrahaitesti",
        "Patrangeni",
        "Patrusesti",
        "Patrutesti",
        "Peles",
        "Perjesti",
        "Peste Valea Bistrii",
        "Petelca",
        "Petelei",
        "Petreasa",
        "Petreni",
        "Petresti",
        "Petrisat",
        "Pianu de Jos",
        "Pianu de Sus",
        "Pirita",
        "Pitarcesti",
        "Pitiga",
        "Plai",
        "Plaiuri",
        "Plescuta",
        "Plesesti",
        "Plesi",
        "Plisti",
        "Podu lui Paul",
        "Poduri",
        "Poduri-Bricesti",
        "Poiana",
        "Poiana Aiudului",
        "Poiana Ampoiului",
        "Poiana Galdei",
        "Poiana Ursului",
        "Poiana Vadului",
        "Poieni",
        "Poienile-Mogos",
        "Poienita",
        "Poiu",
        "Ponor",
        "Ponorel",
        "Popesti",
        "Popestii de Jos",
        "Popestii de Sus",
        "Posaga de Jos",
        "Posaga de Sus",
        "Posogani",
        "Potionci",
        "Preluca",
        "Presaca Ampoiului",
        "Puiuletesti",
        "Purcareti",
        "Puselesti",
        "Racatau",
        "Rachis",
        "Rachita",
        "Radesti",
        "Rahau",
        "Raicani",
        "Ramet",
        "Rametea",
        "Ratitis",
        "Ravicesti",
        "Razboieni-Cetate",
        "Reciu",
        "Remetea",
        "Robesti",
        "Rogoz",
        "Rosesti",
        "Rosia de Secas",
        "Rosia Montana",
        "Runc",
        "Runcuri",
        "Rusesti",
        "Rusi",
        "Sagagea",
        "Salagesti",
        "Salciua de Jos",
        "Salciua de Sus",
        "Salistea",
        "Salistea-Deal",
        "Sanbenedic",
        "Sancel",
        "Sancrai",
        "Sanmiclaus",
        "Santamarie",
        "Santimbru",
        "Saracsau",
        "Sard",
        "Sartas",
        "Sasa",
        "Sasciori",
        "Scarisoara",
        "Scoarta",
        "Sebes",
        "Sebesel",
        "Sebisesti",
        "Secasel",
        "Segaj",
        "Seusa",
        "Sfarcea",
        "Sfoartea",
        "Sibot",
        "Sicoiesti",
        "Silea",
        "Silivas",
        "Simocesti",
        "Simulesti",
        "Snide",
        "Soal",
        "Soharu",
        "Sohodol",
        "Soicesti",
        "Soimus",
        "Sona",
        "Sorlita",
        "Spalnaca",
        "Spatac",
        "Spring",
        "Stalnisoara",
        "Stana de Mures",
        "Stanesti",
        "Stauini",
        "Stefanca",
        "Stei-Arieseni",
        "Stertesti",
        "Stiuleti",
        "Straja",
        "Stremt",
        "Strungari",
        "Sturu",
        "Sub Piatra",
        "Sucesti",
        "Sugag",
        "Surdesti",
        "Suseni",
        "Tamboresti",
        "Taranesti",
        "Tarina",
        "Tarsa",
        "Tarsa-Plai",
        "Tartaria",
        "Tatarlaua",
        "Tau",
        "Tau Bistra",
        "Tauni",
        "Tauti",
        "Tecsesti",
        "Teiu",
        "Teius",
        "Teleac",
        "Telna",
        "Tibru",
        "Tifra",
        "Tiur",
        "Toci",
        "Tolacesti",
        "Tomesti",
        "Tomnatec",
        "Tomusesti",
        "Tomutesti",
        "Tonea",
        "Totesti",
        "Totoi",
        "Trampoiele",
        "Trancesti",
        "Trifesti",
        "Trisoresti",
        "Turdas",
        "Uioara de Jos",
        "Uioara de Sus",
        "Ungurei",
        "Unirea",
        "Urdes",
        "Vadu Motilor",
        "Vai",
        "Valcaneasa",
        "Valcea",
        "Valcesti",
        "Vale In Jos",
        "Valea Abruzel",
        "Valea Alba",
        "Valea Barlutesti",
        "Valea Barnii",
        "Valea Bistrii",
        "Valea Bucurului",
        "Valea Caselor",
        "Valea Cerbului",
        "Valea Ciuciului",
        "Valea Cocesti",
        "Valea Fagetului",
        "Valea Giogesti",
        "Valea Goblii",
        "Valea Holhorii",
        "Valea Inzelului",
        "Valea Larga",
        "Valea lui Mihai",
        "Valea Lunga",
        "Valea Lupsii",
        "Valea Maciului",
        "Valea Manastirii",
        "Valea Mare",
        "Valea Mica",
        "Valea Mlacii",
        "Valea Morii",
        "Valea Negrilesii",
        "Valea Poienii",
        "Valea Sasului",
        "Valea Sesii",
        "Valea Tupilor",
        "Valea Utului",
        "Valea Uzei",
        "Valea Verde",
        "Valea Vintului",
        "Valeni",
        "Valisoara",
        "Valtori",
        "Vama Seaca",
        "Vanvucesti",
        "Varsi",
        "Varsi-Rontu",
        "Varsii Mari",
        "Varsii Mici",
        "Vartanesti",
        "Vartop",
        "Vasesti",
        "Verdesti",
        "Veseus",
        "Veza",
        "Vidolm",
        "Vidra",
        "Vidrisoara",
        "Viezuri",
        "Vinerea",
        "Vingard",
        "Vinta",
        "Vintu de Jos",
        "Vladesti",
        "Vladosesti",
        "Vulcan",
        "Vurpar",
        "Zagris",
        "Zanzesti",
        "Zaries",
        "Zlatna"
      ],
      "Arad": [
        "Aciuta",
        "Adea",
        "Agrisu Mare",
        "Agrisu Mic",
        "Aldesti",
        "Almas",
        "Alunis",
        "Andrei Saguna",
        "Apateu",
        "Arad",
        "Araneag",
        "Archis",
        "Avram Iancu",
        "Bacau de Mijloc",
        "Baia",
        "Banesti",
        "Baratca",
        "Barsa",
        "Barzava",
        "Barzesti",
        "Bata",
        "Batuta",
        "Beliu",
        "Belotint",
        "Benesti",
        "Berechiu",
        "Berindia",
        "Birchis",
        "Bochia",
        "Bocsig",
        "Bodesti",
        "Bodrogu Nou",
        "Bodrogu Vechi",
        "Bontesti",
        "Botfei",
        "Brazii",
        "Brusturi",
        "Bruznic",
        "Buceava-Soimus",
        "Budesti",
        "Buhani",
        "Bulci",
        "Buteni",
        "Calugareni",
        "Camna",
        "Capalnas",
        "Caporal Alexa",
        "Caprioara",
        "Capruta",
        "Carand",
        "Cermei",
        "Chelmac",
        "Cherelus",
        "Chesint",
        "Chier",
        "Chisindia",
        "Chisineu-Cris",
        "Chislaca",
        "Cicir",
        "Cil",
        "Cintei",
        "Ciuntesti",
        "Cladova",
        "Clit",
        "Cociuba",
        "Comanesti",
        "Conop",
        "Corbesti",
        "Coroi",
        "Covasint",
        "Craiva",
        "Cristesti",
        "Crocna",
        "Cruceni",
        "Cuias",
        "Cuied",
        "Curtici",
        "Cuvesdia",
        "Cuvin",
        "Dezna",
        "Dieci",
        "Donceni",
        "Dorgos",
        "Dorobanti",
        "Draut",
        "Dud",
        "Dulcele",
        "Dumbrava",
        "Dumbravita",
        "Fantanele",
        "Felnac",
        "Fenis",
        "Firiteaz",
        "Fiscut",
        "Frumuseni",
        "Galsa",
        "Ghioroc",
        "Graniceri",
        "Groseni",
        "Grosi",
        "Grosii Noi",
        "Gura Vaii",
        "Gurahont",
        "Gurba",
        "Halalis",
        "Halmagel",
        "Halmagiu",
        "Hasmas",
        "Hodis",
        "Hontisor",
        "Horia",
        "Hunedoara Timisana",
        "Iacobini",
        "Iercoseni",
        "Iermata",
        "Iermata Neagra",
        "Ignesti",
        "Ilteu",
        "Ineu",
        "Ionesti",
        "Iosas",
        "Iratosu",
        "Joia Mare",
        "Julita",
        "Labasint",
        "Lalasint",
        "Laz",
        "Lazuri",
        "Leasa",
        "Lestioara",
        "Lipova",
        "Livada",
        "Luguzau",
        "Luncsoara",
        "Lupesti",
        "Macea",
        "Maderat",
        "Madrigesti",
        "Magulicea",
        "Mailat",
        "Manastur",
        "Mandruloc",
        "Manerau",
        "Maraus",
        "Masca",
        "Mermesti",
        "Milova",
        "Minead",
        "Minis",
        "Minisel",
        "Minisu de Sus",
        "Misca",
        "Mocrea",
        "Moneasa",
        "Monorostia",
        "Moroda",
        "Motiori",
        "Munar",
        "Mustesti",
        "Nadab",
        "Nadalbesti",
        "Nadas",
        "Nadlac",
        "Neagra",
        "Nermis",
        "Neudorf",
        "Nicolae Balcescu",
        "Obarsia",
        "Odvos",
        "Olari",
        "Ostrov",
        "Paiuseni",
        "Pancota",
        "Parnesti",
        "Patars",
        "Paulian",
        "Paulis",
        "Pecica",
        "Peregu Mare",
        "Peregu Mic",
        "Pescari",
        "Petris",
        "Pilu",
        "Plescuta",
        "Poiana",
        "Poienari",
        "Prunisor",
        "Radesti",
        "Radna",
        "Ranusa",
        "Rapsig",
        "Revetis",
        "Rogoz de Beliu",
        "Rosia",
        "Rosia Noua",
        "Rostoci",
        "Sagu",
        "Salajeni",
        "Sambateni",
        "Sanleani",
        "Sanmartin",
        "Sanpaul",
        "Sanpetru German",
        "Santana",
        "Sarbi",
        "Satu Mare",
        "Satu Mic",
        "Satu Nou",
        "Savarsin",
        "Sebis",
        "Secaci",
        "Secas",
        "Secusigiu",
        "Sederhat",
        "Seitin",
        "Seleus",
        "Seliste",
        "Selistea",
        "Semlac",
        "Sepreus",
        "Siad",
        "Siclau",
        "Sicula",
        "Silindia",
        "Simand",
        "Sintea Mare",
        "Sintea Mica",
        "Siria",
        "Sistarovat",
        "Slatina de Cris",
        "Slatina de Mures",
        "Socodor",
        "Sofronea",
        "Soimos",
        "Somosches",
        "Stejar",
        "Stoinesti",
        "Susag",
        "Susani",
        "Tagadau",
        "Talagiu",
        "Talmaci",
        "Tarmure",
        "Tarnavita",
        "Tarnova",
        "Taut",
        "Tela",
        "Temesesti",
        "Tipar",
        "Tisa",
        "Tisa Noua",
        "Toc",
        "Tohesti",
        "Troas",
        "Turnu",
        "Urvisu de Beliu",
        "Ususau",
        "Valea Mare",
        "Vanatori",
        "Varadia de Mures",
        "Varfurile",
        "Variasu Mare",
        "Variasu Mic",
        "Varnita",
        "Varsand",
        "Vasile Goldis",
        "Vasoaia",
        "Vidra",
        "Vinga",
        "Virismort",
        "Vladimirescu",
        "Voivodeni",
        "Zabalt",
        "Zabrani",
        "Zadareni",
        "Zarand",
        "Zerind",
        "Zerindu Mic",
        "Zimandcuz",
        "Zimandu Nou",
        "Zimbru"
      ],
      "Arges": [
        "Adunati",
        "Afrimesti",
        "Albesti",
        "Albestii Pamanteni",
        "Albestii Ungureni",
        "Albota",
        "Albotele",
        "Alunis",
        "Alunisu",
        "Anghinesti",
        "Aninoasa",
        "Arefu",
        "Argesani",
        "Argeselu",
        "Babana",
        "Babaroaga",
        "Bacesti",
        "Badeni",
        "Badesti",
        "Badicea",
        "Badila",
        "Badislava",
        "Badulesti",
        "Baiculesti",
        "Baila",
        "Bajanesti",
        "Bajesti",
        "Balabani",
        "Balilesti",
        "Baloteasca",
        "Baltata",
        "Balteni",
        "Banaresti",
        "Banicesti",
        "Bantau",
        "Baranesti",
        "Barasti",
        "Barbalani",
        "Barbalatesti",
        "Barbatesti",
        "Barla",
        "Barlogu",
        "Barloi",
        "Barsestii de Jos",
        "Barsestii de Sus",
        "Barzesti",
        "Bascov",
        "Bascovele",
        "Batrani",
        "Beculesti",
        "Beleti",
        "Berevoesti",
        "Berindesti",
        "Bilcesti",
        "Blaju",
        "Blejani",
        "Bogati",
        "Bolculesti",
        "Bolovanesti",
        "Bordeieni",
        "Borlesti",
        "Borobanesti",
        "Borovinesti",
        "Botarcani",
        "Boteni",
        "Botesti",
        "Brabeti",
        "Bradetu",
        "Bradu",
        "Bradulet",
        "Braileni",
        "Branistea",
        "Branzari",
        "Brateasca",
        "Bratesti",
        "Bratia",
        "Brosteni",
        "Bucov",
        "Bucsenesti",
        "Bucsenesti-Lotasi",
        "Budeasa Mare",
        "Budeasa Mica",
        "Budisteni",
        "Bughea de Jos",
        "Bughea de Sus",
        "Bujoi",
        "Bujoreni",
        "Bumbueni",
        "Bunesti",
        "Burdea",
        "Burdesti",
        "Buretesti",
        "Burlusi",
        "Burnesti",
        "Buta",
        "Buzoesti",
        "Caldararu",
        "Calinesti",
        "Calotesti",
        "Campulung",
        "Candesti",
        "Capatanenii Pamanteni",
        "Capatanenii Ungureni",
        "Capu Piscului",
        "Carcesti",
        "Carciumaresti",
        "Carpenis",
        "Carstieni",
        "Catane",
        "Catanele",
        "Cateasca",
        "Catunasi",
        "Ceauresti",
        "Ceausesti",
        "Cepari",
        "Ceparii Pamanteni",
        "Ceparii Ungureni",
        "Cerbu",
        "Cerbureni",
        "Cersani",
        "Cetateni",
        "Chilii",
        "Chiritesti",
        "Chitani",
        "Chitesti",
        "Cicanesti",
        "Ciesti",
        "Ciobanesti",
        "Ciobani",
        "Ciocanai",
        "Ciocanesti",
        "Ciocanu",
        "Ciocesti",
        "Ciofrangeni",
        "Ciolcesti",
        "Ciomagesti",
        "Ciresu",
        "Cismea",
        "Ciulnita",
        "Ciupa-Manciulescu",
        "Ciuresti",
        "Clucereasa",
        "Cocenesti",
        "Cochinesti",
        "Cocu",
        "Colibasi",
        "Colnic",
        "Coltu",
        "Contesti",
        "Corbeni",
        "Corbi",
        "Corbsori",
        "Cornatel",
        "Cosaci",
        "Coseri",
        "Cosesti",
        "Costesti",
        "Costesti-Vaslan",
        "Costita",
        "Coteasca",
        "Cotenesti",
        "Cotesti",
        "Cotmeana",
        "Cotmenita",
        "Cotu",
        "Cotu Malului",
        "Crampotani",
        "Crintesti",
        "Crivatu",
        "Crucisoara",
        "Cuca",
        "Cungrea",
        "Curtea de Arges",
        "Curteanca",
        "Dambovicioara",
        "Darmanesti",
        "Davidesti",
        "Deagu de Jos",
        "Deagu de Sus",
        "Dealu",
        "Dealu Bisericii",
        "Dealu Bradului",
        "Dealu Frumos",
        "Dealu Obejdeanului",
        "Dealu Orasului",
        "Dealu Padurii",
        "Dealu Tolcesii",
        "Dealu Viilor",
        "Dedulesti",
        "Diconesti",
        "Dincani",
        "Dinculesti",
        "Doblea",
        "Dobresti",
        "Dobrogostea",
        "Dobrotu",
        "Dogari",
        "Domnesti",
        "Draganu-Olteni",
        "Draghescu",
        "Draghicesti",
        "Draghici",
        "Dragolesti",
        "Dragoslavele",
        "Dumbrava",
        "Dumbravesti",
        "Dumiresti",
        "Enculesti",
        "Facaletesti",
        "Fagetu",
        "Falfani",
        "Fantanea",
        "Fata",
        "Fedelesoiu",
        "Florieni",
        "Fratesti",
        "Fratici",
        "Furduesti",
        "Furesti",
        "Furnicosi",
        "Gainusa",
        "Galasesti",
        "Galcesti",
        "Galesesti",
        "Galesu",
        "Galeteanu",
        "Gamacesti",
        "Ganesti",
        "Gardinesti",
        "Gaujani",
        "Geamana",
        "Giuclani",
        "Glambocata",
        "Glambocata-Deal",
        "Glambocel",
        "Glambocelu",
        "Glambocu",
        "Glavacioc",
        "Gliganu de Jos",
        "Gliganu de Sus",
        "Glodu",
        "Godeni",
        "Goia",
        "Goleasca",
        "Golesti",
        "Goranesti",
        "Gorani",
        "Gorganu",
        "Greaban",
        "Greabanu",
        "Grosani",
        "Grosi",
        "Gruiu",
        "Gura Pravat",
        "Gura Vaii",
        "Harsesti",
        "Hartiesti",
        "Hintesti",
        "Huluba",
        "Humele",
        "Ianculesti",
        "Ioanicesti",
        "Ionesti",
        "Izbasesti",
        "Izvorani",
        "Izvoru",
        "Izvoru de Jos",
        "Izvoru de Sus",
        "Jgheaburi",
        "Jugur",
        "Jupanesti",
        "Laceni",
        "Lacurile",
        "Laicai",
        "Langesti",
        "Lapusani",
        "Launele de Sus",
        "Lazaresti",
        "Leicesti",
        "Lentea",
        "Leordeni",
        "Leresti",
        "Lesile",
        "Lespezi",
        "Lintesti",
        "Lipia",
        "Livezeni",
        "Loturi",
        "Lucieni",
        "Luminile",
        "Lunca",
        "Lunca Corbului",
        "Lunca Gartii",
        "Lungani",
        "Lungulesti",
        "Lupueni",
        "Macai",
        "Malu",
        "Malu Vanat",
        "Malureni",
        "Mancioiu",
        "Mandra",
        "Manesti",
        "Manicesti",
        "Maracineni",
        "Mares",
        "Marghia de Jos",
        "Marghia de Sus",
        "Martalogi",
        "Martesti",
        "Matau",
        "Mavrodolu",
        "Merisani",
        "Metofu",
        "Mica",
        "Micesti",
        "Miercani",
        "Mihaesti",
        "Mioarele",
        "Mioveni",
        "Mirosi",
        "Moara Mocanului",
        "Mogosesti",
        "Moraresti",
        "Morasti",
        "Mosoaia",
        "Mosteni-Greci",
        "Mozaceni",
        "Mozacenii-Vale",
        "Mozacu",
        "Musatesti",
        "Muscel",
        "Mustatesti",
        "Namaesti",
        "Negesti",
        "Negrasi",
        "Negreni",
        "Negresti",
        "Nejlovelu",
        "Nigrisoara",
        "Noaptes",
        "Nucsoara",
        "Oarja",
        "Odaeni",
        "Oestii Pamanteni",
        "Oestii Ungureni",
        "Ogrezea",
        "Opresti",
        "Orodel",
        "Otelu",
        "Pacioiu",
        "Padureni",
        "Padureti",
        "Paduroiu din Deal",
        "Paduroiu din Vale",
        "Palanga",
        "Paltenu",
        "Paraschivesti",
        "Parvu Rosu",
        "Patuleni",
        "Pauleasca",
        "Pauleni",
        "Paunesti",
        "Petresti",
        "Piatra",
        "Pielesti",
        "Pietroasa",
        "Pietrosani",
        "Piscani",
        "Pitesti",
        "Pitigaia",
        "Pitoi",
        "Podeni",
        "Podisoru",
        "Podu Brosteni",
        "Podu Dambovitei",
        "Poduri",
        "Poiana Lacului",
        "Poienarei",
        "Poienari",
        "Poienita",
        "Pojorata",
        "Popesti",
        "Priboaia",
        "Priboieni",
        "Priseaca",
        "Prislopu Mare",
        "Prislopu Mic",
        "Prodani",
        "Prosia",
        "Purcareni",
        "Putina",
        "Raca",
        "Rachitele de Jos",
        "Rachitele de Sus",
        "Racovita",
        "Radesti",
        "Radu Negru",
        "Radutesti",
        "Rajletu-Govora",
        "Rancaciov",
        "Ratesti",
        "Ratoi",
        "Recea",
        "Redea",
        "Retevoiesti",
        "Robaia",
        "Rociu",
        "Rogojina",
        "Romana",
        "Rotunda",
        "Rucar",
        "Rudeni",
        "Ruginoasa",
        "Salatrucu",
        "Salistea",
        "Samaila",
        "Samara",
        "Sandulesti",
        "Sapunari",
        "Satic",
        "Satu Nou",
        "Sboghitesti",
        "Scheau",
        "Schitu Golesti",
        "Schitu Scoicesti",
        "Schitu-Matei",
        "Selareasca",
        "Selari",
        "Sendrulesti",
        "Serbanesti",
        "Serboeni",
        "Silistea",
        "Silisteni",
        "Sinesti",
        "Slaatioarele",
        "Slamnesti",
        "Slanic",
        "Slatina",
        "Slobozia",
        "Smei",
        "Smeura",
        "Spiridoni",
        "Stalpeni",
        "Stanesti",
        "Stanicei",
        "Starci",
        "Stefan cel Mare",
        "Stefanesti",
        "Stefanestii Noi",
        "Stejari",
        "Stoenesti",
        "Stolnici",
        "Strambeni",
        "Stroesti",
        "Suici",
        "Surdulesti",
        "Suseni",
        "Suslanesti",
        "Teiu",
        "Teodoresti",
        "Tiganesti",
        "Tigveni",
        "Titesti",
        "Tomsanca",
        "Tomulesti",
        "Toplita",
        "Topoloveni",
        "Turburea",
        "Turcesti",
        "Tutana",
        "Tutulesti",
        "Uda",
        "Udeni-Zavoi",
        "Uiasca",
        "Uleni",
        "Ulita",
        "Ungheni",
        "Ungureni",
        "Urechesti",
        "Urlucea",
        "Urlueni",
        "Urluiesti",
        "Ursoaia",
        "Vacarea",
        "Valcelele",
        "Valea Badenilor",
        "Valea Bradului",
        "Valea Brazilor",
        "Valea Calului",
        "Valea Cetatuia",
        "Valea Corbului",
        "Valea Cucii",
        "Valea Danului",
        "Valea Faurului",
        "Valea Hotarului",
        "Valea Iasului",
        "Valea Indarat",
        "Valea lui Enache",
        "Valea lui Mas",
        "Valea Magurei",
        "Valea Manastirii",
        "Valea Mare",
        "Valea Mare Pravat",
        "Valea Mare-Bratia",
        "Valea Mare-Podgoria",
        "Valea Marului",
        "Valea Muscelului",
        "Valea Nandrii",
        "Valea Nenii",
        "Valea Pechii",
        "Valea Popii",
        "Valea Rizii",
        "Valea Rumanestilor",
        "Valea Silistii",
        "Valea Stanii",
        "Valea Uleiului",
        "Valea Ursului",
        "Valeni",
        "Valeni-Podgoria",
        "Valsanesti",
        "Varloveni",
        "Varsesti",
        "Varzaroaia",
        "Varzaru",
        "Vata",
        "Vedea",
        "Vernesti",
        "Vetisoara",
        "Viisoara",
        "Vladesti",
        "Vladuta",
        "Vlascuta",
        "Voinesti",
        "Vonigeasa",
        "Voroveni",
        "Vranesti",
        "Vulpesti",
        "Vulturesti",
        "Zamfiresti",
        "Zarnesti",
        "Zavoi",
        "Zgripcesti",
        "Zidurile",
        "Zigoneni",
        "Zuvelcati"
      ],
      "Bacau": [
        "Agas",
        "Albele",
        "Antohesti",
        "Apa Asau",
        "Ardeoani",
        "Arini",
        "Asau",
        "Bacau",
        "Bacioiu",
        "Baclesti",
        "Bahna",
        "Bahnaseni",
        "Baimac",
        "Balaia",
        "Balaneasa",
        "Balanesti",
        "Balca",
        "Balcani",
        "Balotesti",
        "Baltata",
        "Balusa",
        "Banca",
        "Barati",
        "Barboasa",
        "Barcana",
        "Barna",
        "Barnesti",
        "Barsanesti",
        "Bartasesti",
        "Barzulesti",
        "Basasti",
        "Bazga",
        "Belciuneasa",
        "Beleghet",
        "Benesti",
        "Berbinceni",
        "Beresti",
        "Beresti-Bistrita",
        "Beresti-Tazlau",
        "Berzunti",
        "Bibiresti",
        "Bijghir",
        "Blaga",
        "Blagesti",
        "Blidari",
        "Boanta",
        "Bobos",
        "Bodeasa",
        "Bogata",
        "Bogdan Voda",
        "Bogdana",
        "Bogdanesti",
        "Boistea",
        "Boistea de Jos",
        "Bolatau",
        "Bolovanis",
        "Borsani",
        "Borzesti",
        "Bosia",
        "Bosoteni",
        "Bostanesti",
        "Bota",
        "Botesti",
        "Brad",
        "Bratesti",
        "Bratila",
        "Brusturoasa",
        "Buchila",
        "Buciumi",
        "Bucsa",
        "Bucsesti",
        "Buda",
        "Budesti",
        "Buhocel",
        "Buhoci",
        "Buhusi",
        "Burdusaci",
        "Buruienis",
        "Buruienisu de Sus",
        "Cabesti",
        "Cadaresti",
        "Caiuti",
        "Calapodesti",
        "Calcai",
        "Calinesti",
        "Calini",
        "Calugareni",
        "Camenca",
        "Campeni",
        "Capata",
        "Capotesti",
        "Caraclau",
        "Carligi",
        "Casin",
        "Cauia",
        "Cerdac",
        "Cernu",
        "Cetatuia",
        "Chetreni",
        "Chetris",
        "Chicerea",
        "Chilia Benei",
        "Chiticeni",
        "Ciobanus",
        "Ciresoaia",
        "Ciucani",
        "Ciughes",
        "Ciumasi",
        "Ciuturesti",
        "Cleja",
        "Climesti",
        "Cociu",
        "Colonesti",
        "Coman",
        "Comanesti",
        "Contesti",
        "Corbasca",
        "Cornatel",
        "Cornatelu",
        "Cornesti",
        "Cornet",
        "Cornii de Jos",
        "Cornii de Sus",
        "Cosnea",
        "Costei",
        "Coteni",
        "Cotofanesti",
        "Cotu Grosului",
        "Cotumba",
        "Craiesti",
        "Crihan",
        "Cuchinis",
        "Cucova",
        "Cucuieti",
        "Curita",
        "Dadesti",
        "Damienesti",
        "Danaila",
        "Darmaneasca",
        "Darmanesti",
        "Dealu Morii",
        "Dealu Perjului",
        "Dealu-Mare",
        "Deleni",
        "Diaconesti",
        "Dienet",
        "Dofteana",
        "Dorneni",
        "Dorofei",
        "Dospinesti",
        "Dragesti",
        "Dragomir",
        "Dragugesti",
        "Dragusani",
        "Dumbrava",
        "Enachesti",
        "Faget",
        "Fagetel",
        "Fagetu de Sus",
        "Faghieni",
        "Fantanele",
        "Faraoani",
        "Farcasa",
        "Ferestrau-Oituz",
        "Fichitesti",
        "Filipeni",
        "Filipesti",
        "Floresti",
        "Frumoasa",
        "Frumuselu",
        "Fruntesti",
        "Fulgeris",
        "Fundatura",
        "Fundatura Rachitoasa",
        "Fundeni",
        "Fundoaia",
        "Fundu Racaciuni",
        "Fundu Tutovei",
        "Fundu Vaii",
        "Furnicari",
        "Gaiceana",
        "Galbeni",
        "Galeri",
        "Garla Anei",
        "Garleni",
        "Garlenii de Sus",
        "Gasteni",
        "Gazarie",
        "Gheorghe Doja",
        "Gherdana",
        "Ghilavesti",
        "Ghimes",
        "Ghionoaia",
        "Gioseni",
        "Giurgeni",
        "Giurgioana",
        "Glavanesti",
        "Glodisoarele",
        "Godinestii de Jos",
        "Godinestii de Sus",
        "Goioasa",
        "Gorghesti",
        "Gradesti",
        "Grigoreni",
        "Gura Craiesti",
        "Gura Vaii",
        "Gutinas",
        "Haghiac",
        "Haineala",
        "Halmacioaia",
        "Hanganesti",
        "Hanta",
        "Harja",
        "Harlesti",
        "Helegiu",
        "Heltiu",
        "Hemeius",
        "Hemieni",
        "Hertioana de Jos",
        "Hertioana-Razesi",
        "Holt",
        "Horgesti",
        "Huruiesti",
        "Hutu",
        "Iaz",
        "Iliesi",
        "Itcani",
        "Itesti",
        "Izvoru Berheciului",
        "Lapos",
        "Larga",
        "Larguta",
        "Lehancea",
        "Leontinesti",
        "Lespezi",
        "Letea Veche",
        "Lichitiseni",
        "Lilieci",
        "Lipova",
        "Livezi",
        "Ludasi",
        "Luizi-Calugara",
        "Lunca Asau",
        "Lunca Dochiei",
        "Luncani",
        "Lupesti",
        "Magazia",
        "Magiresti",
        "Magla",
        "Magura",
        "Malosu",
        "Manastirea Casin",
        "Marascu",
        "Marasti",
        "Marcesti",
        "Marginea",
        "Margineni",
        "Marvila",
        "Mateiesti",
        "Medeleni",
        "Milestii de Jos",
        "Milestii de Sus",
        "Misihanesti",
        "Moinesti",
        "Motoc",
        "Motocesti",
        "Motoseni",
        "Movilita",
        "Muncelu",
        "Nadisa",
        "Nanesti",
        "Nastaseni",
        "Nazarioaia",
        "Negoiesti",
        "Negreni",
        "Negri",
        "Negulesti",
        "Neguseni",
        "Nicolae Balcescu",
        "Nicoresti",
        "Obarsia",
        "Ocheni",
        "Odobesti",
        "Oituz",
        "Oncesti",
        "Oncestii Vechi",
        "Onesti",
        "Oniscani",
        "Oprisesti",
        "Orasa",
        "Orbeni",
        "Osebiti",
        "Otelesti",
        "Padureni",
        "Pagubeni",
        "Pajistea",
        "Palanca",
        "Paltinata",
        "Paltinis",
        "Pancesti",
        "Parau Boghii",
        "Parava",
        "Pargaresti",
        "Parincea",
        "Parjol",
        "Parvulesti",
        "Perchiu",
        "Petresti",
        "Petricica",
        "Plopana",
        "Plopu",
        "Podei",
        "Podis",
        "Podu Turcului",
        "Poduri",
        "Poglet",
        "Poiana",
        "Poiana Negustorului",
        "Poiana Sarata",
        "Poieni",
        "Popeni",
        "Popesti",
        "Popoiu",
        "Pradais",
        "Praja",
        "Prajesti",
        "Prajoaia",
        "Pralea",
        "Preluci",
        "Prisaca",
        "Prohozesti",
        "Pustiana",
        "Putini",
        "Putredeni",
        "Racaciuni",
        "Racatau de Jos",
        "Racatau-Razesi",
        "Racauti",
        "Rachitis",
        "Rachitisu",
        "Rachitoasa",
        "Racova",
        "Racusana",
        "Radeana",
        "Radoaia",
        "Radomiresti",
        "Rastoaca",
        "Razesu",
        "Recea",
        "Reprivat",
        "Rogoaza",
        "Romanesti",
        "Rosiori",
        "Rotaria",
        "Runcu",
        "Rusenii de Sus",
        "Rusenii Razesi",
        "Rusi-Ciutea",
        "Salatruc",
        "Sanduleni",
        "Sarata",
        "Sarbi",
        "Sascut",
        "Sascut-Sat",
        "Satu Nou",
        "Saucesti",
        "Scariga",
        "Scarisoara",
        "Schineni",
        "Schitu Frumoasa",
        "Scorteni",
        "Scurta",
        "Scutaru",
        "Seaca",
        "Secuieni",
        "Sendresti",
        "Serbesti",
        "Serpeni",
        "Sesuri",
        "Siretu",
        "Slanic-Moldova",
        "Slobozia",
        "Slobozia Noua",
        "Soci",
        "Sohodol",
        "Sohodor",
        "Solont",
        "Somusca",
        "Spria",
        "Stanesti",
        "Stanisesti",
        "Stefan cel Mare",
        "Stefan Voda",
        "Stejaru",
        "Straja",
        "Straminoasa",
        "Strugari",
        "Stufu",
        "Sulta",
        "Surina",
        "Tagara",
        "Tamasi",
        "Tamasoaia",
        "Tarata",
        "Tardenii Mari",
        "Targu Ocna",
        "Targu Trotus",
        "Tarhausi",
        "Tarnita",
        "Tatarasti",
        "Taula",
        "Tavadaresti",
        "Teius",
        "Temelia",
        "Tepoaia",
        "Tescani",
        "Tiganesti",
        "Tisa",
        "Tisa-Silvestri",
        "Tochilea",
        "Tomozia",
        "Traian",
        "Trebes",
        "Turluianu",
        "Tuta",
        "Ungureni",
        "Urechesti",
        "Ursoaia",
        "Valcele",
        "Valea Arinilor",
        "Valea Botului",
        "Valea Budului",
        "Valea Caselor",
        "Valea Fanatului",
        "Valea Hogei",
        "Valea lui Ion",
        "Valea Lupului",
        "Valea Mare",
        "Valea Marului",
        "Valea Merilor",
        "Valea Mica",
        "Valea Mosneagului",
        "Valea Nacului",
        "Valea Salciei",
        "Valea Seaca",
        "Valea Sosii",
        "Valeni",
        "Vermesti",
        "Versesti",
        "Viforeni",
        "Viisoara",
        "Vladnic",
        "Vranceni",
        "Vultureni",
        "Zapodia",
        "Zemes",
        "Zlatari"
      ],
      "Bihor": [
        "Abram",
        "Abramut",
        "Adoni",
        "Albesti",
        "Albis",
        "Alesd",
        "Almasu Mare",
        "Almasu Mic",
        "Alparea",
        "Ant",
        "Apateu",
        "Arpasel",
        "Astileu",
        "Ateas",
        "Auseu",
        "Avram Iancu",
        "Baile Felix",
        "Baita",
        "Baita-Plai",
        "Balaia",
        "Balc",
        "Baleni",
        "Balnaca",
        "Balnaca-Grosi",
        "Batar",
        "Beius",
        "Beiusele",
        "Belejeni",
        "Belfir",
        "Berechiu",
        "Betfia",
        "Beznea",
        "Bicacel",
        "Bicaci",
        "Biharia",
        "Birtin",
        "Bistra",
        "Bogei",
        "Boianu Mare",
        "Boiu",
        "Borod",
        "Borozel",
        "Bors",
        "Borsa",
        "Borumlaca",
        "Borz",
        "Botean",
        "Bradet",
        "Bratca",
        "Bratesti",
        "Briheni",
        "Brusturi",
        "Bucium",
        "Bucuroaia",
        "Budoi",
        "Budureasa",
        "Buduslau",
        "Bulz",
        "Buntesti",
        "Burda",
        "Burzuc",
        "Butani",
        "Cabesti",
        "Cacuciu Nou",
        "Cacuciu Vechi",
        "Cadea",
        "Calacea",
        "Calatani",
        "Calatea",
        "Calea Mare",
        "Calugari",
        "Camp",
        "Camp-Moti",
        "Campani",
        "Campani de Pomezeu",
        "Capalna",
        "Carandeni",
        "Caranzel",
        "Carasau",
        "Carpinet",
        "Cauaceu",
        "Cauasd",
        "Cefa",
        "Ceica",
        "Ceisoara",
        "Cenalos",
        "Cetariu",
        "Cetea",
        "Cherechiu",
        "Cheresig",
        "Cheriu",
        "Chesa",
        "Chesereu",
        "Chet",
        "Chijic",
        "Chioag",
        "Chiraleu",
        "Chiribis",
        "Chiscau",
        "Chisirid",
        "Chislaz",
        "Chistag",
        "Cihei",
        "Ciocaia",
        "Ciuhoi",
        "Ciulesti",
        "Ciumeghiu",
        "Ciutelec",
        "Cociuba Mare",
        "Cociuba Mica",
        "Codrisoru",
        "Codru",
        "Cohani",
        "Colesti",
        "Copacel",
        "Copaceni",
        "Corbesti",
        "Corboaia",
        "Cordau",
        "Cornisesti",
        "Cornitel",
        "Cosdeni",
        "Cotiglet",
        "Crancesti",
        "Crestur",
        "Cresuia",
        "Cristioru de Jos",
        "Cristioru de Sus",
        "Cubulcut",
        "Cucuceni",
        "Cuiesd",
        "Curatele",
        "Curtuiseni",
        "Cusuius",
        "Cuzap",
        "Damis",
        "Delani",
        "Derna",
        "Dernisoara",
        "Dicanesti",
        "Dijir",
        "Diosig",
        "Dobresti",
        "Dobricionesti",
        "Dolea",
        "Draganesti",
        "Dragesti",
        "Dragoteni",
        "Dumbrava",
        "Dumbravani",
        "Dumbravita",
        "Dumbravita de Codru",
        "Dusesti",
        "Fanate",
        "Fancica",
        "Fasca",
        "Fegernic",
        "Fegernicu Nou",
        "Felcheriu",
        "Feneris",
        "Ferice",
        "Finis",
        "Fizis",
        "Foglas",
        "Fonau",
        "Forau",
        "Forosig",
        "Fughiu",
        "Galaseni",
        "Galospetreu",
        "Gepis",
        "Gepiu",
        "Gheghie",
        "Ghenetea",
        "Ghida",
        "Ghighiseni",
        "Ghiorac",
        "Ginta",
        "Girisu de Cris",
        "Girisu Negru",
        "Giulesti",
        "Goila",
        "Gradinari",
        "Grosi",
        "Gruilung",
        "Gurani",
        "Gurbediu",
        "Gurbesti",
        "Haieu",
        "Harsesti",
        "Haucesti",
        "Hidis",
        "Hidisel",
        "Hidiselu de Jos",
        "Hidiselu de Sus",
        "Hinchiris",
        "Hodis",
        "Hodisel",
        "Hodos",
        "Holod",
        "Homorog",
        "Hotar",
        "Hotarel",
        "Husasau de Cris",
        "Husasau de Tinca",
        "Huta",
        "Huta Voivozi",
        "Ianca",
        "Ianosda",
        "Inand",
        "Incesti",
        "Ineu",
        "Ioanis",
        "Iteu",
        "Iteu Nou",
        "Izbuc",
        "Izvoarele",
        "Josani",
        "Lacu Sarat",
        "Lazareni",
        "Lazuri",
        "Lazuri de Beius",
        "Leheceni",
        "Lelesti",
        "Les",
        "Livada Beiusului",
        "Livada de Bihor",
        "Loranta",
        "Lorau",
        "Lugasu de Jos",
        "Lugasu de Sus",
        "Lunca",
        "Luncasprie",
        "Luncsoara",
        "Lupoaia",
        "Madaras",
        "Magesti",
        "Magura",
        "Marghita",
        "Margine",
        "Martihaz",
        "Meziad",
        "Mierag",
        "Mierlau",
        "Miersig",
        "Mihai Bravu",
        "Miheleu",
        "Misca",
        "Mizies",
        "Motesti",
        "Munteni",
        "Nadar",
        "Nimaiesti",
        "Niuved",
        "Nojorid",
        "Nucet",
        "Ogesti",
        "Olcea",
        "Olosig",
        "Oradea",
        "Ortiteag",
        "Orvisele",
        "Osand",
        "Osorhei",
        "Otomani",
        "Pacalesti",
        "Padurea Neagra",
        "Padureni",
        "Pagaia",
        "Paleu",
        "Palota",
        "Pantasesti",
        "Parhida",
        "Paulesti",
        "Pausa",
        "Pestere",
        "Pestis",
        "Petid",
        "Petrani",
        "Petreasa",
        "Petreu",
        "Petrileni",
        "Picleu",
        "Pietroasa",
        "Pocioveliste",
        "Poclusa de Barcau",
        "Poclusa de Beius",
        "Pocola",
        "Poiana",
        "Poiana Tasad",
        "Poienii de Jos",
        "Poienii de Sus",
        "Poietari",
        "Pomezeu",
        "Ponoara",
        "Popesti",
        "Posoloaca",
        "Prisaca",
        "Rabagani",
        "Racas",
        "Rapa",
        "Reghea",
        "Remetea",
        "Remeti",
        "Rieni",
        "Rogoz",
        "Rohani",
        "Roit",
        "Rontau",
        "Rosia",
        "Rosiori",
        "Rotaresti",
        "Rugea",
        "Sabolciu",
        "Saca",
        "Sacadat",
        "Sacalasau",
        "Sacalasau Nou",
        "Sacueni",
        "Salacea",
        "Salard",
        "Saldabagiu de Barcau",
        "Saldabagiu de Munte",
        "Saldabagiu Mic",
        "Saliste",
        "Saliste de Beius",
        "Saliste de Pomezeu",
        "Saliste de Vascau",
        "Salonta",
        "Sambata",
        "Saniob",
        "Sanlazar",
        "Sanmartin",
        "Sanmartin de Beius",
        "Sannicolau de Beius",
        "Sannicolau de Munte",
        "Sannicolau Roman",
        "Santandrei",
        "Santaul Mare",
        "Santaul Mic",
        "Santelec",
        "Santimreu",
        "Santion",
        "Sarand",
        "Sarbesti",
        "Sarbi",
        "Sarcau",
        "Sarsig",
        "Satu Barba",
        "Satu Nou",
        "Sauaieu",
        "Saucani",
        "Saud",
        "Sebis",
        "Seghiste",
        "Serani",
        "Serghis",
        "Sfarnas",
        "Sighistel",
        "Silindru",
        "Simian",
        "Sinteu",
        "Sisterea",
        "Sitani",
        "Sititelec",
        "Socet",
        "Sohodol",
        "Soimi",
        "Soimus",
        "Spinus",
        "Spinus de Pomezeu",
        "Stancesti",
        "Stei",
        "Stracos",
        "Subpiatra",
        "Sudrigiu",
        "Suiug",
        "Sumugiu",
        "Suncuis",
        "Suncuius",
        "Suplacu de Barcau",
        "Suplacu de Tinca",
        "Surduc",
        "Surducel",
        "Sustiu",
        "Susturogi",
        "Talpe",
        "Talpos",
        "Tamasda",
        "Tamaseu",
        "Tarcaia",
        "Tarcaita",
        "Tarcea",
        "Targusor",
        "Tarian",
        "Tasad",
        "Taut",
        "Tautelec",
        "Tauteu",
        "Teleac",
        "Telechiu",
        "Tetchea",
        "Tiganestii de Beius",
        "Tiganestii de Cris",
        "Tileagd",
        "Tilecus",
        "Tinaud",
        "Tinca",
        "Toboliu",
        "Tomnatic",
        "Topa de Cris",
        "Topa de Jos",
        "Topa de Sus",
        "Topesti",
        "Totoreni",
        "Tria",
        "Tulca",
        "Ucuris",
        "Uileacu de Beius",
        "Uileacu de Cris",
        "Uileacu de Munte",
        "Ursad",
        "Urvind",
        "Urvis de Beius",
        "Vadu Crisului",
        "Vaida",
        "Valani de Pomezeu",
        "Valanii de Beius",
        "Valcelele",
        "Valea Cerului",
        "Valea Crisului",
        "Valea de Jos",
        "Valea de Sus",
        "Valea lui Mihai",
        "Valea Mare de Codru",
        "Valea Mare de Cris",
        "Valea Tarnei",
        "Varasau",
        "Varaseni",
        "Varciorog",
        "Varviz",
        "Varzari",
        "Varzarii de Jos",
        "Varzarii de Sus",
        "Vasad",
        "Vascau",
        "Viisoara",
        "Vintere",
        "Voivozi",
        "Zavoiu",
        "Zece Hotare"
      ],
      "Bistrita-Nasaud": [
        "Agries",
        "Agriesel",
        "Agrisu de Jos",
        "Agrisu de Sus",
        "Albestii Bistritei",
        "Alunisul",
        "Anies",
        "Apatiu",
        "Arcalia",
        "Archiud",
        "Ardan",
        "Arsita",
        "Barla",
        "Bata",
        "Beclean",
        "Beudiu",
        "Bichigiu",
        "Bidiu",
        "Bistrita",
        "Bistrita Bargaului",
        "Blajenii de Jos",
        "Blajenii de Sus",
        "Borleasa",
        "Bozies",
        "Branistea",
        "Brateni",
        "Breaza",
        "Bretea",
        "Budacu de Jos",
        "Budacu de Sus",
        "Budesti",
        "Budesti-Fanate",
        "Budurleni",
        "Budus",
        "Bungard",
        "Buza Catun",
        "Caianu Mare",
        "Caianu Mic",
        "Caila",
        "Camp",
        "Cepari",
        "Chetiu",
        "Chintelnic",
        "Chiochis",
        "Chirales",
        "Chiuza",
        "Ciceu-Corabia",
        "Ciceu-Giurgesti",
        "Ciceu-Mihaiesti",
        "Ciceu-Poieni",
        "Ciosa",
        "Cireasi",
        "Ciresoaia",
        "Coasta",
        "Cociu",
        "Coldau",
        "Colibita",
        "Comlod",
        "Cormaia",
        "Corvinesti",
        "Cosbuc",
        "Coseriu",
        "Crainimat",
        "Cristestii Ciceului",
        "Cristur-Sieu",
        "Cusma",
        "Dealu Stefanitei",
        "Delureni",
        "Dipsa",
        "Dobric",
        "Dobricel",
        "Domnesti",
        "Dorolea",
        "Draga",
        "Dumbrava",
        "Dumbraveni",
        "Dumbravita",
        "Dumitra",
        "Dumitrita",
        "Dupa Deal",
        "Enciu",
        "Fanate",
        "Fanatele Silivasului",
        "Fantanele",
        "Fantanita",
        "Feldru",
        "Feleac",
        "Fiad",
        "Figa",
        "Floresti",
        "Galatii Bistritei",
        "Gersa I",
        "Gersa Ii",
        "Ghemes",
        "Ghinda",
        "Gledin",
        "Halmasau",
        "Hasmasu Ciceului",
        "Herina",
        "Hirean",
        "Ilisua",
        "Ilva Mare",
        "Ilva Mica",
        "Ivaneasa",
        "Jeica",
        "Jelna",
        "Jimbor",
        "Josenii Bargaului",
        "La Curte",
        "Lechinta",
        "Lelesti",
        "Lesu",
        "Livezile",
        "Liviu Rebreanu",
        "Lunca",
        "Lunca Borlesei",
        "Lunca Ilvei",
        "Lunca Lesului",
        "Lunca Sateasca",
        "Lusca",
        "Magura Ilvei",
        "Magurele",
        "Maieru",
        "Malin",
        "Malut",
        "Manic",
        "Mariselu",
        "Matei",
        "Micestii de Campie",
        "Mijlocenii Bargaului",
        "Milas",
        "Mintiu",
        "Mires",
        "Mititei",
        "Mocod",
        "Mogoseni",
        "Moliset",
        "Monariu",
        "Monor",
        "Morut",
        "Muresenii Bargaului",
        "Nasaud",
        "Negrilesti",
        "Nepos",
        "Neteni",
        "Nimigea de Jos",
        "Nimigea de Sus",
        "Nuseni",
        "Oarzina",
        "Ocnita",
        "Orheiu Bistritei",
        "Orosfaia",
        "Paltineasa",
        "Parva",
        "Perisor",
        "Petris",
        "Piatra",
        "Piatra Fantanele",
        "Pinticu",
        "Podenii",
        "Poderei",
        "Podirei",
        "Poiana Ilvei",
        "Poienile Zagrei",
        "Porumbenii",
        "Posmus",
        "Prundu Bargaului",
        "Purcarete",
        "Racatesu",
        "Ragla",
        "Rebra",
        "Rebrisoara",
        "Reteag",
        "Rodna",
        "Romuli",
        "Runcu Salvei",
        "Rustior",
        "Rusu Bargaului",
        "Rusu de Jos",
        "Rusu de Sus",
        "Salcuta",
        "Salva",
        "Sangeorz-Bai",
        "Sangeorzu Nou",
        "Saniacob",
        "Sanmihaiu de Campie",
        "Sannicoara",
        "Sant",
        "Santioana",
        "Sarata",
        "Saratel",
        "Sasarm",
        "Satu Nou",
        "Scoabe",
        "Sebis",
        "Sendroaia",
        "Sesuri Spermezeu-Vale",
        "Sieu",
        "Sieu-Magherus",
        "Sieu-Odorhei",
        "Sieu-Sfantu",
        "Sieut",
        "Sigmir",
        "Silivasu de Campie",
        "Simionesti",
        "Sintereag",
        "Sintereag-Gara",
        "Sirioara",
        "Sita",
        "Slatinita",
        "Soimus",
        "Sopteriu",
        "Spermezeu",
        "Stramba",
        "Strugureni",
        "Stupini",
        "Suplai",
        "Susenii Bargaului",
        "Tagsoru",
        "Tagu",
        "Tarlisua",
        "Tarpiu",
        "Taure",
        "Teaca",
        "Telcisor",
        "Telciu",
        "Tentea",
        "Tigau",
        "Tiha Bargaului",
        "Tonciu",
        "Tureac",
        "Unirea",
        "Uriu",
        "Urmenis",
        "Valea",
        "Valea Borcutului",
        "Valea Magherusului",
        "Valea Mare",
        "Valea Poenii",
        "Valea Vinului",
        "Vermes",
        "Viile Tecii",
        "Viisoara",
        "Visuia",
        "Vita",
        "Zagra",
        "Zoreni"
      ],
      "Botosani": [
        "Adaseni",
        "Agafton",
        "Alba",
        "Albesti",
        "Arborea",
        "Aurel Vlaicu",
        "Avram Iancu",
        "Avrameni",
        "Babiceni",
        "Badarai",
        "Badiuti",
        "Baiceni",
        "Baisa",
        "Bajura",
        "Balinti",
        "Balta Arsa",
        "Baluseni",
        "Balusenii Noi",
        "Baranca",
        "Barsanesti",
        "Baseu",
        "Batranesti",
        "Belcea",
        "Berza",
        "Bivolari",
        "Blandesti",
        "Bobulesti",
        "Bodeasa",
        "Bogdanesti",
        "Bohoghina",
        "Bold",
        "Borolea",
        "Borzesti",
        "Boscoteni",
        "Botosani",
        "Bozieni",
        "Braesti",
        "Brateni",
        "Brehuiesti",
        "Broscauti",
        "Brosteni",
        "Bucecea",
        "Buda",
        "Buhaceni",
        "Buimaceni",
        "Burla",
        "Burlesti",
        "Buzeni",
        "Calarasi",
        "Calinesti",
        "Calugareni",
        "Calugarenii Noi",
        "Campeni",
        "Candesti",
        "Caraiman",
        "Carasa",
        "Catamaresti",
        "Catamaresti-Deal",
        "Cerbu",
        "Cerchejeni",
        "Cernesti",
        "Cervicesti",
        "Cervicesti-Deal",
        "Chelis",
        "Chiscareni",
        "Chitoveni",
        "Cinghiniia",
        "Ciritei",
        "Cismanesti",
        "Cismea",
        "Codreni",
        "Concesti",
        "Copalau",
        "Cordareni",
        "Corjauti",
        "Corlateni",
        "Corni",
        "Costesti",
        "Costinesti",
        "Costiugeni",
        "Cosula",
        "Cosuleni",
        "Cotargaci",
        "Cotu",
        "Cotu Miculinti",
        "Cotusca",
        "Crasnaleuca",
        "Cristesti",
        "Cristinesti",
        "Cucorani",
        "Cucuteni",
        "Curtesti",
        "Cuza Voda",
        "Cuzlau",
        "Dacia",
        "Damideni",
        "Damileni",
        "Dangeni",
        "Darabani",
        "Davidoaia",
        "Dealu Crucii",
        "Dealu Mare",
        "Dersca",
        "Dimacheni",
        "Dimitrie Cantemir",
        "Dobarceni",
        "Dobrinauti-Hapai",
        "Doina",
        "Dolina",
        "Dorobanti",
        "Dorohoi",
        "Dracsani",
        "Dragalina",
        "Draguseni",
        "Draxini",
        "Drislea",
        "Dumbravita",
        "Dumeni",
        "Durnesti",
        "Esanca",
        "Flamanzi",
        "Flondora",
        "Floresti",
        "Frumusica",
        "Fundu Hertii",
        "Galbeni",
        "Garbeni",
        "Garbesti",
        "George Cosbuc",
        "George Enescu",
        "Ghireni",
        "Gorbanesti",
        "Gorovei",
        "Grivita",
        "Guranda",
        "Hanesti",
        "Havarna",
        "Hiliseu-Closca",
        "Hiliseu-Crisan",
        "Hiliseu-Horia",
        "Hlipiceni",
        "Horia",
        "Horlaceni",
        "Horodistea",
        "Hriscani",
        "Hudesti",
        "Hudum",
        "Hulub",
        "Hulubesti",
        "Hutani",
        "Iacobeni",
        "Ibaneasa",
        "Ibanesti",
        "Ichimeni",
        "Icuseni",
        "Iezer",
        "Iliseni",
        "Ionaseni",
        "Iorga",
        "Ipotesti",
        "Iuresti",
        "Izvoare",
        "Jijia",
        "Joldesti",
        "Lehnesti",
        "Leorda",
        "Libertatea",
        "Lismanita",
        "Lisna",
        "Livada",
        "Liveni",
        "Loturi",
        "Loturi Enescu",
        "Lozna",
        "Lunca",
        "Luparia",
        "Maghera",
        "Manastirea Doamnei",
        "Manastireni",
        "Mandresti",
        "Manoleasa",
        "Manoleasa-Prut",
        "Manolesti",
        "Mascateni",
        "Mateieni",
        "Mesteacan",
        "Mihai Eminescu",
        "Mihai Viteazu",
        "Mihail Kogalniceanu",
        "Mihaileni",
        "Mihalaseni",
        "Mileanca",
        "Miletin",
        "Miorcani",
        "Miron Costin",
        "Mitoc",
        "Mlenauti",
        "Moara Jorii",
        "Movila Rupta",
        "Movileni",
        "Murguta",
        "Nastase",
        "Negreni",
        "Negresti",
        "Nichiteni",
        "Nicolae Balcescu",
        "Nicseni",
        "Niculcea",
        "Oneaga",
        "Oraseni-Deal",
        "Oraseni-Vale",
        "Oroftiana",
        "Padureni",
        "Paltinis",
        "Panaitoaia",
        "Parau Negru",
        "Pasateni",
        "Paun",
        "Petricani",
        "Plesani",
        "Plevna",
        "Plopenii Mari",
        "Plopenii Mici",
        "Podeni",
        "Podriga",
        "Pogorasti",
        "Poiana",
        "Pomarla",
        "Popeni",
        "Popoaia",
        "Prajeni",
        "Prisacani",
        "Progresul",
        "Pustoaia",
        "Putureni",
        "Rachiti",
        "Racovat",
        "Radauti-Prut",
        "Radeni",
        "Ranghilesti",
        "Ranghilesti-Deal",
        "Rasca",
        "Rauseni",
        "Recia-Verbia",
        "Rediu",
        "Ripiceni",
        "Ripicenii Vechi",
        "Rogojesti",
        "Roma",
        "Romanesti",
        "Romanesti-Vale",
        "Rosiori",
        "Sadoveni",
        "Santa Mare",
        "Sarafinesti",
        "Sarata",
        "Sarata-Basarab",
        "Sarata-Draguseni",
        "Sarbi",
        "Sat Nou",
        "Saucenita",
        "Saveni",
        "Schit-Oraseni",
        "Scutari",
        "Selistea",
        "Sendreni",
        "Sendriceni",
        "Serpenita",
        "Siliscani",
        "Silistea",
        "Slobozia",
        "Slobozia Hanesti",
        "Slobozia Siliscani",
        "Smardan",
        "Socrujeni",
        "Soldanesti",
        "Soroceni",
        "Stanca",
        "Stancesti",
        "Stauceni",
        "Stefanesti",
        "Stefanesti-Sat",
        "Stiubieni",
        "Stolniceni",
        "Storesti",
        "Strahotin",
        "Strateni",
        "Stroiesti",
        "Suharau",
        "Sulita",
        "Supitca",
        "Talpa",
        "Tataraseni",
        "Tautesti",
        "Timus",
        "Tocileni",
        "Todireni",
        "Trusesti",
        "Tudor Vladimirescu",
        "Tudora",
        "Ungureni",
        "Unguroaia",
        "Unteni",
        "Vaculesti",
        "Valcelele",
        "Valea Grajdului",
        "Vanatori",
        "Varfu Campului",
        "Vatra",
        "Vicoleni",
        "Victoria",
        "Viforeni",
        "Viisoara",
        "Viisoara Mica",
        "Vitcani",
        "Vladeni",
        "Vladeni-Deal",
        "Vlasinesti",
        "Vorniceni",
        "Vorona",
        "Vorona Mare",
        "Vorona-Teodoru",
        "Vultureni",
        "Zahoreni",
        "Zaicesti",
        "Zlatunoaia",
        "Zoitani"
      ],
      "Braila": [
        "Agaua",
        "Albina",
        "Ariciu",
        "Baldovinesti",
        "Bandoiu",
        "Baraganul",
        "Batogu",
        "Berlesti",
        "Bertestii de Jos",
        "Bertestii de Sus",
        "Boarca",
        "Bordei Verde",
        "Bradeanca",
        "Braila",
        "Bratesu Vechi",
        "Bumbacari",
        "Caineni-Bai",
        "Caldarusa",
        "Cazasu",
        "Chichinetu",
        "Chioibasesti",
        "Chiscani",
        "Ciocile",
        "Ciresu",
        "Cistia",
        "Coltea",
        "Comaneasca",
        "Constantin Gabrielescu",
        "Constantinesti",
        "Corbeni",
        "Corbu Nou",
        "Corbu Vechi",
        "Cotu Lung",
        "Cotu Mihalea",
        "Custura",
        "Cuza Voda",
        "Dedulesti",
        "Desirati",
        "Drogu",
        "Dudescu",
        "Dudesti",
        "Esna",
        "Faurei",
        "Faurei Sat",
        "Filipesti",
        "Filiu",
        "Florica",
        "Frecatei",
        "Galbenu",
        "Gara Ianca",
        "Gavani",
        "Gemenele",
        "Gradistea",
        "Gropeni",
        "Gulianca",
        "Gura Calmatui",
        "Gura Garlutei",
        "Gurguieti",
        "Horia",
        "Ianca",
        "Ibrianu",
        "Insuratei",
        "Ionesti",
        "Jirlau",
        "Jugureanu",
        "Lacu Rezii",
        "Lacu Sarat",
        "Lanurile",
        "Latinu",
        "Liscoteanca",
        "Magureni",
        "Maraloiu",
        "Marasu",
        "Martacesti",
        "Maru Rosu",
        "Maxineni",
        "Mihai Bravu",
        "Mihail Kogalniceanu",
        "Mircea Voda",
        "Morotesti",
        "Movila Miresii",
        "Muchea",
        "Nedeicu",
        "Nicolae Balcescu",
        "Nicolesti",
        "Oancea",
        "Odaieni",
        "Olaneasca",
        "Oprisenesti",
        "Pantecani",
        "Perisoru",
        "Pietroiu",
        "Pitulati",
        "Plasoiu",
        "Plopi",
        "Plopu",
        "Polizesti",
        "Pribeagu",
        "Racovita",
        "Ramnicelu",
        "Romanu",
        "Rosiori",
        "Salcia",
        "Salcia Tudor",
        "Satuc",
        "Scarlatesti",
        "Scortaru Nou",
        "Scortaru Vechi",
        "Sihleanu",
        "Silistea",
        "Silistraru",
        "Spiru Haret",
        "Stanca",
        "Stancuta",
        "Stoienesti",
        "Surdila-Gaiseanca",
        "Surdila-Greci",
        "Sutesti",
        "Tacau",
        "Tarlele Filiu",
        "Tataru",
        "Tepes Voda",
        "Tichilesti",
        "Titcov",
        "Traian",
        "Tudor Vladimirescu",
        "Tufesti",
        "Ulmu",
        "Unirea",
        "Urleasca",
        "Vadeni",
        "Valea Calmatuiului",
        "Valea Canepii",
        "Vamesu",
        "Varsatura",
        "Victoria",
        "Visani",
        "Viziru",
        "Voinesti",
        "Vultureni",
        "Zamfiresti",
        "Zavoaia"
      ],
      "Brasov": [
        "Acris",
        "Apata",
        "Arini",
        "Augustin",
        "Barcut",
        "Beclean",
        "Beia",
        "Berivoi",
        "Bod",
        "Bogata Olteana",
        "Boholt",
        "Bran",
        "Brasov",
        "Breaza",
        "Bucium",
        "Budila",
        "Bunesti",
        "Buzaiel",
        "Calbor",
        "Carpinis",
        "Cata",
        "Cheia",
        "Cincsor",
        "Cincu",
        "Cobor",
        "Codlea",
        "Colonia 1 Mai",
        "Colonia Bod",
        "Colonia Reconstructia",
        "Comana de Jos",
        "Comana de Sus",
        "Copacel",
        "Corbi",
        "Crihalma",
        "Cristian",
        "Crit",
        "Crizbav",
        "Cuciulata",
        "Cutus",
        "Dacia",
        "Daisoara",
        "Dalghiu",
        "Dejani",
        "Dopca",
        "Dragus",
        "Drauseni",
        "Dridif",
        "Drumul Carului",
        "Dumbravita",
        "Fagaras",
        "Fantana",
        "Feldioara",
        "Felmer",
        "Fiser",
        "Fundata",
        "Fundatica",
        "Ghimbav",
        "Granari",
        "Grid",
        "Gura Vaii",
        "Halchiu",
        "Halmeag",
        "Harman",
        "Harseni",
        "Hoghiz",
        "Holbav",
        "Homorod",
        "Hurez",
        "Iasi",
        "Ileni",
        "Ionesti",
        "Jibert",
        "Jimbor",
        "Lisa",
        "Lovnic",
        "Ludisor",
        "Lunca Calnicului",
        "Lupsa",
        "Luta",
        "Magura",
        "Maierus",
        "Malinis",
        "Mandra",
        "Margineni",
        "Mateias",
        "Mercheasa",
        "Mesendorf",
        "Moieciu de Jos",
        "Moieciu de Sus",
        "Ohaba",
        "Oltet",
        "Ormenis",
        "Palos",
        "Paltin",
        "Parau",
        "Paraul Rece",
        "Persani",
        "Pestera",
        "Podu Oltului",
        "Poiana Brasov",
        "Poiana Marului",
        "Pojorta",
        "Predeal",
        "Predelut",
        "Prejmer",
        "Purcareni",
        "Racos",
        "Rasnov",
        "Rausor",
        "Recea",
        "Roades",
        "Rodbav",
        "Rotbav",
        "Rucar",
        "Rupea",
        "Sacele",
        "Sambata de Jos",
        "Sambata de Sus",
        "Sanpetru",
        "Sasciori",
        "Satu Nou",
        "Savastreni",
        "Sebes",
        "Selistat",
        "Sercaia",
        "Sercaita",
        "Simon",
        "Sinca Noua",
        "Sinca Veche",
        "Sirnea",
        "Soars",
        "Sohodol",
        "Sona",
        "Statiunea Climaterica Sambata",
        "Stupinii Prejmerului",
        "Tarlungeni",
        "Teliu",
        "Ticusu Nou",
        "Ticusu Vechi",
        "Timisu de Jos",
        "Timisu de Sus",
        "Toarcla",
        "Toderita",
        "Tohanu Nou",
        "Ucea de Jos",
        "Ucea de Sus",
        "Ungra",
        "Vad",
        "Valcea",
        "Valeni",
        "Vama Buzaului",
        "Venetia de Jos",
        "Venetia de Sus",
        "Victoria",
        "Viscri",
        "Vistea de Jos",
        "Vistea de Sus",
        "Vistisoara",
        "Vladeni",
        "Voila",
        "Voivodeni",
        "Vulcan",
        "Zarnesti",
        "Zizin"
      ],
      "Bucuresti": [
        "Sector 1",
        "Sector 2",
        "Sector 3",
        "Sector 4",
        "Sector 5",
        "Sector 6"
      ],
      "Buzau": [
        "Albesti",
        "Aldeni",
        "Alexandru Odobescu",
        "Aliceni",
        "Alunis",
        "Amara",
        "Amaru",
        "Anini",
        "Arbanasi",
        "Arcanu",
        "Babeni",
        "Baceni",
        "Badeni",
        "Badila",
        "Baesti",
        "Baile",
        "Bajani",
        "Balaceanu",
        "Balaia",
        "Balanesti",
        "Balhacu",
        "Balta Alba",
        "Balta Tocila",
        "Baltagari",
        "Baltareti",
        "Balteni",
        "Banita",
        "Barasti",
        "Barbuncesti",
        "Basca Chiojdului",
        "Basca Rozilei",
        "Bascenii de Jos",
        "Bascenii de Sus",
        "Batogu",
        "Beceni",
        "Beciu",
        "Begu",
        "Beilic",
        "Bentu",
        "Berca",
        "Bercesti",
        "Beslii",
        "Bisoca",
        "Blajani",
        "Boboc",
        "Bodinesti",
        "Boldu",
        "Bordusani",
        "Bozioru",
        "Bradeanca",
        "Bradeanu",
        "Braesti",
        "Bragareasa",
        "Bratilesti",
        "Breaza",
        "Brebu",
        "Buda",
        "Buda Craciunesti",
        "Budesti",
        "Budisteni",
        "Budrea",
        "Buduile",
        "Bustea",
        "Buzau",
        "C.a. Rosetti",
        "Caldarasti",
        "Caldarusa",
        "Caldaruseanca",
        "Calea Chiojdului",
        "Caltesti",
        "Caltuna",
        "Calvini",
        "Campeni",
        "Campulungeanca",
        "Candesti",
        "Canesti",
        "Capatanesti",
        "Capu Satului",
        "Caragele",
        "Caratnau de Jos",
        "Caratnau de Sus",
        "Carligu Mare",
        "Carligu Mic",
        "Carlomanesti",
        "Carpinistea",
        "Casoca",
        "Casota",
        "Catiasu",
        "Catina",
        "Ceairu",
        "Cernatesti",
        "Chiliile",
        "Chiojdu",
        "Chiperu",
        "Chirlesti",
        "Cilibia",
        "Ciobanoaia",
        "Ciocanesti",
        "Cioranca",
        "Ciresu",
        "Cislau",
        "Ciuta",
        "Clondiru",
        "Clondiru de Sus",
        "Coca-Antimiresti",
        "Coca-Niculesti",
        "Cocarceni",
        "Cochirleanca",
        "Coconari",
        "Cojanu",
        "Colibasi",
        "Coltaneni",
        "Colteni",
        "Colti",
        "Coltii de Jos",
        "Coltu Pietrii",
        "Comisoaia",
        "Corbu",
        "Corneanu",
        "Costesti",
        "Costieni",
        "Costomiru",
        "Cotatcu",
        "Cotorca",
        "Cotu Ciorii",
        "Cozieni",
        "Crang",
        "Crevelesti",
        "Cuculeasa",
        "Curcanesti",
        "Curmatura",
        "Dalma",
        "Dambroca",
        "Danulesti",
        "Dara",
        "Dascalesti",
        "Dealul Viei",
        "Dedulesti",
        "Deleni",
        "Dobrilesti",
        "Dogari",
        "Dulbanu",
        "Fantanele",
        "Fata lui Nan",
        "Fintesti",
        "Fisici",
        "Floresti",
        "Florica",
        "Focsanei",
        "Fotin",
        "Frasinet",
        "Fulga",
        "Fundata",
        "Fundaturile",
        "Fundeni",
        "Furtunesti",
        "Gageni",
        "Galbinasi",
        "Gara Bobocu",
        "Gara Cilibia",
        "Gavanele",
        "Gavanesti",
        "Gheraseni",
        "Ghergheasa",
        "Ghiocari",
        "Ghizdita",
        "Glodeanu Sarat",
        "Glodeanu-Silistea",
        "Glodu-Petcari",
        "Glodurile",
        "Goicelu",
        "Goidesti",
        "Golu Grabicina",
        "Gomoesti",
        "Gontesti",
        "Gorani",
        "Gornet",
        "Grabicina de Jos",
        "Grabicina de Sus",
        "Grajdana",
        "Grebanu",
        "Greceanca",
        "Gresia",
        "Grosani",
        "Gura Badicului",
        "Gura Bascei",
        "Gura Calnaului",
        "Gura Dimienii",
        "Gura Fagetului",
        "Gura Saratii",
        "Gura Siriului",
        "Gura Teghii",
        "Gura Vaii",
        "Hales",
        "Heliade Radulescu",
        "Homesti",
        "Ileana",
        "Istrita de Jos",
        "Ivanetu",
        "Izvoarele",
        "Izvoranu",
        "Izvoru",
        "Izvoru Dulce",
        "Jghiab",
        "Joseni",
        "Lacu",
        "Lacu cu Anini",
        "Lacu Sinaia",
        "Lacurile",
        "Lanurile",
        "Largu",
        "Leiculesti",
        "Lera",
        "Limpezis",
        "Lipanescu",
        "Lipia",
        "Livada",
        "Livada Mica",
        "Lopatareasa",
        "Lopatari",
        "Luciu",
        "Lunca",
        "Lunca Frumoasa",
        "Lunca Jaristei",
        "Lunca Priporului",
        "Luncile",
        "Lungesti",
        "Macrina",
        "Magura",
        "Maguricea",
        "Manasia",
        "Manastirea",
        "Manastirea Ratesti",
        "Manzalesti",
        "Manzu",
        "Maracineni",
        "Margaritesti",
        "Margariti",
        "Margineanu",
        "Maruntisu",
        "Matesti",
        "Maxenu",
        "Merei",
        "Mierea",
        "Mihailesti",
        "Mitropolia",
        "Mlajet",
        "Modreni",
        "Moisica",
        "Mosesti",
        "Movila Banului",
        "Movila Oii",
        "Movilita",
        "Mucesti-Danulesti",
        "Murgesti",
        "Muscel",
        "Muscelu Caramanesti",
        "Muscelusa",
        "Naeni",
        "Negosina",
        "Nehoiasu",
        "Nehoiu",
        "Nemertea",
        "Nenciu",
        "Nenciulesti",
        "Nicolesti",
        "Niculesti",
        "Niscov",
        "Nistoresti",
        "Nucu",
        "Odaia Banului",
        "Odaile",
        "Ograzile",
        "Ojasca",
        "Olari",
        "Olesesti",
        "Oratia",
        "Oreavul",
        "Paclele",
        "Pacurile",
        "Padina",
        "Padurenii",
        "Palici",
        "Paltineni",
        "Paltinis",
        "Panatau",
        "Pardosi",
        "Parjolesti",
        "Parscov",
        "Parscovelu",
        "Patarlagele",
        "Pestritu",
        "Petrachesti",
        "Petrisoru",
        "Piatra Alba",
        "Pietraru",
        "Pietroasa Mica",
        "Pietroasele",
        "Pietrosu",
        "Pinu",
        "Pitulicea",
        "Plaisor",
        "Plaiu Nucului",
        "Plavatu",
        "Plescioara",
        "Plescoi",
        "Plesesti",
        "Plesi",
        "Plevna",
        "Plopeasa",
        "Plopi",
        "Plostina",
        "Podgoria",
        "Podu Muncii",
        "Poenitele",
        "Pogoanele",
        "Pogonele",
        "Poiana Pletari",
        "Poiana Valcului",
        "Poienile",
        "Policiori",
        "Posobesti",
        "Posta",
        "Posta Calnau",
        "Potarnichesti",
        "Potecu",
        "Potoceni",
        "Prosca",
        "Pruneni",
        "Puiestii de Jos",
        "Puiestii de Sus",
        "Punga",
        "Racoviteni",
        "Raducesti",
        "Ramnicelu",
        "Ramnicu Sarat",
        "Rapile",
        "Ratesti",
        "Recea",
        "Robeasca",
        "Robesti",
        "Rosioru",
        "Rubla",
        "Ruginoasa",
        "Runcu",
        "Rusavat",
        "Rusetu",
        "Sageata",
        "Sahateni",
        "Salcia",
        "Salcioara",
        "Sapoca",
        "Saranga",
        "Sarata",
        "Sarata-Monteoru",
        "Sarbesti",
        "Sareni",
        "Sarile",
        "Sarile-Catun",
        "Sarulesti",
        "Sasenii Noi",
        "Sasenii pe Vale",
        "Sasenii Vechi",
        "Satu Nou",
        "Satu Vechi",
        "Satuc",
        "Scaeni",
        "Scarisoara",
        "Scarlatesti",
        "Scorosesti",
        "Scorteanca",
        "Scortoasa",
        "Scurtesti",
        "Scutelnici",
        "Secuiu",
        "Sergent Ionel Stefan",
        "Sibiciu de Jos",
        "Sibiciu de Sus",
        "Sindrila",
        "Slobozia",
        "Smardan",
        "Smeeni",
        "Smeesti",
        "Soresti",
        "Spataru",
        "Spidele",
        "Stalpu",
        "Stancesti",
        "Stanila",
        "Stavarasti",
        "Stiubei",
        "Strezeni",
        "Stroesti",
        "Suchea",
        "Suditi",
        "Tabacari",
        "Tabarasti",
        "Tarcov",
        "Tarlele",
        "Tatarligu",
        "Tatulesti",
        "Tega",
        "Teisu",
        "Terca",
        "Tintesti",
        "Tisau",
        "Tocileni",
        "Topliceni",
        "Toropalesti",
        "Trestia",
        "Trestieni",
        "Trestioara",
        "Tronari",
        "Tulburea",
        "Udati-Lucieni",
        "Udati-Manzu",
        "Ulmeni",
        "Ulmet",
        "Unguriu",
        "Ursoaia",
        "Vacareasca",
        "Vadu Oii",
        "Vadu Pasii",
        "Vadu Soresti",
        "Valcele",
        "Valcelele",
        "Valea Banului",
        "Valea Catinei",
        "Valea Cotoarei",
        "Valea Fantanei",
        "Valea Larga",
        "Valea Larga-Sarulesti",
        "Valea lui Lalu",
        "Valea Lupului",
        "Valea Nucului",
        "Valea Parului",
        "Valea Purcarului",
        "Valea Putului Merei",
        "Valea Ramnicului",
        "Valea Ratei",
        "Valea Roatei",
        "Valea Salciei",
        "Valea Salciei-Catun",
        "Valea Salciilor",
        "Valea Schiopului",
        "Valea Sibiciului",
        "Valea Stanei",
        "Valea Stefanului",
        "Valea Ursului",
        "Valea Verzei",
        "Valea Viei",
        "Valeanca-Vilanesti",
        "Varf",
        "Varlaam",
        "Varteju",
        "Vavalucile",
        "Vernesti",
        "Viforata",
        "Vinetisu",
        "Vintila Voda",
        "Vintileanca",
        "Viperesti",
        "Vispesti",
        "Vizireni",
        "Vladeni",
        "Zaharesti",
        "Zaplazi",
        "Zapodia",
        "Zarnesti",
        "Zarnestii de Slanic",
        "Zeletin",
        "Ziduri",
        "Zilisteanca",
        "Zoita",
        "Zoresti"
      ],
      "Calarasi": [
        "Alexandru I. Cuza",
        "Alexandru Odobescu",
        "Aprozi",
        "Artari",
        "Belciugatele",
        "Bogata",
        "Bogdana",
        "Borcea",
        "Bosneagu",
        "Buciumeni",
        "Budesti",
        "Buzoeni",
        "Calarasi",
        "Calarasii Vechi",
        "Calareti",
        "Candeasca",
        "Cascioarele",
        "Ceacu",
        "Cetatea Veche",
        "Chirnogi",
        "Chiselet",
        "Ciocanesti",
        "Clatesti",
        "Coconi",
        "Codreni",
        "Cojesti",
        "Constantin Brancoveanu",
        "Coslogeni",
        "Cotofanca",
        "Crivat",
        "Cucuieti",
        "Cunesti",
        "Curatesti",
        "Curcani",
        "Cuza Voda",
        "Dalga",
        "Dalga-Gara",
        "Danesti",
        "Darvari",
        "Dichiseni",
        "Dor Marunt",
        "Dorobantu",
        "Dragalina",
        "Dragos Voda",
        "Drajna Noua",
        "Fantana Doamnei",
        "Faurei",
        "Florica",
        "Floroaica",
        "Frasinet",
        "Frasinetu de Jos",
        "Frumusani",
        "Fundeni",
        "Fundulea",
        "Galatui",
        "Galbinasi",
        "Galdau",
        "Gostilele",
        "Gradistea",
        "Gruiu",
        "Gurbanesti",
        "Iezeru",
        "Ileana",
        "Independenta",
        "Infratirea",
        "Jegalia",
        "Lehliu",
        "Lehliu-Gara",
        "Libertatea",
        "Luica",
        "Lunca",
        "Lupsanu",
        "Luptatori",
        "Magureni",
        "Manastirea",
        "Marculesti-Gara",
        "Mariuta",
        "Mataraua",
        "Mihai Viteazu",
        "Mitreni",
        "Modelu",
        "Nana",
        "Negoesti",
        "Nicolae Balcescu",
        "Nucetu",
        "Nuci",
        "Ogoru",
        "Oltenita",
        "Oltina",
        "Orasti",
        "Ostrovu",
        "Padurisu",
        "Paicu",
        "Pasarea",
        "Pelinu",
        "Perisoru",
        "Pitigaia",
        "Plataresti",
        "Plevna",
        "Plumbuita",
        "Podari",
        "Podu Pitarului",
        "Polcesti",
        "Popesti",
        "Postavari",
        "Potcoava",
        "Preasna",
        "Preasna Veche",
        "Progresu",
        "Radovanu",
        "Radu Negru",
        "Radu Voda",
        "Rasa",
        "Rasurile",
        "Razoarele",
        "Razvani",
        "Roseti",
        "Sacele",
        "Salcioara",
        "Sandulita",
        "Sapunari",
        "Sarulesti",
        "Sarulesti-Gara",
        "Satnoeni",
        "Satu Nou",
        "Satucu",
        "Seinoiu",
        "Silistea",
        "Socoalele",
        "Sohatu",
        "Solacolu",
        "Soldanu",
        "Spantov",
        "Stancea",
        "Stefan cel Mare",
        "Stefan Voda",
        "Stefanesti",
        "Stoenesti",
        "Sultana",
        "Tamadau Mare",
        "Tamadau Mic",
        "Tariceni",
        "Tonea",
        "Tudor Vladimirescu",
        "Ulmeni",
        "Ulmu",
        "Unirea",
        "Valcelele",
        "Valea Argovei",
        "Valea Popii",
        "Valea Presnei",
        "Valea Rosie",
        "Valea Rusului",
        "Valea Seaca",
        "Valea Stanii",
        "Varasti",
        "Vasilati",
        "Visinii",
        "Vlad Tepes",
        "Vladiceasca",
        "Vlaiculesti",
        "Zimbru"
      ],
      "Caras-Severin": [
        "23 August",
        "Agadici",
        "Anina",
        "Apadia",
        "Armenis",
        "Arsuri",
        "Baile Herculane",
        "Bania",
        "Barbosu",
        "Barz",
        "Barza",
        "Bautar",
        "Bazias",
        "Belobresca",
        "Berliste",
        "Berzasca",
        "Berzovia",
        "Bigar",
        "Binis",
        "Bocsa",
        "Bogaltin",
        "Bogodint",
        "Boina",
        "Boinita",
        "Bojia",
        "Bolvasnita",
        "Borlova",
        "Borlovenii Noi",
        "Borlovenii Vechi",
        "Borugi",
        "Bozovici",
        "Bradisoru de Jos",
        "Bratova",
        "Brebu",
        "Brebu Nou",
        "Brestelnic",
        "Brezon",
        "Brosteni",
        "Buchin",
        "Bucosnita",
        "Bucova",
        "Calina",
        "Calnic",
        "Camena",
        "Camenita",
        "Campia",
        "Canicea",
        "Caransebes",
        "Carasova",
        "Carbunari",
        "Carnecea",
        "Carsa Rosie",
        "Carsie",
        "Cavaran",
        "Cicleni",
        "Ciclova Montana",
        "Ciclova Romana",
        "Ciortea",
        "Ciresa",
        "Ciresel",
        "Ciuchici",
        "Ciudanovita",
        "Ciuta",
        "Clocotici",
        "Comoraste",
        "Copacele",
        "Cornea",
        "Cornereva",
        "Cornisoru",
        "Cornutel",
        "Coronini",
        "Costis",
        "Cozia",
        "Cozla",
        "Cracu Almaj",
        "Cracu Mare",
        "Cracu Teiului",
        "Crusovat",
        "Crusovita",
        "Cuptoare",
        "Curmatura",
        "Dalboset",
        "Dalci",
        "Delinesti",
        "Dezesti",
        "Divici",
        "Dobraia",
        "Doclin",
        "Dognecea",
        "Dolina",
        "Doman",
        "Domasnea",
        "Drencova",
        "Dristie",
        "Duleu",
        "Eftimie Murgu",
        "Ersig",
        "Ezeris",
        "Farliug",
        "Fenes",
        "Fizes",
        "Forotic",
        "Frasinis",
        "Garana",
        "Garbovat",
        "Garliste",
        "Garnic",
        "Ghertenis",
        "Giurgiova",
        "Glimboca",
        "Globu Craiovei",
        "Globurau",
        "Golet",
        "Gornea",
        "Goruia",
        "Gradinari",
        "Greoni",
        "Gruni",
        "Hora Mare",
        "Hora Mica",
        "Iabalcea",
        "Iablanita",
        "Iam",
        "Iaz",
        "Iertof",
        "Ilidia",
        "Ilova",
        "Inelet",
        "Izgar",
        "Izvor",
        "Jitin",
        "Jupa",
        "Lapusnicel",
        "Lapusnicu Mare",
        "Lescovita",
        "Liborajdea",
        "Lindenfeld",
        "Liubcova",
        "Lucacevat",
        "Lunca Florii",
        "Lunca Zaicii",
        "Luncavita",
        "Lupac",
        "Macesti",
        "Maciova",
        "Macoviste",
        "Magura",
        "Mal",
        "Marga",
        "Marila",
        "Martinovat",
        "Maru",
        "Matnicu Mare",
        "Maureni",
        "Mehadia",
        "Mehadica",
        "Mercina",
        "Mesteacan",
        "Milcoveni",
        "Moceris",
        "Moldova Noua",
        "Moldova Veche",
        "Moldovita",
        "Moniom",
        "Naidas",
        "Negiudin",
        "Nermed",
        "Nicolint",
        "Obita",
        "Obreja",
        "Ocna de Fier",
        "Ogasu Podului",
        "Ohaba-Matnic",
        "Ohabita",
        "Oravita",
        "Otelu Rosu",
        "Padina Matei",
        "Paltinis",
        "Parneaura",
        "Parvova",
        "Patas",
        "Pecinisca",
        "Pestere",
        "Petnic",
        "Petrilova",
        "Petrosnita",
        "Plopu",
        "Plugova",
        "Pogara",
        "Pogara de Sus",
        "Poiana",
        "Poiana Lunga",
        "Poiana Marului",
        "Poienile Boinei",
        "Pojejena",
        "Poneasca",
        "Potoc",
        "Preveciori",
        "Prigor",
        "Prilipet",
        "Prisaca",
        "Prisacina",
        "Prisian",
        "Prislop",
        "Putna",
        "Racasdia",
        "Rachita",
        "Rachitova",
        "Radimna",
        "Rafnic",
        "Ramna",
        "Ravensca",
        "Remetea-Poganici",
        "Resita",
        "Resita Mica",
        "Rugi",
        "Ruginosu",
        "Rusca",
        "Rusca Montana",
        "Ruschita",
        "Rusova Noua",
        "Rusova Veche",
        "Rustin",
        "Sacu",
        "Sadova Noua",
        "Sadova Veche",
        "Salbagelu Nou",
        "Sasca Montana",
        "Sasca Romana",
        "Sat Batran",
        "Scaius",
        "Scarisoara",
        "Secaseni",
        "Secu",
        "Sfanta Elena",
        "Sichevita",
        "Slatina-Nera",
        "Slatina-Timis",
        "Soceni",
        "Socol",
        "Socolari",
        "Sopotu Nou",
        "Sopotu Vechi",
        "Sosdea",
        "Stancilova",
        "Steierdorf",
        "Stinapari",
        "Streneac",
        "Strugasca",
        "Studena",
        "Sub Crang",
        "Sub Margine",
        "Sub Plai",
        "Sumita",
        "Surducu Mare",
        "Susca",
        "Tarnova",
        "Tatu",
        "Teregova",
        "Terova",
        "Ticvaniu Mare",
        "Ticvaniu Mic",
        "Tincova",
        "Tirol",
        "Topla",
        "Toplet",
        "Turnu Ruieni",
        "Urcu",
        "Valea Bistrei",
        "Valea Bolvasnita",
        "Valea Mare",
        "Valea Minisului",
        "Valea Orevita",
        "Valea Rachitei",
        "Valea Ravensca",
        "Valea Rosie",
        "Valea Sichevitei",
        "Valea Timisului",
        "Valeadeni",
        "Valeapai",
        "Valisoara",
        "Valiug",
        "Vama Marga",
        "Var",
        "Varadia",
        "Varciorova",
        "Verendin",
        "Vermes",
        "Vodnic",
        "Voislova",
        "Vrani",
        "Vraniut",
        "Zagujeni",
        "Zanogi",
        "Zanou",
        "Zasloane",
        "Zavoi",
        "Zbegu",
        "Zervesti",
        "Zlagna",
        "Zlatita",
        "Zmogotin",
        "Zoina",
        "Zorile",
        "Zorlencior",
        "Zorlentu Mare"
      ],
      "Cluj": [
        "Agarbiciu",
        "Aghiresu",
        "Aghiresu-Fabrici",
        "Agris",
        "Aiton",
        "Alunis",
        "Alunisu",
        "Andici",
        "Antas",
        "Apahida",
        "Ardeova",
        "Arghisu",
        "Aruncuta",
        "Aschileu Mare",
        "Aschileu Mic",
        "Babdiu",
        "Babutiu",
        "Baciu",
        "Badeni",
        "Badesti",
        "Bagaciu",
        "Bagara",
        "Baisoara",
        "Baita",
        "Balcesti",
        "Barai",
        "Barlea",
        "Batin",
        "Bedeciu",
        "Belis",
        "Berchiesu",
        "Berindu",
        "Bica",
        "Bicalatu",
        "Blidaresti",
        "Bobalna",
        "Bociu",
        "Bodrog",
        "Bogata",
        "Bogata de Jos",
        "Bogata de Sus",
        "Boian",
        "Boj-Catun",
        "Boju",
        "Boldut",
        "Bologa",
        "Bont",
        "Bontida",
        "Borsa",
        "Borsa-Catun",
        "Borsa-Crestaia",
        "Borzesti",
        "Boteni",
        "Braisoru",
        "Bucea",
        "Bunesti",
        "Buru",
        "Buteni",
        "Buza",
        "Cacova Ierii",
        "Caianu",
        "Caianu Mic",
        "Caianu-Vama",
        "Calarasi",
        "Calarasi-Gara",
        "Calata",
        "Calatele",
        "Calna",
        "Camarasu",
        "Campenesti",
        "Campia Turzii",
        "Caprioara",
        "Capusu Mare",
        "Capusu Mic",
        "Cara",
        "Caseiu",
        "Casele Micesti",
        "Catalina",
        "Catcau",
        "Catina",
        "Ceaba",
        "Ceanu Mare",
        "Ceanu Mic",
        "Cerbesti",
        "Cerc",
        "Cetan",
        "Cheia",
        "Chesau",
        "Chidea",
        "Chinteni",
        "Chiris",
        "Chiuiesti",
        "Ciubanca",
        "Ciubancuta",
        "Ciucea",
        "Ciuleni",
        "Ciumafaia",
        "Ciurgau",
        "Ciurila",
        "Clapa",
        "Cluj-Napoca",
        "Coasta",
        "Codor",
        "Cojocna",
        "Colonia",
        "Comorata",
        "Comsesti",
        "Copaceni",
        "Coplean",
        "Copru",
        "Corneni",
        "Cornesti",
        "Corpadea",
        "Corusu",
        "Craesti",
        "Crairat",
        "Cremenea",
        "Criseni",
        "Cristorel",
        "Cublesu Somesan",
        "Curtuiusu Dejului",
        "Custura",
        "Cutca",
        "Cuzdrioara",
        "Dabaca",
        "Dambu Mare",
        "Damburile",
        "Dancu",
        "Dangau Mare",
        "Dangau Mic",
        "Darja",
        "Darot",
        "Dealu Botii",
        "Dealu Mare",
        "Dealu Negru",
        "Dej",
        "Deleni",
        "Deusu",
        "Dezmir",
        "Diviciorii Mari",
        "Diviciorii Mici",
        "Domosu",
        "Dorna",
        "Doroltu",
        "Dosu Bricii",
        "Dosu Napului",
        "Dretea",
        "Dumbrava",
        "Elciu",
        "Escu",
        "Fagetu Ierii",
        "Falca",
        "Fanate",
        "Faureni",
        "Feiurdeni",
        "Feldioara",
        "Feleacu",
        "Filea de Jos",
        "Filea de Sus",
        "Finciu",
        "Finisel",
        "Fizesu Gherlii",
        "Floresti",
        "Fodora",
        "Frasinet",
        "Frata",
        "Fundatura",
        "Gadalin",
        "Garbau",
        "Garbau Dejului",
        "Geaca",
        "Gheorghieni",
        "Gherla",
        "Ghirisu Roman",
        "Ghirolt",
        "Gilau",
        "Giula",
        "Giurcuta de Jos",
        "Giurcuta de Sus",
        "Gligoresti",
        "Guga",
        "Hagau",
        "Hasdate",
        "Hodai Boian",
        "Hodaie",
        "Hodisu",
        "Horlacea",
        "Huci",
        "Huedin",
        "Huta",
        "Iacobeni",
        "Iara",
        "Iclod",
        "Iclozel",
        "Igritia",
        "Inucu",
        "Iuriu de Campie",
        "Izvoru Crisului",
        "Jichisu de Jos",
        "Jichisu de Sus",
        "Juc-Herghelie",
        "Jucu de Mijloc",
        "Jucu de Sus",
        "Jurca",
        "Lacu",
        "Lapustesti",
        "Leghia",
        "Legii",
        "Leurda",
        "Lita",
        "Liteni",
        "Livada",
        "Lobodas",
        "Lujerdiu",
        "Luna",
        "Luna de Jos",
        "Luna de Sus",
        "Lunca Bontului",
        "Lunca Visagului",
        "Luncani",
        "Lungesti",
        "Macau",
        "Macicasu",
        "Magoaja",
        "Magura Ierii",
        "Maguri",
        "Maguri-Racatau",
        "Mahal",
        "Maia",
        "Manastirea",
        "Manastireni",
        "Manasturel",
        "Manasturu Romanesc",
        "Marcesti",
        "Margau",
        "Marisel",
        "Martinesti",
        "Masca",
        "Mera",
        "Mica",
        "Micesti",
        "Mihai Viteazu",
        "Mihaiesti",
        "Mintiu Gherlii",
        "Moara de Padure",
        "Mociu",
        "Moldovenesti",
        "Morau",
        "Moristi",
        "Morlaca",
        "Mortesti",
        "Muncel",
        "Muntele Baisorii",
        "Muntele Bocului",
        "Muntele Cacovei",
        "Muntele Filii",
        "Muntele Rece",
        "Muntele Sacelului",
        "Muresenii de Campie",
        "Nadaselu",
        "Nadasu",
        "Naoiu",
        "Nasal",
        "Nearsova",
        "Negreni",
        "Nicula",
        "Nima",
        "Nires",
        "Oas",
        "Ocna Dejului",
        "Ocolisel",
        "Olariu",
        "Orman",
        "Osoi",
        "Osorhel",
        "Padurea Iacobeni",
        "Padureni",
        "Padurenii",
        "Paglisa",
        "Palatca",
        "Paniceni",
        "Panticeu",
        "Pata",
        "Pestera",
        "Petea",
        "Petresti",
        "Petrestii de Jos",
        "Petrestii de Mijloc",
        "Petrestii de Sus",
        "Pietroasa",
        "Pintic",
        "Plaiesti",
        "Plaiuri",
        "Plopi",
        "Ploscos",
        "Podeni",
        "Poiana Fratii",
        "Poiana Horea",
        "Poieni",
        "Popesti",
        "Prelucele",
        "Pruneni",
        "Pruni",
        "Prunis",
        "Puini",
        "Pustuta",
        "Rachitele",
        "Radaia",
        "Rascruci",
        "Razbuneni",
        "Razoare",
        "Recea-Cristur",
        "Rediu",
        "Risca",
        "Rogojel",
        "Rosieni",
        "Rotunda",
        "Rugasesti",
        "Sacalaia",
        "Sacel",
        "Sacuieu",
        "Salatiu",
        "Salatruc",
        "Salicea",
        "Salisca",
        "Saliste",
        "Salistea Noua",
        "Salistea Veche",
        "Samboieni",
        "Samboleni",
        "Sancraiu",
        "Sandulesti",
        "Sanmarghita",
        "Sanmartin",
        "Sannicoara",
        "Sanpaul",
        "Santejude",
        "Santejude Vale",
        "Santioana",
        "Saradis",
        "Sarata",
        "Sardu",
        "Satu Lung",
        "Saula",
        "Sava",
        "Savadisla",
        "Scrind-Frasinet",
        "Sic",
        "Sicfa",
        "Sigau",
        "Silivas",
        "Smida",
        "Soimeni",
        "Somcutu Mic",
        "Somesu Cald",
        "Somesu Rece",
        "Soporu de Campie",
        "Starcu",
        "Stejeris",
        "Stoiana",
        "Stolna",
        "Straja",
        "Strambu",
        "Strucut",
        "Suaras",
        "Suatu",
        "Sub Coasta",
        "Suceagu",
        "Sucutard",
        "Sumurducu",
        "Surduc",
        "Sutu",
        "Taga",
        "Targusor",
        "Tarpiu",
        "Tauseni",
        "Tauti",
        "Ticu",
        "Ticu-Colonie",
        "Tiocu de Jos",
        "Tiocu de Sus",
        "Tioltiur",
        "Topa Mica",
        "Tranisu",
        "Tritenii de Jos",
        "Tritenii de Sus",
        "Tritenii-Hotar",
        "Turda",
        "Turea",
        "Tureni",
        "Turmasi",
        "Unguras",
        "Urca",
        "Urisor",
        "Vad",
        "Vaida-Camaras",
        "Valcele",
        "Valcelele",
        "Vale",
        "Valea Agrisului",
        "Valea Calda",
        "Valea Caseielului",
        "Valea Ciresoii",
        "Valea Draganului",
        "Valea Florilor",
        "Valea Garboului",
        "Valea Grosilor",
        "Valea Ierii",
        "Valea lui Cati",
        "Valea lui Opris",
        "Valea Luncii",
        "Valea Ungurasului",
        "Valea Vadului",
        "Valeni",
        "Valisoara",
        "Vanatori",
        "Vechea",
        "Viisoara",
        "Visagu",
        "Visea",
        "Vistea",
        "Vlaha",
        "Vultureni",
        "Zorenii de Vale"
      ],
      "Constanta": [
        "2 Mai",
        "23 August",
        "Abrud",
        "Adamclisi",
        "Agigea",
        "Albesti",
        "Aliman",
        "Almalau",
        "Amzacea",
        "Arsa",
        "Baltagesti",
        "Baneasa",
        "Baraganu",
        "Biruinta",
        "Brebeni",
        "Bugeac",
        "Calugareni",
        "Canlia",
        "Cap Aurora",
        "Capidava",
        "Carvan",
        "Cascioarele",
        "Casian",
        "Casicea",
        "Castelu",
        "Cerchezu",
        "Cernavoda",
        "Cetatea",
        "Cheia",
        "Chirnogeni",
        "Ciobanita",
        "Ciobanu",
        "Ciocarlia",
        "Ciocarlia de Sus",
        "Closca",
        "Cobadin",
        "Cochirleni",
        "Cogealac",
        "Comana",
        "Conacu",
        "Constanta",
        "Corbu",
        "Coroana",
        "Coslugea",
        "Costinesti",
        "Cotu Vaii",
        "Crangu",
        "Credinta",
        "Crisan",
        "Crucea",
        "Cuiugiuc",
        "Cumpana",
        "Curcani",
        "Cuza Voda",
        "Darabani",
        "Deleni",
        "Dobromir",
        "Dobromiru din Deal",
        "Dorobantu",
        "Dropia",
        "Dulcesti",
        "Dulgheru",
        "Dumbraveni",
        "Dunarea",
        "Dunareni",
        "Eforie Nord",
        "Eforie Sud",
        "Esechioi",
        "Faclia",
        "Fantana Mare",
        "Fantanele",
        "Faurei",
        "Floriile",
        "Furnica",
        "Galbiori",
        "Galita",
        "Garliciu",
        "Garlita",
        "General Scarisoreanu",
        "Gherghina",
        "Ghindaresti",
        "Goruni",
        "Gradina",
        "Graniceru",
        "Gura Dobrogei",
        "Hagieni",
        "Harsova",
        "Hateg",
        "Horia",
        "Independenta",
        "Ion Corvin",
        "Istria",
        "Ivrinezu Mare",
        "Ivrinezu Mic",
        "Izvoarele",
        "Izvoru Mare",
        "Jupiter",
        "Lanurile",
        "Lazu",
        "Lespezi",
        "Limanu",
        "Lipnita",
        "Lumina",
        "Luminita",
        "Magura",
        "Mamaia",
        "Mamaia-Sat",
        "Mangalia",
        "Medgidia",
        "Mereni",
        "Mihai Viteazu",
        "Mihail Kogalniceanu",
        "Miorita",
        "Mircea Voda",
        "Mireasa",
        "Miristea",
        "Mosneni",
        "Movila Verde",
        "Movilita",
        "Murfatlar",
        "Navodari",
        "Nazarcea",
        "Negresti",
        "Negru Voda",
        "Negureni",
        "Neptun",
        "Nicolae Balcescu",
        "Nisipari",
        "Nistoresti",
        "Nuntasi",
        "Oituz",
        "Olimp",
        "Olteni",
        "Oltina",
        "Osmancea",
        "Ostrov",
        "Ovidiu",
        "Padureni",
        "Palazu Mare",
        "Palazu Mic",
        "Pantelimon",
        "Pantelimon de Jos",
        "Pecineaga",
        "Pelinu",
        "Pestera",
        "Petrosani",
        "Piatra",
        "Pietreni",
        "Plopeni",
        "Poarta Alba",
        "Poiana",
        "Potarnichea",
        "Ramnicu de Jos",
        "Ramnicu de Sus",
        "Raristea",
        "Rasova",
        "Razoarele",
        "Remus Opreanu",
        "Runcu",
        "Sacele",
        "Saligny",
        "Sanatoriul Agigea",
        "Saraiu",
        "Satu Nou",
        "Saturn",
        "Schitu",
        "Seimeni",
        "Seimenii Mici",
        "Sibioara",
        "Silistea",
        "Siminoc",
        "Sinoie",
        "Sipotele",
        "Siriu",
        "Statiunea Zoologica Marina Agigea",
        "Stefan cel Mare",
        "Stejaru",
        "Straja",
        "Strunga",
        "Stupina",
        "Targusor",
        "Tariverde",
        "Tataru",
        "Techirghiol",
        "Tepes Voda",
        "Tibrinu",
        "Tichilesti",
        "Topalu",
        "Topraisar",
        "Tortoman",
        "Traian",
        "Tudor Vladimirescu",
        "Tufani",
        "Tuzla",
        "Urluia",
        "Vadu",
        "Vadu Oii",
        "Valcelele",
        "Valea Dacilor",
        "Valeni",
        "Valu lui Traian",
        "Vama Veche",
        "Vanatori",
        "Vartop",
        "Venus",
        "Veteranu",
        "Viile",
        "Viisoara",
        "Viroaga",
        "Vlahii",
        "Vulturu",
        "Zorile"
      ],
      "Covasna": [
        "Aita Mare",
        "Aita Medie",
        "Aita Seaca",
        "Albis",
        "Alungeni",
        "Anghelus",
        "Aninoasa",
        "Araci",
        "Arcus",
        "Ariusd",
        "Bacel",
        "Baraolt",
        "Barcani",
        "Batanii Mari",
        "Batanii Mici",
        "Belani",
        "Belin",
        "Belin-Vale",
        "Biborteni",
        "Bicfalau",
        "Bita",
        "Bixad",
        "Bodoc",
        "Bodos",
        "Borosneu Mare",
        "Borosneu Mic",
        "Bradet",
        "Bradut",
        "Brates",
        "Bretcu",
        "Calnic",
        "Capeni",
        "Carpinenii",
        "Casinu Mic",
        "Catalina",
        "Cernat",
        "Chichis",
        "Chilieni",
        "Chiurus",
        "Comandau",
        "Coseni",
        "Covasna",
        "Crasna",
        "Dalnic",
        "Dobarlau",
        "Dobolii de Jos",
        "Dobolii de Sus",
        "Doboseni",
        "Estelnic",
        "Filia",
        "Floroaia",
        "Fotos",
        "Ghelinta",
        "Ghidfalau",
        "Haghig",
        "Harale",
        "Hatuica",
        "Herculian",
        "Hetea",
        "Hilib",
        "Iaras",
        "Icafalau",
        "Ilieni",
        "Imeni",
        "Intorsura Buzaului",
        "Ladauti",
        "Lemnia",
        "Let",
        "Lisnau",
        "Lisnau-Vale",
        "Lunca Marcusului",
        "Lunca Ozunului",
        "Lunga",
        "Lutoasa",
        "Magherus",
        "Malnas",
        "Malnas-Bai",
        "Marcus",
        "Marcusa",
        "Martanus",
        "Martineni",
        "Mereni",
        "Merisor",
        "Micfalau",
        "Miclosoara",
        "Moacsa",
        "Oituz",
        "Ojdula",
        "Olteni",
        "Ozun",
        "Ozunca-Bai",
        "Pachia",
        "Padureni",
        "Papauti",
        "Peteni",
        "Petriceni",
        "Poian",
        "Racosul de Sus",
        "Reci",
        "Saciova",
        "Sancraiu",
        "Santionlunca",
        "Sanzieni",
        "Saramas",
        "Scradoasa",
        "Sfantu  Gheorghe",
        "Sita Buzaului",
        "Surcea",
        "Talisoara",
        "Tamasfalau",
        "Targu Secuiesc",
        "Telechia",
        "Tufalau",
        "Turia",
        "Valcele",
        "Valea Crisului",
        "Valea Dobarlaului",
        "Valea Mare",
        "Valea Mica",
        "Valea Scurta",
        "Valea Seaca",
        "Valea Zalanului",
        "Varghis",
        "Zabala",
        "Zabratau",
        "Zagon",
        "Zalan",
        "Zoltan"
      ],
      "Dambovita": [
        "Adanca",
        "Alunis",
        "Alunisu",
        "Aninoasa",
        "Aninosani",
        "Bacesti",
        "Badeni",
        "Badulesti",
        "Balanesti",
        "Baldana",
        "Baleni-Romani",
        "Baleni-Sarbi",
        "Balteni",
        "Banesti",
        "Baraceni",
        "Barbuceanu",
        "Barbuletu",
        "Bechinesti",
        "Bela",
        "Berevoesti",
        "Bezdead",
        "Bilciuresti",
        "Blidari",
        "Boboci",
        "Bolovani",
        "Boteni",
        "Bradatel",
        "Brancoveanu",
        "Branesti",
        "Branistea",
        "Bratestii de Jos",
        "Brebu",
        "Brezoaele",
        "Brezoaia",
        "Brosteni",
        "Buciumeni",
        "Bucsani",
        "Bujoreanca",
        "Bumbuia",
        "Bungetu",
        "Burduca",
        "Butimanu",
        "Butoiu de Jos",
        "Butoiu de Sus",
        "Calugareni",
        "Candesti Deal",
        "Candesti-Vale",
        "Caprioru",
        "Capsuna",
        "Capu Coastei",
        "Carlanesti",
        "Catanele",
        "Catunu",
        "Cazaci",
        "Cetatuia",
        "Chirca",
        "Ciocanari",
        "Ciocanesti",
        "Coada Izvorului",
        "Cobiuta",
        "Cocani",
        "Cojasca",
        "Cojocaru",
        "Cojoiu",
        "Colacu",
        "Colanu",
        "Colibasi",
        "Comisani",
        "Contesti",
        "Copaceni",
        "Corbii Mari",
        "Cornatelu",
        "Cornesti",
        "Corni",
        "Costesti",
        "Costestii din Deal",
        "Costestii din Vale",
        "Costisata",
        "Craciunesti",
        "Crangasi",
        "Crangurile de Jos",
        "Crangurile de Sus",
        "Cretu",
        "Cretulesti",
        "Crevedia",
        "Cricovu Dulce",
        "Cristeasca",
        "Crivatu",
        "Croitori",
        "Crovu",
        "Cucuteni",
        "Cuparu",
        "Cuza Voda",
        "Dambovicioara",
        "Darmanesti",
        "Darza",
        "Dealu Frumos",
        "Dealu Mare",
        "Decindea",
        "Decindeni",
        "Diaconesti",
        "Dimoiu",
        "Dobra",
        "Dobresti",
        "Doicesti",
        "Dospinesti",
        "Dragaesti Pamanteni",
        "Dragaesti Ungureni",
        "Dragodana",
        "Dragodanesti",
        "Dragomiresti",
        "Dumbrava",
        "Dupa Deal",
        "Fagetu",
        "Fantanele",
        "Ferestre",
        "Feteni",
        "Fieni",
        "Fierbinti",
        "Finta Mare",
        "Finta Veche",
        "Frasin Deal",
        "Frasin Vale",
        "Frasinu",
        "Fusea",
        "Gaesti",
        "Gamanesti",
        "Garleni",
        "Geangoesti",
        "Gemenea Bratulesti",
        "Gheboaia",
        "Gheboieni",
        "Ghergani",
        "Gherghesti",
        "Gherghitesti",
        "Ghimpati",
        "Ghinesti",
        "Ghirdoveni",
        "Glod",
        "Glodeni",
        "Glogoveanu",
        "Gorgota",
        "Greci",
        "Grozavesti",
        "Gulia",
        "Gura Barbuletului",
        "Gura Foii",
        "Gura Ocnitei",
        "Gura Sutii",
        "Gura Vulcanei",
        "Gusoiu",
        "Habeni",
        "Hagioaica",
        "Hanu lui Pala",
        "Helesteu",
        "Hodarasti",
        "Hulubesti",
        "I. L. Caragiale",
        "Iazu",
        "Ibrianu",
        "Iedera de Jos",
        "Iedera de Sus",
        "Ilfoveni",
        "Ionesti",
        "Izvoarele",
        "Izvoru",
        "Jugureni",
        "Laculete",
        "Laculete-Gara",
        "Lazuri",
        "Livezile",
        "Lucianca",
        "Lucieni",
        "Ludesti",
        "Lunca",
        "Lunguletu",
        "Magura",
        "Malu cu Flori",
        "Malu Mierii",
        "Malurile",
        "Manastioara",
        "Manastirea",
        "Manesti",
        "Manga",
        "Manjina",
        "Marcesti",
        "Marginenii de Sus",
        "Maruntisu",
        "Matasaru",
        "Matraca",
        "Mavrodin",
        "Meisoare",
        "Mereni",
        "Merii",
        "Merisoru",
        "Mesteacan",
        "Miclosanii Mari",
        "Miclosanii Mici",
        "Miculesti",
        "Mija",
        "Milosari",
        "Mircea Voda",
        "Mislea",
        "Miulesti",
        "Moara din Groapa",
        "Moara Noua",
        "Mogosani",
        "Mogosesti",
        "Moreni",
        "Moroeni",
        "Morteni",
        "Mosia Mica",
        "Motaieni",
        "Movila",
        "Muscel",
        "Neajlovu",
        "Nicolaesti",
        "Niculesti",
        "Nisipurile",
        "Nucet",
        "Ochiuri",
        "Ocnita",
        "Odaia Turcului",
        "Odobesti",
        "Olteni",
        "Oncesti",
        "Oreasca",
        "Padureni",
        "Patroaia Deal",
        "Patroaia Vale",
        "Persinari",
        "Petresti",
        "Piatra",
        "Picior de Munte",
        "Pietrari",
        "Pietrosita",
        "Pitaru",
        "Plopu",
        "Podu Corbencii",
        "Podu Cristinii",
        "Podu Rizii",
        "Poiana",
        "Poienita",
        "Poroinica",
        "Postarnacu",
        "Potlogeni Vale",
        "Potlogeni-Deal",
        "Potlogi",
        "Potocelu",
        "Priboiu",
        "Priseaca",
        "Produlesti",
        "Pucheni",
        "Pucioasa",
        "Pucioasa-Sat",
        "Puntea de Greci",
        "Putu cu Salcie",
        "Racari",
        "Raciu",
        "Racovita",
        "Ragu",
        "Rancaciov",
        "Rascaeti",
        "Ratesti",
        "Ratoaia",
        "Rau Alb de Jos",
        "Rau Alb de Sus",
        "Razvad",
        "Romanesti",
        "Runcu",
        "Sabiesti",
        "Sacueni",
        "Salcioara",
        "Salcuta",
        "Samurcasi",
        "Saru",
        "Sateni",
        "Satu Nou",
        "Savesti",
        "Scheiu de Jos",
        "Scheiu de Sus",
        "Schela",
        "Selaru",
        "Serbaneasa",
        "Serdanu",
        "Silistea",
        "Sipot",
        "Slobozia",
        "Slobozia Moara",
        "Sotanga",
        "Sperieteni",
        "Stanesti",
        "Statesti",
        "Stavropolia",
        "Straosti",
        "Stratonesti",
        "Stubeie Tisa",
        "Suduleni",
        "Sultanu",
        "Suseni Socetu",
        "Suta Seaca",
        "Suvita",
        "Targoviste",
        "Tartasesti",
        "Tatarani",
        "Teis",
        "Telesti",
        "Tetcoiu",
        "Titu",
        "Toculesti",
        "Tomsani",
        "Tunari",
        "Udresti",
        "Uliesti",
        "Ulmetu",
        "Ulmi",
        "Ungureni",
        "Urseiu",
        "Urziceanca",
        "Vacaresti",
        "Vadu Stanchii",
        "Valea",
        "Valea Caselor",
        "Valea Dadei",
        "Valea Larga",
        "Valea Leurzii",
        "Valea lui Dan",
        "Valea Lunga Gorgota",
        "Valea Lunga Ogrea",
        "Valea Lunga-Cricov",
        "Valea Mare",
        "Valea Morii",
        "Valea Voivozilor",
        "Valeni-Dambovita",
        "Varfureni",
        "Varfuri",
        "Viforata",
        "Viisoara",
        "Visina",
        "Visinesti",
        "Vizuresti",
        "Vladeni",
        "Vlasceni",
        "Voia",
        "Voinesti",
        "Vulcana de Sus",
        "Vulcana-Bai",
        "Vulcana-Pandele",
        "Vultureanca",
        "Zavoiu",
        "Zidurile"
      ],
      "Dolj": [
        "Adancata",
        "Afumati",
        "Albesti",
        "Almaj",
        "Almajel",
        "Amarasti",
        "Amarastii de Jos",
        "Amarastii de Sus",
        "Apele Vii",
        "Argetoaia",
        "Badosi",
        "Bailesti",
        "Balasan",
        "Balota de Jos",
        "Balota de Sus",
        "Balta",
        "Balta Verde",
        "Baranu",
        "Barboi",
        "Barca",
        "Basarabi",
        "Bascov",
        "Bazdana",
        "Bechet",
        "Beharca",
        "Belcinu",
        "Belot",
        "Benesti",
        "Berbesu",
        "Bistret",
        "Bistretu Nou",
        "Bobeanu",
        "Bodaiesti",
        "Bodaiestii de Sus",
        "Bogea",
        "Bojoiu",
        "Booveni",
        "Botosesti-Paia",
        "Boureni",
        "Brabeti",
        "Brabova",
        "Bradesti",
        "Bradestii Batrani",
        "Bralostita",
        "Brandusa",
        "Braniste",
        "Bratovoesti",
        "Breasta",
        "Bucicani",
        "Bucovat",
        "Bucovicior",
        "Bujor",
        "Bulzesti",
        "Busteni",
        "Busu",
        "Busuletu",
        "Buzduc",
        "Caciulatesti",
        "Caciulatu",
        "Calafat",
        "Calarasi",
        "Calinesti",
        "Calopar",
        "Calugarei",
        "Campeni",
        "Caraiman",
        "Caraula",
        "Carcea",
        "Carligei",
        "Carna",
        "Carpen",
        "Carstovani",
        "Caruia",
        "Castranova",
        "Castrele Traiane",
        "Catane",
        "Catanele Noi",
        "Celaru",
        "Cerat",
        "Cernat",
        "Cernatesti",
        "Cernele",
        "Cernelele de Sus",
        "Cetate",
        "Cetatuia",
        "Chiasu",
        "Ciocanele",
        "Ciocanesti",
        "Cioroiasi",
        "Cioroiu Nou",
        "Ciupercenii Noi",
        "Ciupercenii Vechi",
        "Ciutura",
        "Cleanov",
        "Comanicea",
        "Comosteni",
        "Corlate",
        "Cornetu",
        "Cornita",
        "Cornu",
        "Cosereni",
        "Cosoveni",
        "Cotofenii din Dos",
        "Cotofenii din Fata",
        "Cotu",
        "Covei",
        "Craiova",
        "Criva",
        "Crovna",
        "Curmatura",
        "Dabuleni",
        "Daneti",
        "Deleni",
        "Desa",
        "Desnatui",
        "Diosti",
        "Dobresti",
        "Dobridor",
        "Dobromira",
        "Dobrotesti",
        "Domnu Tudor",
        "Dragoaia",
        "Dragotesti",
        "Dranic",
        "Dudovicesti",
        "Dutulesti",
        "Facai",
        "Faget",
        "Fantanele",
        "Fantani",
        "Farcas",
        "Filaret",
        "Filiasi",
        "Floran",
        "Floresti",
        "Foisor",
        "Frasin",
        "Fratila",
        "Fratostita",
        "Gabru",
        "Gaia",
        "Galicea Mare",
        "Galiciuica",
        "Gangiova",
        "Garlesti",
        "Geblesti",
        "Georocel",
        "Georocu Mare",
        "Ghercesti",
        "Ghidici",
        "Ghindeni",
        "Ghizdavesti",
        "Gighera",
        "Giubega",
        "Giurgita",
        "Godeni",
        "Gogosesti",
        "Gogosita",
        "Gogosu",
        "Goicea",
        "Goiesti",
        "Golenti",
        "Golfin",
        "Golumbelu",
        "Golumbu",
        "Gradistea",
        "Grecesti",
        "Gropanele",
        "Gruita",
        "Gubaucea",
        "Gura Racului",
        "Gura Vaii",
        "Horezu Poenari",
        "Hunia",
        "Infratirea",
        "Intorsura",
        "Iordachesti",
        "Isalnita",
        "Italieni",
        "Izvoare",
        "Izvor",
        "Izvorul Rece",
        "Jieni",
        "Jiul",
        "Lacrita Mare",
        "Lacrita Mica",
        "Langa",
        "Lazu",
        "Leamna de Jos",
        "Leamna de Sus",
        "Leordoasa",
        "Lesile",
        "Leu",
        "Lipovu",
        "Lipovu de Sus",
        "Listeava",
        "Livezi",
        "Locusteni",
        "Luncsoru",
        "Macesu de Jos",
        "Macesu de Sus",
        "Maglavit",
        "Malaesti",
        "Malaica",
        "Malu Mare",
        "Malumnic",
        "Maracinele",
        "Marotinu de Jos",
        "Marotinu de Sus",
        "Marsani",
        "Marza",
        "Melinesti",
        "Meteu",
        "Mihaita",
        "Milesti",
        "Milovan",
        "Mischii",
        "Mlecanesti",
        "Mofleni",
        "Moflesti",
        "Mogosesti",
        "Moreni",
        "Mosna",
        "Mosneni",
        "Motatei",
        "Motatei Gara",
        "Motoci",
        "Muereni",
        "Muierusu",
        "Murgasi",
        "Murta",
        "Nedeia",
        "Negoi",
        "Negoiesti",
        "Nisipuri",
        "Nistoi",
        "Novac",
        "Obedin",
        "Ocolna",
        "Odoleni",
        "Ohaba",
        "Orodel",
        "Ostroveni",
        "Padea",
        "Palilula",
        "Panaghia",
        "Pereni",
        "Perisor",
        "Picaturile",
        "Pielesti",
        "Pietroaia",
        "Pioresti",
        "Piria",
        "Piscani",
        "Piscu Lung",
        "Piscu Nou",
        "Piscu Sadovei",
        "Piscu Vechi",
        "Pisculet",
        "Plenita",
        "Plesoi",
        "Plopsor",
        "Plopu Amarasti",
        "Plosca",
        "Plostina",
        "Podari",
        "Poiana Fantanii",
        "Poiana Mare",
        "Poienile",
        "Pometesti",
        "Popanzalesti",
        "Popeasa",
        "Popesti",
        "Popoveni",
        "Potmeltu",
        "Prapor",
        "Preajba",
        "Preajba de Jos",
        "Preajba de Padure",
        "Predesti",
        "Predestii Mici",
        "Prejoi",
        "Prunet",
        "Putinei",
        "Puturi",
        "Racarii de Jos",
        "Racarii de Sus",
        "Rachita de Jos",
        "Rachita de Sus",
        "Racovita",
        "Radomir",
        "Radovan",
        "Rasnicu Batran",
        "Rasnicu Oghian",
        "Rast",
        "Robanestii de Jos",
        "Robanestii de Sus",
        "Rojiste",
        "Romanesti",
        "Rosieni",
        "Rovine",
        "Rupturile",
        "Sadova",
        "Salcia",
        "Salcuta",
        "Saliste",
        "Sapata",
        "Sarata",
        "Sarbatoarea",
        "Sarsca",
        "Scaesti",
        "Schitu",
        "Seaca de Camp",
        "Seaca de Padure",
        "Secu",
        "Secui",
        "Seculesti",
        "Segarcea",
        "Seglet",
        "Sfarcea",
        "Silistea Crucii",
        "Simnicu de Jos",
        "Simnicu de Sus",
        "Sitoaia",
        "Smadovicioara de Secu",
        "Smardan",
        "Soceni",
        "Sopot",
        "Soreni",
        "Spineni",
        "Stefanel",
        "Stiubei",
        "Stoicesti",
        "Suharu",
        "Sumandra",
        "Talpas",
        "Tamburesti",
        "Tandara",
        "Tarnava",
        "Tartal",
        "Tatomiresti",
        "Teasc",
        "Teascu din Deal",
        "Teiu",
        "Tencanau",
        "Terpezita",
        "Teslui",
        "Tiu",
        "Toceni",
        "Tuglui",
        "Tunarii Noi",
        "Tunarii Vechi",
        "Ungureni",
        "Ungurenii Mici",
        "Unirea",
        "Urdinita",
        "Urechesti",
        "Urieni",
        "Ursoaia",
        "Urzica Mare",
        "Urzicuta",
        "Uscaci",
        "Valea Fantanilor",
        "Valea lui Patru",
        "Valea Lungului",
        "Valea Mare",
        "Valea Muierii de Jos",
        "Valea Stanciului",
        "Vartop",
        "Varvor",
        "Varvoru de Jos",
        "Vela",
        "Veleni",
        "Velesti",
        "Verbicioara",
        "Verbita",
        "Viisoara",
        "Viisoara Mosneni",
        "Vladimir",
        "Voita",
        "Zanoaga",
        "Zaval",
        "Zlatari",
        "Zvorsca"
      ],
      "Galati": [
        "Adam",
        "Aldesti",
        "Balabanesti",
        "Balasesti",
        "Baleni",
        "Balintesti",
        "Baltareti",
        "Baneasa",
        "Barcea",
        "Beresti",
        "Beresti-Meria",
        "Blanzi",
        "Brahasesti",
        "Branesti",
        "Branistea",
        "Bratulesti",
        "Bucesti",
        "Buciumeni",
        "Bursucani",
        "Calmatui",
        "Carapcesti",
        "Carlomanesti",
        "Cauiesti",
        "Cavadinesti",
        "Certesti",
        "Chiraftei",
        "Ciorasti",
        "Cismele",
        "Ciuresti",
        "Ciurestii Noi",
        "Coasta Lupei",
        "Comanesti",
        "Condrea",
        "Corcioveni",
        "Corni",
        "Corod",
        "Cositeni",
        "Cosmesti",
        "Cosmestii-Vale",
        "Costache Negri",
        "Costi",
        "Cotoroaia",
        "Craiesti",
        "Crangeni",
        "Cruceanu",
        "Cuca",
        "Cudalbi",
        "Cuza Voda",
        "Dobrinesti",
        "Draganesti",
        "Draguseni",
        "Fantanele",
        "Fantani",
        "Fartanesti",
        "Foltesti",
        "Frumusita",
        "Frunzeasca",
        "Fundeanu",
        "Fundeni",
        "Fundenii Noi",
        "Furcenii Noi",
        "Furcenii Vechi",
        "Galati",
        "Ganesti",
        "Gara Berheci",
        "Gara Ghidigeni",
        "Garbovat",
        "Gefu",
        "Ghidigeni",
        "Ghinghesti",
        "Gohor",
        "Grivita",
        "Grozavesti",
        "Gura Garbovatului",
        "Hantesti",
        "Hanu Conachi",
        "Hustiu",
        "Ijdileni",
        "Independenta",
        "Ionasesti",
        "Ireasca",
        "Ivesti",
        "Izvoarele",
        "Jorasti",
        "Liesti",
        "Lozova",
        "Lunca",
        "Lungesti",
        "Lungoci",
        "Lupele",
        "Maciseni",
        "Malu Alb",
        "Malureni",
        "Mandresti",
        "Mastacani",
        "Matca",
        "Mihail Kogalniceanu",
        "Moscu",
        "Movileni",
        "Munteni",
        "Namoloasa",
        "Namoloasa Sat",
        "Nartesti",
        "Negrea",
        "Negrilesti",
        "Nicopole",
        "Nicoresti",
        "Oancea",
        "Odaia Manolache",
        "Onciu",
        "Pechea",
        "Piscu",
        "Piscu Corbului",
        "Plesa",
        "Plevna",
        "Podoleni",
        "Poiana",
        "Posta",
        "Priponesti",
        "Priponestii de Jos",
        "Prodanesti",
        "Pupezeni",
        "Puricani",
        "Radesti",
        "Rediu",
        "Rogojeni",
        "Roscani",
        "Salcia",
        "Sarbi",
        "Saseni",
        "Satu Nou",
        "Scanteiesti",
        "Schela",
        "Sendreni",
        "Serbestii Vechi",
        "Silistea",
        "Sipote",
        "Sivita",
        "Slivna",
        "Slobozia Blaneasa",
        "Slobozia Conachi",
        "Slobozia Corni",
        "Slobozia Oancea",
        "Smardan",
        "Smulti",
        "Stietesti",
        "Stoicani",
        "Suceveni",
        "Suhurlui",
        "Talpigi",
        "Tamaoani",
        "Taplau",
        "Targu Bujor",
        "Tatarca",
        "Tecucelu Sec",
        "Tecuci",
        "Tepu",
        "Tepu de Sus",
        "Tiganesti",
        "Toflea",
        "Torcesti",
        "Traian",
        "Tudor Vladimirescu",
        "Tulucesti",
        "Umbraresti",
        "Umbraresti-Deal",
        "Ungureni",
        "Urlesti",
        "Vadeni",
        "Valea Marului",
        "Vames",
        "Vanatori",
        "Varlezi",
        "Vasile Alecsandri",
        "Viile",
        "Visina",
        "Vizuresti",
        "Vladesti",
        "Zarnesti",
        "Zimbru"
      ],
      "Giurgiu": [
        "Adunatii-Copaceni",
        "Anghelesti",
        "Bacu",
        "Balanu",
        "Baneasa",
        "Banesti",
        "Bila",
        "Bolintin-Deal",
        "Bolintin-Vale",
        "Branistari",
        "Branistea",
        "Bucsani",
        "Budeni",
        "Bulbucata",
        "Buturugeni",
        "Calugareni",
        "Camineasca",
        "Campurelu",
        "Carapancea",
        "Carpenisu",
        "Cartojani",
        "Cascioarele",
        "Cetatea",
        "Cetatuia",
        "Chirculesti",
        "Chiriacu",
        "Clejani",
        "Colibasi",
        "Comana",
        "Comasca",
        "Copaciu",
        "Corbeanca",
        "Cosoba",
        "Coteni",
        "Cranguri",
        "Crevedia Mare",
        "Crevedia Mica",
        "Crivina",
        "Crucea de Piatra",
        "Cucuruzu",
        "Cupele",
        "Daia",
        "Darasti-Vlasca",
        "Dealu",
        "Dimitrie Cantemir",
        "Dobreni",
        "Draganeasca",
        "Draganescu",
        "Draghiceanu",
        "Facau",
        "Falastoaca",
        "Floresti",
        "Frasinu",
        "Fratesti",
        "Gaiseanca",
        "Gaiseni",
        "Gaujani",
        "Ghimpati",
        "Ghionea",
        "Ghizdaru",
        "Giurgiu",
        "Gogosari",
        "Goleasca",
        "Gorneni",
        "Gostinari",
        "Gostinu",
        "Gradinari",
        "Gradistea",
        "Greaca",
        "Herasti",
        "Hobaia",
        "Hodivoaia",
        "Hotarele",
        "Hulubesti",
        "Ianculesti",
        "Icoana",
        "Iepuresti",
        "Isvoarele",
        "Izvoarele",
        "Izvoru",
        "Joita",
        "Letca Noua",
        "Letca Veche",
        "Malu",
        "Malu Spart",
        "Marsa",
        "Mihai Bravu",
        "Mihai Voda",
        "Mihailesti",
        "Milcovatu",
        "Milosesti",
        "Mirau",
        "Mironesti",
        "Mogosesti",
        "Mosteni",
        "Naipu",
        "Neajlov",
        "Novaci",
        "Obedeni",
        "Ogrezeni",
        "Oinacu",
        "Oncesti",
        "Padureni",
        "Palanca",
        "Petru Rares",
        "Pietrele",
        "Pietrisu",
        "Plopsoru",
        "Podisor",
        "Podu Doamnei",
        "Podu Ilfovatului",
        "Podu Popa Nae",
        "Poenari",
        "Poiana lui Stanga",
        "Popesti",
        "Posta",
        "Priboiu",
        "Prundu",
        "Puieni",
        "Putineiu",
        "Putu Greci",
        "Radu Voda",
        "Ralesti",
        "Rasuceni",
        "Remus",
        "Roata de Jos",
        "Roata Mica",
        "Sabareni",
        "Sadina",
        "Satu Nou",
        "Schitu",
        "Sfantu Gheorghe",
        "Singureni",
        "Slobozia",
        "Stalpu",
        "Stanesti",
        "Stejaru",
        "Sterea",
        "Stoenesti",
        "Suseni",
        "Tantava",
        "Teisori",
        "Teiusu",
        "Tomulesti",
        "Toporu",
        "Trestieni",
        "Uiesti",
        "Ulmi",
        "Uzunu",
        "Vadu Lat",
        "Valcele",
        "Valea Bujorului",
        "Valea Dragului",
        "Valea Plopilor",
        "Valter Maracineanu",
        "Vanatorii Mari",
        "Vanatorii Mici",
        "Varasti",
        "Varlaam",
        "Vedea",
        "Vieru",
        "Vlad Tepes",
        "Vlasin",
        "Zadariciu",
        "Zboiu",
        "Zorile"
      ],
      "Gorj": [
        "Albeni",
        "Alexeni",
        "Alimpesti",
        "Alunis",
        "Andreesti",
        "Aninisu din Deal",
        "Aninisu din Vale",
        "Aninoasa",
        "Apa Neagra",
        "Arcani",
        "Arjoci",
        "Arpadia",
        "Arseni",
        "Arsuri",
        "Artanu",
        "Bacesti",
        "Badesti",
        "Baia de Fier",
        "Balacesti",
        "Balanesti",
        "Balani",
        "Balcesti",
        "Balesti",
        "Balosani",
        "Balta",
        "Balteni",
        "Baltisoara",
        "Baniu",
        "Barbatesti",
        "Barcaciu",
        "Barsesti",
        "Barza",
        "Barzeiu",
        "Barzeiu de Gilort",
        "Bazavani",
        "Becheni",
        "Bengesti",
        "Bercesti",
        "Berlesti",
        "Bibesti",
        "Bibulesti",
        "Bircii",
        "Blahnita de Jos",
        "Blahnita de Sus",
        "Blidari",
        "Bobaia",
        "Boboiesti",
        "Bobu",
        "Boca",
        "Bohorel",
        "Boia",
        "Bojinu",
        "Bolboasa",
        "Bolbocesti",
        "Bolbosi",
        "Borascu",
        "Borosteni",
        "Botorogi",
        "Bradet",
        "Bradetel",
        "Bradiceni",
        "Branesti",
        "Bratesti",
        "Bratuia",
        "Brebenei",
        "Brosteni",
        "Brostenii de Sus",
        "Bucsana",
        "Bucureasa",
        "Budieni",
        "Buduhala",
        "Bulbuceni",
        "Bumbesti-Jiu",
        "Bumbesti-Pitic",
        "Burlani",
        "Bustuchin",
        "Busuioci",
        "Buzesti",
        "Calaparu",
        "Calcesti",
        "Calesti",
        "Calnic",
        "Calnicu de Sus",
        "Calugareasa",
        "Calugareni",
        "Campofeni",
        "Campu Mare",
        "Camuiesti",
        "Canepesti",
        "Capreni",
        "Capu Dealului",
        "Carbesti",
        "Carbunesti-Sat",
        "Carciu",
        "Carligei",
        "Carpinis",
        "Cartiu",
        "Catunele",
        "Ceauru",
        "Celei",
        "Ceplea",
        "Ceratu de Copacioasa",
        "Cerna-Sat",
        "Cernadia",
        "Cetatea",
        "Chiciora",
        "Chiliu",
        "Ciocadia",
        "Cionti",
        "Ciorari",
        "Ciuperceni",
        "Ciupercenii de Oltet",
        "Clesnesti",
        "Closani",
        "Cocoreni",
        "Cocorova",
        "Cojani",
        "Cojmanesti",
        "Colibasi",
        "Coltesti",
        "Condeiesti",
        "Copacioasa",
        "Cornesti",
        "Cornetu",
        "Corobai",
        "Corsoru",
        "Costeni",
        "Costesti",
        "Covrigi",
        "Crasna",
        "Crasna din Deal",
        "Cretesti",
        "Croici",
        "Cruset",
        "Curpen",
        "Cursaru",
        "Curteana",
        "Curtisoara",
        "Dambova",
        "Danciulesti",
        "Danesti",
        "Dealu Leului",
        "Dealu Pomilor",
        "Dealu Spirei",
        "Dealu Viei",
        "Dealu Viilor",
        "Deleni",
        "Didilesti",
        "Dobrana",
        "Dobrita",
        "Dolcesti",
        "Doseni",
        "Dragoeni",
        "Dragoiesti",
        "Dragotesti",
        "Dragutesti",
        "Duculesti",
        "Dumbraveni",
        "Fantanele",
        "Farcasesti",
        "Farcasesti Mosneni",
        "Floresteni",
        "Floresti",
        "Francesti",
        "Frasin",
        "Fratesti",
        "Frumusei",
        "Frunza",
        "Galcesti",
        "Galesoaia",
        "Gamani",
        "Garbovu",
        "Gavanesti",
        "Gilortu",
        "Glodeni",
        "Glogova",
        "Godinesti",
        "Gornacel",
        "Gornovita",
        "Groserea",
        "Grui",
        "Gura Menti",
        "Gura Susitei",
        "Gureni",
        "Haiesti",
        "Halangesti",
        "Hirisesti",
        "Hobita",
        "Hodoreasca",
        "Horasti",
        "Horezu",
        "Hotaroasa",
        "Hurezani",
        "Iasi-Gorj",
        "Iezureni",
        "Igirosu",
        "Iliesti",
        "Insuratei",
        "Ionesti",
        "Iormanesti",
        "Isvarna",
        "Izvoarele",
        "Jeristea",
        "Jiltu",
        "Jupanesti",
        "Larga",
        "Lazaresti",
        "Lazuri",
        "Lelesti",
        "Leurda",
        "Licurici",
        "Lihulesti",
        "Lintea",
        "Logresti Mosteni",
        "Lupoaia",
        "Lupoita",
        "Macesu",
        "Magheresti",
        "Maiag",
        "Marinesti",
        "Maru",
        "Matasari",
        "Mazaroi",
        "Mentii din Dos",
        "Merfulesti",
        "Miclosu",
        "Miculesti",
        "Mielusei",
        "Mierea",
        "Miericeaua",
        "Miluta",
        "Mirosloveni",
        "Mogosani",
        "Moi",
        "Motorgi",
        "Motru",
        "Motru Sec",
        "Murgesti",
        "Murgilesti",
        "Musculesti",
        "Musetesti",
        "Namete",
        "Negoiesti",
        "Negomir",
        "Negreni",
        "Nistoresti",
        "Novaci",
        "Nucetu",
        "Obarsia",
        "Obreja",
        "Ohaba",
        "Ohaba Jiu",
        "Olari",
        "Olteanu",
        "Orzesti",
        "Orzu",
        "Pades",
        "Paisani",
        "Pajistele",
        "Paltinu",
        "Parau",
        "Parau Boia",
        "Parau de Pripor",
        "Parau de Vale",
        "Parau Viu",
        "Parvulesti",
        "Pegeni",
        "Pesteana de Jos",
        "Pesteana Jiu",
        "Pesteana Vulcan",
        "Pestisani",
        "Petrachei",
        "Petresti",
        "Picu",
        "Pieptani",
        "Pinoasa",
        "Piscoiu",
        "Piscuri",
        "Pistestii din Deal",
        "Plesa",
        "Plopsoru",
        "Plopu",
        "Plostina",
        "Pociovalistea",
        "Pocruia",
        "Poiana",
        "Poiana Seciuri",
        "Poienari",
        "Poienita",
        "Pojaru",
        "Pojogeni",
        "Polata",
        "Polovragi",
        "Popesti",
        "Popesti Stejari",
        "Preajba Mare",
        "Prigoria",
        "Priporu",
        "Prunesti",
        "Purcaru",
        "Rachiti",
        "Raci",
        "Racoti",
        "Racovita",
        "Radinesti",
        "Radosi",
        "Rapa",
        "Rasova",
        "Rasovita",
        "Ratez",
        "Rogojel",
        "Rogojeni",
        "Romanesti",
        "Rosia de Amaradia",
        "Rosia Jiu",
        "Rosiuta",
        "Rovinari",
        "Ruget",
        "Rugi",
        "Runcu",
        "Runcurel",
        "Sacelu",
        "Samarinesti",
        "Sambotin",
        "Sanatesti",
        "Sarbesti",
        "Sardanesti",
        "Sasa",
        "Satu Nou",
        "Saulesti",
        "Schela",
        "Scoarta",
        "Scorusu",
        "Scrada",
        "Scurtu",
        "Seaca",
        "Seciurile",
        "Seuca",
        "Siacu",
        "Sipotu",
        "Sitesti",
        "Sitoaia",
        "Slamnesti",
        "Slavuta",
        "Slivilesti",
        "Slobozia",
        "Socu",
        "Sohodol",
        "Somanesti",
        "Spahii",
        "Stancesti",
        "Stancesti Larga",
        "Stanesti",
        "Stefanesti",
        "Steic",
        "Stejari",
        "Stejaru",
        "Stejerei",
        "Sterpoaia",
        "Stiucani",
        "Stoina",
        "Stolojani",
        "Stramba Jiu",
        "Stramba Vulcan",
        "Stramtu",
        "Stroiesti",
        "Sura",
        "Suseni",
        "Talpasesti",
        "Talvesti",
        "Tamasesti",
        "Tantareni",
        "Tarculesti",
        "Targu Carbunesti",
        "Targu Jiu",
        "Targu Logresti",
        "Tehomir",
        "Telesti",
        "Tetila",
        "Ticleni",
        "Timiseni",
        "Tirioi",
        "Tismana",
        "Toiaga",
        "Topesti",
        "Totea",
        "Totea de Hurezani",
        "Trestioara",
        "Trocani",
        "Turburea",
        "Turceni",
        "Turcinesti",
        "Ulmet",
        "Ungureni",
        "Urda de Jos",
        "Urda de Sus",
        "Urdari",
        "Urechesti",
        "Ursati",
        "Ursoaia",
        "Vacarea",
        "Vagiulesti",
        "Vaidei",
        "Vaieni",
        "Valari",
        "Valceaua",
        "Valcele",
        "Valea",
        "Valea Bisericii",
        "Valea cu Apa",
        "Valea Desului",
        "Valea Manastirii",
        "Valea Mare",
        "Valea Mica",
        "Valea Motrului",
        "Valea Perilor",
        "Valea Poienii",
        "Valea Pojarului",
        "Valea Racilor",
        "Valea Viei",
        "Valeni",
        "Valuta",
        "Vanata",
        "Vart",
        "Vartopu",
        "Vidin",
        "Viersani",
        "Vladimir",
        "Vladuleni",
        "Voinigesti",
        "Voitestii de Vale",
        "Voitestii din Deal",
        "Zaicoiu",
        "Zorlesti",
        "Zorzila"
      ],
      "Harghita": [
        "Aldea",
        "Alexandrita",
        "Alunis",
        "Andreeni",
        "Armaseni",
        "Armasenii Noi",
        "Arvateni",
        "Atia",
        "Atid",
        "Avramesti",
        "Badeni",
        "Baile Chirui",
        "Baile Homorod",
        "Baile Tusnad",
        "Balan",
        "Bancu",
        "Baratcos",
        "Barzava",
        "Becas",
        "Bentid",
        "Beta",
        "Betesti",
        "Bilbor",
        "Bisericani",
        "Bodogaia",
        "Borsec",
        "Borzont",
        "Bradesti",
        "Bucin",
        "Bulgareni",
        "Cadaciu Mare",
        "Cadaciu Mic",
        "Calimanel",
        "Calnaci",
        "Calonda",
        "Calugareni",
        "Capalnita",
        "Capu Corbului",
        "Carpitus",
        "Carta",
        "Casinu Nou",
        "Cechesti",
        "Cehetel",
        "Cetatuia",
        "Chedia Mare",
        "Chedia Mica",
        "Chileni",
        "Chinusu",
        "Ciaracio",
        "Ciba",
        "Ciceu",
        "Ciobanis",
        "Cireseni",
        "Ciucani",
        "Ciucsangeorgiu",
        "Ciumani",
        "Cobatesti",
        "Comanesti",
        "Comiat",
        "Corbu",
        "Corund",
        "Cotormani",
        "Covacipeter",
        "Cozmeni",
        "Craciunel",
        "Criseni",
        "Cristuru Secuiesc",
        "Cusmed",
        "Daia",
        "Danesti",
        "Darjiu",
        "Dealu",
        "Dealu Armanului",
        "Dejutiu",
        "Delnita",
        "Desag",
        "Ditrau",
        "Dobeni",
        "Duda",
        "Eghersec",
        "Eliseni",
        "Fagetel",
        "Fancel",
        "Fantana Brazilor",
        "Feliceni",
        "Filias",
        "Filpea",
        "Firtanus",
        "Firtusu",
        "Fitod",
        "Forteni",
        "Frumoasa",
        "Fundoaia",
        "Galautas",
        "Galautas-Parau",
        "Gheorgheni",
        "Ghidut",
        "Ghipes",
        "Ghiurche",
        "Goagiu",
        "Hagota",
        "Harghita-Bai",
        "Hodosa",
        "Hoghia",
        "Hosasau",
        "Iacobeni",
        "Iasu",
        "Ighiu",
        "Imper",
        "Ineu",
        "Inlaceni",
        "Izvoare",
        "Izvoru Muresului",
        "Izvorul Trotusului",
        "Jigodin-Bai",
        "Jolotca",
        "Joseni",
        "Lacu Rosu",
        "Laz-Firtanus",
        "Laz-Soimus",
        "Lazarea",
        "Lazaresti",
        "Leliceni",
        "Liban",
        "Livezi",
        "Locodeni",
        "Lueta",
        "Lunca de Jos",
        "Lunca de Sus",
        "Luncani",
        "Lupeni",
        "Lutita",
        "Madaras",
        "Magherus",
        "Martinis",
        "Martonca",
        "Matiseni",
        "Medisoru Mare",
        "Medisoru Mic",
        "Meresti",
        "Miercurea Ciuc",
        "Mihaileni",
        "Minele Lueta",
        "Misentea",
        "Moglanesti",
        "Morareni",
        "Mugeni",
        "Mujna",
        "Nadejdea",
        "Nicoleni",
        "Nicolesti",
        "Nuteni",
        "Obranesti",
        "Ocland",
        "Ocna de Jos",
        "Ocna de Sus",
        "Odorheiu Secuiesc",
        "Oraseni",
        "Oteni",
        "Paltinis",
        "Paltinis-Ciuc",
        "Pauleni",
        "Pauleni-Ciuc",
        "Petecu",
        "Petreni",
        "Pintic",
        "Plaiesii de Jos",
        "Plaiesii de Sus",
        "Platonesti",
        "Plopis",
        "Poiana Fagului",
        "Poiana Tarnavei",
        "Polonita",
        "Porumbenii Mari",
        "Porumbenii Mici",
        "Potiond",
        "Praid",
        "Preluca",
        "Puntea Lupului",
        "Rachitis",
        "Racu",
        "Rares",
        "Recea",
        "Remetea",
        "Ruganesti",
        "Runc",
        "Sacel",
        "Sancel",
        "Sancrai",
        "Sancraieni",
        "Sandominic",
        "Sanmartin",
        "Sanpaul",
        "Sansimion",
        "Santimbru",
        "Santimbru-Bai",
        "Sarmas",
        "Sasveres",
        "Satu Mare",
        "Satu Mic",
        "Satu Nou",
        "Secu",
        "Secuieni",
        "Senetea",
        "Sicasau",
        "Siclod",
        "Siculeni",
        "Simonesti",
        "Sineu",
        "Soimeni",
        "Soimusu Mare",
        "Soimusu Mic",
        "Sub Cetate",
        "Subcetate",
        "Suseni",
        "Taietura",
        "Tamasu",
        "Tarcesti",
        "Tarnovita",
        "Taureni",
        "Teleac",
        "Tengheler",
        "Tibod",
        "Toleseni",
        "Tomesti",
        "Toplita",
        "Tulghes",
        "Turdeni",
        "Tusnad",
        "Tusnadu Nou",
        "Uilac",
        "Ulcani",
        "Ulies",
        "Vacaresti",
        "Vagani",
        "Vale",
        "Valea Boros",
        "Valea Capelei",
        "Valea Garbea",
        "Valea Intunecoasa",
        "Valea lui Antaloc",
        "Valea lui Pavel",
        "Valea Rece",
        "Valea Rotunda",
        "Valea Stramba",
        "Valea Ugra",
        "Valea Uzului",
        "Valeni",
        "Vargatac",
        "Varsag",
        "Vasileni",
        "Vidacut",
        "Visafolio",
        "Vlahita",
        "Voslabeni",
        "Vrabia",
        "Zapodea",
        "Zencani",
        "Zetea"
      ],
      "Hunedoara": [
        "Abucea",
        "Almas-Saliste",
        "Almasel",
        "Almasu Mic",
        "Almasu Mic de Munte",
        "Almasu Sec",
        "Alun",
        "Aninoasa",
        "Aranies",
        "Archia",
        "Ardeu",
        "Aurel Vlaicu",
        "Bacaia",
        "Bacea",
        "Bacia",
        "Baia de Cris",
        "Baiesti",
        "Baita",
        "Balata",
        "Baldovin",
        "Balomir",
        "Balsa",
        "Banita",
        "Banpotoc",
        "Barastii Hategului",
        "Barastii Iliei",
        "Barbura",
        "Barcea Mare",
        "Barcea Mica",
        "Barsau",
        "Baru",
        "Barza",
        "Basarabasa",
        "Bastea",
        "Batalar",
        "Batiz",
        "Batrana",
        "Bejan",
        "Bejan-Tarnavita",
        "Bercu",
        "Beriu",
        "Birtin",
        "Blajeni",
        "Blajeni-Vulcan",
        "Bobaia",
        "Bobalna",
        "Bocsa Mare",
        "Bocsa Mica",
        "Boholt",
        "Boia Barzii",
        "Boita",
        "Boiu",
        "Boiu de Jos",
        "Boiu de Sus",
        "Bos",
        "Bosorod",
        "Boz",
        "Bozes",
        "Brad",
        "Bradatel",
        "Branisca",
        "Braseu",
        "Brazi",
        "Braznic",
        "Breazova",
        "Bretea Muresana",
        "Bretea Romana",
        "Bretea Streiului",
        "Bretelin",
        "Brotuna",
        "Buces",
        "Buces-Vulcan",
        "Bucium",
        "Bucium-Orlea",
        "Bucuresci",
        "Bujoru",
        "Bulzestii de Jos",
        "Bulzestii de Sus",
        "Bunesti",
        "Bunila",
        "Burjuc",
        "Cabesti",
        "Cainelu de Jos",
        "Cainelu de Sus",
        "Calan",
        "Calanu Mic",
        "Campu lui Neag",
        "Campuri de Sus",
        "Campuri-Surduc",
        "Caoi",
        "Caraci",
        "Carastau",
        "Carjiti",
        "Carmazanesti",
        "Carnesti",
        "Carpinis",
        "Castau",
        "Cazanesti",
        "Cerbal",
        "Cerbia",
        "Cerisor",
        "Cernisoara Florese",
        "Certeju de Jos",
        "Certeju de Sus",
        "Cherghes",
        "Chimindia",
        "Chiscadaga",
        "Chitid",
        "Cigmau",
        "Cimpa",
        "Cincis-Cerna",
        "Cioclovina",
        "Ciopeia",
        "Ciula Mare",
        "Ciula Mica",
        "Ciulpaz",
        "Ciumita",
        "Ciungani",
        "Ciungu Mare",
        "Clopotiva",
        "Coaja",
        "Copaci",
        "Coroiesti",
        "Cosesti",
        "Costesti",
        "Costesti-Deal",
        "Covragiu",
        "Cozia",
        "Craciunesti",
        "Craguis",
        "Cris",
        "Crisan",
        "Criscior",
        "Cristur",
        "Criva",
        "Crivadia",
        "Cucuis",
        "Cuies",
        "Curechiu",
        "Curpenii Silvasului",
        "Cutin",
        "Dabaca",
        "Dalja Mare",
        "Dalja Mica",
        "Dancu Mare",
        "Dancu Mic",
        "Danulesti",
        "Dealu Babii",
        "Dealu Mare",
        "Dealu Mic",
        "Deleni",
        "Densus",
        "Deva",
        "Dobra",
        "Dobrot",
        "Dragu-Brad",
        "Dudesti",
        "Dumbrava",
        "Dumbrava de Jos",
        "Dumbrava de Sus",
        "Dumbravita",
        "Dumesti",
        "Dupapiatra",
        "Fagetel",
        "Fantana",
        "Farcadin",
        "Fata Rosie",
        "Federi",
        "Feregi",
        "Fintoag",
        "Fizes",
        "Fizesti",
        "Folt",
        "Fornadia",
        "Furcsoara",
        "Galati",
        "Galbina",
        "Gantaga",
        "Gelmar",
        "General Berthelot",
        "Geoagiu",
        "Geoagiu-Bai",
        "Ghelari",
        "Gialacuta",
        "Giurgesti",
        "Glodghilesti",
        "Godinesti",
        "Goles",
        "Gotesti",
        "Gothatea",
        "Govajdia",
        "Gradistea de Munte",
        "Grid",
        "Grind",
        "Grohot",
        "Grohotele",
        "Gros",
        "Grosuri",
        "Gura Bordului",
        "Gurasada",
        "Harau",
        "Hartagani",
        "Hasdat",
        "Hasdau",
        "Hatagel",
        "Hateg",
        "Herepeia",
        "Hobita",
        "Hobita-Gradiste",
        "Holdea",
        "Homorod",
        "Hondol",
        "Hunedoara",
        "Ilia",
        "Iscroni",
        "Izvoarele",
        "Jeledinti",
        "Jiet",
        "Jiu-Paroseni",
        "Josani",
        "Lapugiu de Jos",
        "Lapugiu de Sus",
        "Lapusnic",
        "Lasau",
        "Leaut",
        "Lelese",
        "Lesnic",
        "Livada",
        "Livadia",
        "Livezi",
        "Ludestii de Jos",
        "Ludestii de Sus",
        "Lunca",
        "Lunca Cernii de Jos",
        "Lunca Cernii de Sus",
        "Luncani",
        "Luncoiu de Jos",
        "Luncoiu de Sus",
        "Luncsoara",
        "Lupeni",
        "Maceu",
        "Mada",
        "Magura",
        "Magura-Toplita",
        "Magureni",
        "Malaiesti",
        "Manerau",
        "Martinesti",
        "Meria",
        "Merisor",
        "Merisoru de Munte",
        "Mermezeu-Valeni",
        "Mesteacan",
        "Micanesti",
        "Mihaiesti",
        "Mihaileni",
        "Mintia",
        "Mosoru",
        "Muncelu Mare",
        "Muncelu Mic",
        "Nadastia de Jos",
        "Nadastia de Sus",
        "Nalatvad",
        "Nandru",
        "Negoiu",
        "Nojag",
        "Nucsoara",
        "Obarsa",
        "Ocisor",
        "Ociu",
        "Ocolisu Mare",
        "Ocolisu Mic",
        "Ohaba",
        "Ohaba de Sub Piatra",
        "Ohaba Streiului",
        "Ohaba-Ponor",
        "Ohaba-Sibisel",
        "Oprisesti",
        "Orastie",
        "Orastioara de Jos",
        "Orastioara de Sus",
        "Ormindea",
        "Ostrov",
        "Ostrovel",
        "Ostrovu Mic",
        "Paclisa",
        "Panc",
        "Panc-Saliste",
        "Paros",
        "Paucinesti",
        "Paulesti",
        "Paulis",
        "Pesteana",
        "Pestenita",
        "Pestera",
        "Pestisu Mare",
        "Pestisu Mic",
        "Petreni",
        "Petresti",
        "Petrila",
        "Petros",
        "Petrosani",
        "Piatra",
        "Pischinti",
        "Plai",
        "Plop",
        "Plopi",
        "Podele",
        "Poganesti",
        "Poiana",
        "Poiana Rachitelii",
        "Poieni",
        "Poienita",
        "Poienita Tomii",
        "Poienita Voinii",
        "Pojoga",
        "Ponor",
        "Popesti",
        "Potingani",
        "Pravaleni",
        "Pricaz",
        "Prihodiste",
        "Pui",
        "Racastia",
        "Rachitaua",
        "Rachitova",
        "Radulesti",
        "Rapas",
        "Rapoltel",
        "Rapoltu Mare",
        "Rascoala",
        "Rau Alb",
        "Rau Barbat",
        "Rau de Mori",
        "Rau Mic",
        "Reea",
        "Renghet",
        "Ret",
        "Ribicioara",
        "Ribita",
        "Risca",
        "Risculita",
        "Romos",
        "Romosel",
        "Roscani",
        "Rosia",
        "Rovina",
        "Ruda",
        "Ruda-Brad",
        "Runcsor",
        "Runcu Mare",
        "Runcu Mic",
        "Rusesti",
        "Rusi",
        "Rusor",
        "Sacamas",
        "Sacaramb",
        "Sacel",
        "Salasu de Jos",
        "Salasu de Sus",
        "Salatruc",
        "Salciva",
        "Saliste",
        "Salistioara",
        "Sancrai",
        "Sanpetru",
        "Santamaria de Piatra",
        "Santamaria-Orlea",
        "Santandrei",
        "Santuhalm",
        "Sarbi",
        "Sarmizegetusa",
        "Saulesti",
        "Sereca",
        "Serel",
        "Sesuri",
        "Sibisel",
        "Silvasu de Jos",
        "Silvasu de Sus",
        "Simeria",
        "Simeria Veche",
        "Slatinioara",
        "Socet",
        "Sohodol",
        "Soimus",
        "Spini",
        "Stancesti",
        "Stancesti-Ohaba",
        "Stanculesti",
        "Stanija",
        "Stauini",
        "Stei",
        "Steia",
        "Stejarel",
        "Stoieneasa",
        "Strei",
        "Strei-Sacel",
        "Streisangeorgiu",
        "Stretea",
        "Subcetate",
        "Sulighete",
        "Suseni",
        "Tamasasa",
        "Tamasesti",
        "Tampa",
        "Taratel",
        "Tarnava",
        "Tarnava de Cris",
        "Tarnavita",
        "Tarnita",
        "Tarsa",
        "Tatarasti",
        "Tatarastii de Cris",
        "Tebea",
        "Techereu",
        "Teiu",
        "Teliucu Inferior",
        "Teliucu Superior",
        "Ticera",
        "Tirici",
        "Tisa",
        "Tiulesti",
        "Tomesti",
        "Tomnatec",
        "Toplita",
        "Toplita Muresului",
        "Totesti",
        "Totia",
        "Trestia",
        "Turdas",
        "Turmas",
        "Tustea",
        "Uibaresti",
        "Ulies",
        "Ulm",
        "Unciuc",
        "Uric",
        "Uricani",
        "Uroi",
        "Ursici",
        "Vadu",
        "Vadu Dobrii",
        "Vaidei",
        "Valari",
        "Valcele",
        "Valcelele Bune",
        "Valceluta",
        "Valea",
        "Valea Arsului",
        "Valea Babii",
        "Valea Bradului",
        "Valea Daljii",
        "Valea de Brazi",
        "Valea Lunga",
        "Valea Lupului",
        "Valea Mare de Cris",
        "Valea Nandrului",
        "Valea Poienii",
        "Valea Sangeorgiului",
        "Valeni",
        "Valioara",
        "Valisoara",
        "Varmaga",
        "Vata de Jos",
        "Vata de Sus",
        "Vetel",
        "Vica",
        "Visca",
        "Voia",
        "Vorta",
        "Vulcan",
        "Zam",
        "Zavoi",
        "Zdrapti",
        "Zeicani"
      ],
      "Ialomita": [
        "Adancata",
        "Albesti",
        "Alexeni",
        "Amara",
        "Amara Noua",
        "Andrasesti",
        "Armasesti",
        "Axintele",
        "Balaciu",
        "Barbatescu",
        "Barbulesti",
        "Barcanesti",
        "Bataluri",
        "Bitina-Pamanteni",
        "Bitina-Ungureni",
        "Bora",
        "Boranesti",
        "Bordusani",
        "Borduselu",
        "Boteni",
        "Brazii",
        "Brosteni",
        "Bucsa",
        "Bucu",
        "Buesti",
        "Buliga",
        "Butoiu",
        "Catrunesti",
        "Cazanesti",
        "Cegani",
        "Chiroiu-Pamanteni",
        "Chiroiu-Satu Nou",
        "Chiroiu-Ungureni",
        "Ciocarlia",
        "Ciochina",
        "Ciulnita",
        "Cocora",
        "Colelia",
        "Condeesti",
        "Copuzu",
        "Cosambesti",
        "Cosereni",
        "Cotorca",
        "Crasanii de Jos",
        "Crasanii de Sus",
        "Crunti",
        "Dragoesti",
        "Dridu",
        "Dridu-Snagov",
        "Dumitresti",
        "Facaeni",
        "Fetesti",
        "Fetesti-Gara",
        "Fierbinti-Targ",
        "Fierbintii de Jos",
        "Fierbintii de Sus",
        "Fratilesti",
        "Fundata",
        "Garbovi",
        "Gheorghe Doja",
        "Gheorghe Lazar",
        "Gimbasani",
        "Giurgeni",
        "Grecii de Jos",
        "Grindasi",
        "Grindu",
        "Grivita",
        "Gura Ialomitei",
        "Gura Vaii",
        "Hagieni",
        "Hagiesti",
        "Horia",
        "Iazu",
        "Ion Ghica",
        "Ion Roata",
        "Ivanesti",
        "Jilavele",
        "Lacusteni",
        "Lilieci",
        "Livedea",
        "Luciu",
        "Maia",
        "Maltezi",
        "Malu",
        "Malu Rosu",
        "Manasia",
        "Marculesti",
        "Marsilieni",
        "Mihail Kogalniceanu",
        "Milosesti",
        "Mircea cel Batran",
        "Misleanu",
        "Moldoveni",
        "Movila",
        "Movileanca",
        "Movilita",
        "Munteni-Buzau",
        "Murgeanca",
        "Nenisori",
        "Nicolesti",
        "Ograda",
        "Orboesti",
        "Orezu",
        "Paltinisu",
        "Patru Frati",
        "Perieti",
        "Piersica",
        "Platonesti",
        "Poiana",
        "Progresu",
        "Rasi",
        "Rasimnicea",
        "Retezatu",
        "Reviga",
        "Rosiori",
        "Rovine",
        "Salcioara",
        "Sarateni",
        "Saveni",
        "Scanteia",
        "Sfantu Gheorghe",
        "Sinesti",
        "Sintesti",
        "Slatioarele",
        "Slobozia",
        "Slobozia Noua",
        "Smirna",
        "Stejaru",
        "Stelnica",
        "Suditi",
        "Tandarei",
        "Tovarasia",
        "Traian",
        "Urziceni",
        "Valea Bisericii",
        "Valea Ciorii",
        "Valea Macrisului",
        "Vladeni",
        "Vlasca"
      ],
      "Iasi": [
        "Albesti",
        "Alexandru cel Bun",
        "Alexandru I. Cuza",
        "Alexeni",
        "Alexesti",
        "Andrieseni",
        "Arama",
        "Aroneanu",
        "Avantu",
        "Bacu",
        "Badeni",
        "Bahluiu",
        "Baiceni",
        "Balciu",
        "Bals",
        "Baltati",
        "Balteni",
        "Balusesti",
        "Banu",
        "Barbatesti",
        "Barlesti",
        "Barnova",
        "Belcesti",
        "Berezlogi",
        "Bivolari",
        "Blaga",
        "Blagesti",
        "Boatca",
        "Bocnita",
        "Bodesti",
        "Bogdanesti",
        "Bogonos",
        "Bohotin",
        "Bojila",
        "Boldesti",
        "Borosesti",
        "Borosoaia",
        "Borsa",
        "Bosia",
        "Bosteni",
        "Boureni",
        "Bradicesti",
        "Braesti",
        "Bran",
        "Bratesti",
        "Bratuleni",
        "Bratulesti",
        "Breazu",
        "Brosteni",
        "Buda",
        "Budai",
        "Budesti",
        "Buhaeni",
        "Buhalnita",
        "Bulbucani",
        "Bursuc-Deal",
        "Bursuc-Vale",
        "Buruienesti",
        "Butea",
        "Buzdug",
        "Buznea",
        "Carbunari",
        "Carjoaia",
        "Carlig",
        "Carniceni",
        "Cauesti",
        "Ceplenita",
        "Cercu",
        "Chicerea",
        "Chilisoaia",
        "Chiperesti",
        "Chiscareni",
        "Cilibiu",
        "Cioca-Boca",
        "Ciocarlesti",
        "Ciohorani",
        "Ciortesti",
        "Cireseni",
        "Ciurbesti",
        "Ciurea",
        "Coada Stancii",
        "Coarnele Caprei",
        "Coasta Magurii",
        "Cogeasca",
        "Coltu Cornii",
        "Comarna",
        "Contesti",
        "Corcodel",
        "Cornesti",
        "Coropceni",
        "Cositeni",
        "Costesti",
        "Costuleni",
        "Cotargaci",
        "Cotnari",
        "Cotu lui Ivan",
        "Cotu Morii",
        "Covasna",
        "Cozia",
        "Cozmesti",
        "Cristesti",
        "Crivesti",
        "Crucea",
        "Cucova",
        "Cucuteni",
        "Curagau",
        "Curaturi",
        "Cuza Voda",
        "Dadesti",
        "Dagata",
        "Dancas",
        "Dancu",
        "Deleni",
        "Dobrovat",
        "Dolhesti",
        "Domnita",
        "Dorobant",
        "Doroscani",
        "Draganesti",
        "Draguseni",
        "Dumbrava",
        "Dumbravita",
        "Dumesti",
        "Dumitrestii Galatii",
        "Erbiceni",
        "Fagat",
        "Fantanele",
        "Farcaseni",
        "Fedeleseni",
        "Feredeni",
        "Fetesti",
        "Filiasi",
        "Focuri",
        "Forasti",
        "Frasuleni",
        "Frenciugi",
        "Frumusica",
        "Ganesti",
        "Garbesti",
        "Gastesti",
        "Gaureni",
        "Giurgesti",
        "Glavanesti",
        "Glodenii Gandului",
        "Goesti",
        "Golaiesti",
        "Gorban",
        "Goruni",
        "Gradinari",
        "Grajduri",
        "Griesti",
        "Gropnita",
        "Grozesti",
        "Gura Badilitei",
        "Gura Bohotin",
        "Gura Vaii",
        "Habasesti",
        "Hadambu",
        "Halaucesti",
        "Halceni",
        "Handresti",
        "Harlau",
        "Harmaneasa",
        "Harmanestii Noi",
        "Harmanestii Vechi",
        "Harpasesti",
        "Hartoape",
        "Heci",
        "Helesteni",
        "Hermeziu",
        "Hilita",
        "Hlincea",
        "Hodora",
        "Hoisesti",
        "Holboca",
        "Holm",
        "Homita",
        "Horlesti",
        "Horodistea",
        "Horpaz",
        "Humosu",
        "Iacobeni",
        "Iasi",
        "Iazu Nou",
        "Iazu Vechi",
        "Icuseni",
        "Iepureni",
        "Ion Neculce",
        "Iorcani",
        "Iosupeni",
        "Ipatele",
        "Isaiia",
        "Iugani",
        "Izvoarele",
        "Jigoreni",
        "Kogalniceni",
        "Larga-Jijia",
        "Leahu-Nacu",
        "Lespezi",
        "Letcani",
        "Liteni",
        "Luceni",
        "Lunca",
        "Lunca Cetatuii",
        "Lunca Rates",
        "Luncasi",
        "Lungani",
        "Luparia",
        "Macaresti",
        "Madarjac",
        "Madarjesti",
        "Malaesti",
        "Manastirea",
        "Manjesti",
        "Manzatesti",
        "Maxut",
        "Medeleni",
        "Miclauseni",
        "Mihail Kogalniceanu",
        "Mircesti",
        "Mironeasa",
        "Miroslava",
        "Miroslovesti",
        "Mitesti",
        "Mitoc",
        "Moara Ciornei",
        "Mogosesti",
        "Mogosesti-Siret",
        "Moimesti",
        "Moreni",
        "Mosna",
        "Motca",
        "Movileni",
        "Muncelu de Sus",
        "Munteni",
        "Oboroceni",
        "Obrijeni",
        "Onesti",
        "Opriseni",
        "Oproaia",
        "Orzeni",
        "Osoi",
        "Oteleni",
        "Padureni",
        "Parcovaci",
        "Pascani",
        "Paun",
        "Pausesti",
        "Perieni",
        "Petresti",
        "Petrosica",
        "Picioru Lupului",
        "Pietraria",
        "Pietris",
        "Pietrosu",
        "Piscu Rusului",
        "Plugari",
        "Pocreaca",
        "Podisu",
        "Podolenii de Jos",
        "Podolenii de Sus",
        "Podu Hagiului",
        "Podu Iloaiei",
        "Podu Jijiei",
        "Poiana",
        "Poiana cu Cetate",
        "Poiana de Sus",
        "Poiana Manastirii",
        "Poiana Marului",
        "Poiana Scheii",
        "Poieni",
        "Poienile",
        "Popesti",
        "Popricani",
        "Potangeni",
        "Prigoreni",
        "Prisacani",
        "Probota",
        "Proselnici",
        "Rachiteni",
        "Radeni",
        "Raducaneni",
        "Rasboieni",
        "Razboieni",
        "Recea",
        "Rediu",
        "Rediu Aldei",
        "Rediu Mitropoliei",
        "Romanesti",
        "Roscani",
        "Rosu",
        "Rotaria",
        "Ruginoasa",
        "Runcu",
        "Rusenii Noi",
        "Rusenii Vechi",
        "Sacaresti",
        "Salageni",
        "Sangeri",
        "Sarca",
        "Satu Nou",
        "Saveni",
        "Scanteia",
        "Scheia",
        "Schitu Duca",
        "Schitu Hadambului",
        "Schitu Stavnic",
        "Scobalteni",
        "Scobinti",
        "Scoposeni",
        "Sculeni",
        "Sendreni",
        "Serbesti",
        "Sinesti",
        "Sipote",
        "Siretel",
        "Slobozia",
        "Soci",
        "Sodomeni",
        "Solonet",
        "Sorogani",
        "Spineni",
        "Spinoasa",
        "Spranceana",
        "Stanca",
        "Stejarii",
        "Sticlaria",
        "Stolniceni-Prajescu",
        "Stornesti",
        "Stroesti",
        "Strunga",
        "Suhulet",
        "Tabara",
        "Tansa",
        "Targu Frumos",
        "Tarnita",
        "Tatarusi",
        "Tautesti",
        "Tibana",
        "Tibanesti",
        "Tiganasi",
        "Tipilesti",
        "Todirel",
        "Todiresti",
        "Tomesti",
        "Topile",
        "Totoesti",
        "Traian",
        "Trifesti",
        "Tudor Vladimirescu",
        "Tufestii de Sus",
        "Tungujei",
        "Tutora",
        "Uda",
        "Ulmi",
        "Ungheni",
        "Uricani",
        "Ursaresti",
        "Ursita",
        "Ursoaia",
        "Vadu Vejei",
        "Valcelele",
        "Valcica",
        "Valea Adanca",
        "Valea Lunga",
        "Valea Lupului",
        "Valea Oilor",
        "Valea Racului",
        "Valea Satului",
        "Valea Seaca",
        "Valea Ursului",
        "Valenii",
        "Vama",
        "Vanatori",
        "Vascani",
        "Verseni",
        "Victoria",
        "Visan",
        "Vladeni",
        "Vladiceni",
        "Vladnicut",
        "Vladomira",
        "Vocotesti",
        "Voinesti",
        "Volintiresti",
        "Vorovesti",
        "Vulturi",
        "Zaboloteni",
        "Zagavia",
        "Zbereni",
        "Zberoaia",
        "Zece Prajini",
        "Zlodica",
        "Zmeu"
      ],
      "Ilfov": [
        "1 Decembrie",
        "Afumati",
        "Alunisu",
        "Balaceanca",
        "Balotesti",
        "Balta Neagra",
        "Balteni",
        "Berceni",
        "Bragadiru",
        "Branesti",
        "Buciumeni",
        "Buda",
        "Buftea",
        "Burias",
        "Caciulati",
        "Caldararu",
        "Catelu",
        "Cernica",
        "Chiajna",
        "Chitila",
        "Cioflinceni",
        "Ciolpani",
        "Ciorogarla",
        "Clinceni",
        "Copaceni",
        "Corbeanca",
        "Cornetu",
        "Cozieni",
        "Creata",
        "Cretesti",
        "Cretuleasca",
        "Darasti-Ilfov",
        "Darvari",
        "Dascalu",
        "Dimieni",
        "Dobroesti",
        "Domnesti",
        "Dragomiresti-Deal",
        "Dragomiresti-Vale",
        "Dudu",
        "Dumbraveni",
        "Dumitrana",
        "Fundeni",
        "Gagu",
        "Ganeasa",
        "Ghermanesti",
        "Glina",
        "Gradistea",
        "Gruiu",
        "Islaz",
        "Izvorani",
        "Jilava",
        "Lipia",
        "Luparia",
        "Magurele",
        "Maineasca",
        "Manolache",
        "Merii Petchii",
        "Micsunestii Mari",
        "Micsunestii-Moara",
        "Moara Domneasca",
        "Moara Vlasiei",
        "Mogosoaia",
        "Nuci",
        "Odaile",
        "Olteni",
        "Ordoreanu",
        "Ostratu",
        "Otopeni",
        "Pantelimon",
        "Pasarea",
        "Peris",
        "Petrachioaia",
        "Petresti",
        "Piscu",
        "Piteasca",
        "Popesti Leordeni",
        "Posta",
        "Pruni",
        "Rosu",
        "Rudeni",
        "Runcu",
        "Saftica",
        "Santu Floresti",
        "Silistea Snagovului",
        "Sindrilita",
        "Sintesti",
        "Sitaru",
        "Snagov",
        "Stefanestii de Jos",
        "Stefanestii de Sus",
        "Surlari",
        "Tamasi",
        "Tancabesti",
        "Tanganu",
        "Teghes",
        "Tunari",
        "Vadu Anei",
        "Vanatori",
        "Varteju",
        "Vidra",
        "Vladiceasca",
        "Voluntari",
        "Zurbaua"
      ],
      "Maramures": [
        "Ardusat",
        "Arduzel",
        "Ariesu de Camp",
        "Ariesu de Padure",
        "Arinis",
        "Aspra",
        "Asuaju de Jos",
        "Asuaju de Sus",
        "Baba",
        "Baia Mare",
        "Baia Sprie",
        "Baile Borsa",
        "Baita",
        "Baita de Sub Codru",
        "Baiut",
        "Bargau",
        "Barsana",
        "Basesti",
        "Berbesti",
        "Berchez",
        "Berchezoaia",
        "Berinta",
        "Bicaz",
        "Bistra",
        "Blidari",
        "Bocicoel",
        "Bocicoiu Mare",
        "Bogdan Voda",
        "Boiereni",
        "Boiu Mare",
        "Bontaieni",
        "Borcut",
        "Borsa",
        "Botiza",
        "Bozanta Mare",
        "Bozanta Mica",
        "Breb",
        "Brebeni",
        "Buciumi",
        "Budesti",
        "Busag",
        "Buteasa",
        "Buzesti",
        "Calinesti",
        "Campulung la Tisa",
        "Carbunari",
        "Carpinis",
        "Catalina",
        "Cavnic",
        "Cernesti",
        "Cetatele",
        "Chechis",
        "Chelinta",
        "Chiuzbaia",
        "Cicarlau",
        "Ciocotis",
        "Ciolt",
        "Ciuta",
        "Coas",
        "Codru Butesii",
        "Coltau",
        "Coltirea",
        "Copalnic",
        "Copalnic-Deal",
        "Copalnic-Manastur",
        "Cornesti",
        "Corni",
        "Coroieni",
        "Coruia",
        "Costeni",
        "Costiui",
        "Craciunesti",
        "Crasna Viseului",
        "Cufoaia",
        "Culcea",
        "Cupseni",
        "Curtuiusu Mare",
        "Curtuiusu Mic",
        "Damacuseni",
        "Danesti",
        "Danestii Chioarului",
        "Dealu Corbului",
        "Dealu Mare",
        "Desesti",
        "Dobricu Lapusului",
        "Draghia",
        "Dragomiresti",
        "Dumbrava",
        "Dumbravita",
        "Durusa",
        "Fanate",
        "Fantanele",
        "Farcasa",
        "Fauresti",
        "Feresti",
        "Fericea",
        "Fersig",
        "Finteusu Mare",
        "Finteusu Mic",
        "Firiza",
        "Francenii Boiului",
        "Gardani",
        "Giulesti",
        "Glod",
        "Groape",
        "Grosi",
        "Grosii Tiblesului",
        "Handalu Ilbei",
        "Harnicesti",
        "Hideaga",
        "Hoteni",
        "Hovrila",
        "Iadara",
        "Iapa",
        "Ieud",
        "Ilba",
        "Inau",
        "Intrerauri",
        "Izvoarele",
        "Jugastreni",
        "Lapus",
        "Lapusel",
        "Larga",
        "Laschia",
        "Lazu Baciului",
        "Leordina",
        "Libotin",
        "Lucacesti",
        "Lunca la Tisa",
        "Magureni",
        "Manastirea",
        "Manau",
        "Mara",
        "Merisor",
        "Mesteacan",
        "Miresu Mare",
        "Mocira",
        "Mogosesti",
        "Moisei",
        "Nanesti",
        "Negreia",
        "Nistru",
        "Oarta de Jos",
        "Oarta de Sus",
        "Ocna Sugatag",
        "Ocolis",
        "Odesti",
        "Oncesti",
        "Ortita",
        "Peteritea",
        "Petrova",
        "Piatra",
        "Plopis",
        "Poiana Botizii",
        "Poienile de Sub Munte",
        "Poienile Izei",
        "Posta",
        "Preluca Noua",
        "Preluca Veche",
        "Pribilesti",
        "Prislop",
        "Razoare",
        "Recea",
        "Remecioara",
        "Remetea Chioarului",
        "Remeti",
        "Remeti pe Somes",
        "Repedea",
        "Rodina",
        "Rogoz",
        "Rohia",
        "Romanesti",
        "Rona de Jos",
        "Rona de Sus",
        "Rozavlea",
        "Rus",
        "Ruscova",
        "Rusor",
        "Sabisa",
        "Sacalaseni",
        "Sacel",
        "Saliste",
        "Salistea de Sus",
        "Salnita",
        "Salsig",
        "Salta",
        "Sapanta",
        "Sarasau",
        "Sarbi",
        "Sasar",
        "Sat-Sugatag",
        "Satu Nou de Jos",
        "Satu Nou de Sus",
        "Satulung",
        "Seini",
        "Sieu",
        "Sighetu Marmatiei",
        "Sindresti",
        "Sisesti",
        "Slatioara",
        "Somcuta Mare",
        "Somes-Uileac",
        "Stejera",
        "Stoiceni",
        "Strambu-Baiut",
        "Stramtura",
        "Stremt",
        "Suciu de Jos",
        "Suciu de Sus",
        "Sugau",
        "Surdesti",
        "Tamaia",
        "Tamasesti",
        "Targu Lapus",
        "Tautii de Sus",
        "Tautii-Magheraus",
        "Teceu Mic",
        "Ticau",
        "Tisa",
        "Tohat",
        "Trestia",
        "Tulghies",
        "Ulmeni",
        "Ulmoasa",
        "Unguras",
        "Ungureni",
        "Urmenis",
        "Vad",
        "Vadu Izei",
        "Valea Chioarului",
        "Valea Cufundoasa",
        "Valea Hotarului",
        "Valea Neagra",
        "Valea Stejarului",
        "Valea Viseului",
        "Valeni",
        "Valenii Lapusului",
        "Valenii Somcutei",
        "Varai",
        "Vicea",
        "Viile Apei",
        "Vima Mare",
        "Vima Mica",
        "Viseu de Jos",
        "Viseu de Mijloc",
        "Viseu de Sus"
      ],
      "Mehedinti": [
        "23 August",
        "Adunatii Teiului",
        "Albulesti",
        "Almajel",
        "Alunisul",
        "Arginesti",
        "Arvatesti",
        "Aurora",
        "Bacles",
        "Baditesti",
        "Bahna",
        "Baia de Arama",
        "Baia Noua",
        "Bala",
        "Bala de Sus",
        "Balacita",
        "Balota",
        "Balotesti",
        "Balta",
        "Balta Verde",
        "Baltanele",
        "Baluta",
        "Balvanesti",
        "Balvanestii de Jos",
        "Baraiacu",
        "Barda",
        "Barlogeni",
        "Batoti",
        "Biban",
        "Bistretu",
        "Bistrita",
        "Blidaru",
        "Bobaita",
        "Boceni",
        "Borogea",
        "Bragleasa",
        "Branistea",
        "Branzeni",
        "Bratesul",
        "Bratilovu",
        "Brativoesti",
        "Brebina",
        "Breta",
        "Breznicioara",
        "Breznita-Motru",
        "Breznita-Ocol",
        "Brosteni",
        "Bucura",
        "Budanesti",
        "Buicani",
        "Buicesti",
        "Bunoaica",
        "Burila Mare",
        "Burila Mica",
        "Busesti",
        "Butoiesti",
        "Calinestii de Jos",
        "Calinestii de Sus",
        "Campu Mare",
        "Capatanesti",
        "Caramidaru",
        "Carceni",
        "Carjei",
        "Carsu",
        "Cazanesti",
        "Cearangu",
        "Celnata",
        "Ceptureni",
        "Ceranganul",
        "Cerna-Varf",
        "Cernaia",
        "Cerneti",
        "Cervenita",
        "Ciochiuta",
        "Cioroboreni",
        "Ciovarnasani",
        "Ciresu",
        "Coada Cornetului",
        "Cocorova",
        "Colaret",
        "Colibasi",
        "Comanda",
        "Comanesti",
        "Copacioasa",
        "Corcova",
        "Cordun",
        "Corlatel",
        "Corzu",
        "Cosovat",
        "Costesti",
        "Cotoroaia",
        "Cozia",
        "Cracu Lung",
        "Cracu Muntelui",
        "Craguesti",
        "Crainici",
        "Cremenea",
        "Crivina",
        "Croica",
        "Cujmir",
        "Cujmiru Mic",
        "Dalbocita",
        "Dalma",
        "Danceu",
        "Darvari",
        "Dealu Mare",
        "Dedovita Noua",
        "Dedovita Veche",
        "Deleni",
        "Delureni",
        "Devesel",
        "Dobra",
        "Draghesti",
        "Dragotesti",
        "Drincea",
        "Drobeta-Turnu Severin",
        "Dubova",
        "Dudasu",
        "Dudasu Schelei",
        "Dumbrava de Jos",
        "Dumbrava de Mijloc",
        "Dumbrava de Sus",
        "Dumbravita",
        "Dunarea Mica",
        "Eibenthal",
        "Ercea",
        "Erghevita",
        "Eselnita",
        "Fantana Domneasca",
        "Fantanile Negre",
        "Fata Cremenii",
        "Fata Motrului",
        "Fauroaia",
        "Firizu",
        "Floresti",
        "Garbovatu de Jos",
        "Garbovatu de Sus",
        "Gardaneasa",
        "Gardoaia",
        "Garla Mare",
        "Garnita",
        "Gemeni",
        "Ghelmegioaia",
        "Gheorghesti",
        "Giura",
        "Giurgiani",
        "Goanta",
        "Godeanu",
        "Gogosu",
        "Golineasa",
        "Gornenti",
        "Gornovita",
        "Govodarva",
        "Greci",
        "Grozesti",
        "Gruia",
        "Gura Motrului",
        "Gura Vaii",
        "Gutu",
        "Gvardinita",
        "Halanga",
        "Higiu",
        "Hinova",
        "Hotarani",
        "Hurducesti",
        "Husnicioara",
        "Iablanita",
        "Igiroasa",
        "Ilovat",
        "Ilovita",
        "Ilovu",
        "Imoasa",
        "Isverna",
        "Iupca",
        "Izimsa",
        "Izvoarele",
        "Izvoralu",
        "Izvoralu de Jos",
        "Izvoru Anestilor",
        "Izvoru Barzii",
        "Izvoru Frumos",
        "Jiana",
        "Jiana Mare",
        "Jiana Veche",
        "Jidostita",
        "Jignita",
        "Jirov",
        "Jugastru",
        "Jupanesti",
        "Lac",
        "Lazu",
        "Livezi",
        "Livezile",
        "Ludu",
        "Lumnic",
        "Lunca Banului",
        "Luncsoara",
        "Lupsa de Jos",
        "Lupsa de Sus",
        "Magheru",
        "Magurele",
        "Malarisca",
        "Malovat",
        "Manu",
        "Marasesti",
        "Marga",
        "Marmanu",
        "Maru Rosu",
        "Menti",
        "Meris",
        "Mijarca",
        "Moisesti",
        "Molani",
        "Mosneni",
        "Motruleni",
        "Nadanova",
        "Negoesti",
        "Negresti",
        "Negrusa",
        "Nevatu",
        "Nicolae Balcescu",
        "Noaptesa",
        "Obarsia de Camp",
        "Obarsia-Closani",
        "Ohaba",
        "Olteanca",
        "Opranesti",
        "Oprisor",
        "Orevita Mare",
        "Orsova",
        "Ostrovu Corbului",
        "Ostrovu Mare",
        "Padina Mare",
        "Padina Mica",
        "Paltinisu",
        "Parlagele",
        "Parvulesti",
        "Pasarani",
        "Patulele",
        "Paunesti",
        "Pavat",
        "Peri",
        "Pesteana",
        "Pestenuta",
        "Petra",
        "Petris",
        "Pistrita",
        "Plai",
        "Plopi",
        "Pluta",
        "Podeni",
        "Podu Grosului",
        "Poiana",
        "Poiana Gruii",
        "Ponoarele",
        "Poroina",
        "Poroina Mare",
        "Poroinita",
        "Posta Veche",
        "Prejna",
        "Priboiesti",
        "Prisaceaua",
        "Pristol",
        "Proitesti",
        "Prunaru",
        "Prunisor",
        "Punghina",
        "Puscasu",
        "Putinei",
        "Racova",
        "Radutesti",
        "Raiculesti",
        "Rascolesti",
        "Recea",
        "Rocsoreni",
        "Rogova",
        "Rosia",
        "Rosiori",
        "Rudina",
        "Runcusoru",
        "Ruptura",
        "Salatruc",
        "Salcia",
        "Sardanesti",
        "Satu Mare",
        "Satu Nou",
        "Scapau",
        "Schela Cladovei",
        "Schinteiesti",
        "Schitu Topolnitei",
        "Scorila",
        "Selistea",
        "Selisteni",
        "Selistiuta",
        "Severinesti",
        "Sfodea",
        "Simian",
        "Sipotu",
        "Siroca",
        "Sisesti",
        "Slasoma",
        "Slatinicu Mare",
        "Slatinicu Mic",
        "Smadovita",
        "Sovarna",
        "Sperlesti",
        "Stancesti",
        "Stanesti",
        "Stangaceaua",
        "Stefan Odobleja",
        "Stejaru",
        "Stignita",
        "Stircovita",
        "Strehaia",
        "Stroesti",
        "Studina",
        "Suharu",
        "Susita",
        "Svinita",
        "Talapanu",
        "Tamna",
        "Tantaru",
        "Tarsa",
        "Tiganasi",
        "Tismana",
        "Titerlesti",
        "Titirigi",
        "Traian",
        "Turtaba",
        "Valea Anilor",
        "Valea Buna",
        "Valea Copcii",
        "Valea Cosustei",
        "Valea Marcului",
        "Valea Petrii",
        "Valea Teiului",
        "Valea Ursului",
        "Vanatori",
        "Vanju Mare",
        "Vanjulet",
        "Varodia",
        "Viasu",
        "Vidimiresti",
        "Visina",
        "Vladaia",
        "Vladasesti",
        "Vladica",
        "Voloiac",
        "Voloicel",
        "Vrancea",
        "Vrata",
        "Zegaia",
        "Zegujani"
      ],
      "Mures": [
        "Abud",
        "Abus",
        "Acatari",
        "Adamus",
        "Adrian",
        "Adrianu Mare",
        "Adrianu Mic",
        "Agristeu",
        "Albesti",
        "Alunis",
        "Andreneasa",
        "Angofa",
        "Apalina",
        "Apold",
        "Archita",
        "Arsita",
        "Atintis",
        "Aurel Vlaicu",
        "Avramesti",
        "Bagaciu",
        "Bahnea",
        "Baita",
        "Bala",
        "Balauseri",
        "Balda",
        "Band",
        "Bara",
        "Barbosi",
        "Bardesti",
        "Barlibas",
        "Barlibasoaia",
        "Barza",
        "Batos",
        "Bedeni",
        "Beica de Jos",
        "Beica de Sus",
        "Bereni",
        "Berghia",
        "Bernadea",
        "Beu",
        "Bezid",
        "Bezidu Nou",
        "Bicasu",
        "Bichis",
        "Bistra Muresului",
        "Blidireasa",
        "Bobohalma",
        "Bogata",
        "Boiu",
        "Bolintineni",
        "Bologaia",
        "Bord",
        "Bordosiu",
        "Borzia",
        "Botei",
        "Botez",
        "Botorca",
        "Bozed",
        "Bozeni",
        "Bradetelu",
        "Brancovenesti",
        "Breaza",
        "Budiu Mic",
        "Bujor",
        "Bujor-Hodaie",
        "Caciulata",
        "Cacuciu",
        "Calimanesti",
        "Calugareni",
        "Caluseri",
        "Campenita",
        "Campu Cetatii",
        "Candu",
        "Capalna de Sus",
        "Capeti",
        "Capusu de Campie",
        "Casva",
        "Cecalaca",
        "Ceie",
        "Cerghid",
        "Cerghizel",
        "Ceuas",
        "Ceuasu de Campie",
        "Chendu",
        "Chetani",
        "Chibed",
        "Chiheru de Jos",
        "Chiheru de Sus",
        "Chinari",
        "Chincius",
        "Chirileu",
        "Chisalita",
        "Ciba",
        "Cibu",
        "Cinta",
        "Cioarga",
        "Ciobotani",
        "Cipaieni",
        "Cipau",
        "Ciretea",
        "Cirhagau",
        "Ciulea",
        "Ciurgau",
        "Cloasterf",
        "Coasta Grindului",
        "Coasta Mare",
        "Comori",
        "Corbesti",
        "Cordos",
        "Cornesti",
        "Coroi",
        "Coroisanmartin",
        "Corunca",
        "Cotorinau",
        "Cotus",
        "Cozma",
        "Craciunesti",
        "Craiesti",
        "Cris",
        "Cristesti",
        "Cucerdea",
        "Cuci",
        "Cuiesd",
        "Culpiu",
        "Cund",
        "Curete",
        "Curteni",
        "Custelnic",
        "Daia",
        "Dalu",
        "Dambau",
        "Dambu",
        "Damieni",
        "Danes",
        "Dataseni",
        "Deag",
        "Deaj",
        "Deda",
        "Dedrad",
        "Deleni",
        "Delenii",
        "Dileu Nou",
        "Dileu Vechi",
        "Dobra",
        "Draculea Bandului",
        "Drojdii",
        "Dubistea de Padure",
        "Dulcea",
        "Dumbrava",
        "Dumbravioara",
        "Dumitreni",
        "Dumitrestii",
        "Dupa Deal",
        "Ercea",
        "Eremieni",
        "Eremitu",
        "Ernei",
        "Fanate",
        "Fanatele Capusului",
        "Fanatele Madarasului",
        "Fanatele Socolului",
        "Fantana Babii",
        "Fantanele",
        "Faragau",
        "Feleag",
        "Filea",
        "Filitelnic",
        "Filpisu Mare",
        "Filpisu Mic",
        "Fitcau",
        "Foi",
        "Frunzeni",
        "Fundatura",
        "Fundoaia",
        "Gaiesti",
        "Galaoaia",
        "Galateni",
        "Galesti",
        "Gambut",
        "Ganesti",
        "Gaura Sangerului",
        "Gheja",
        "Gheorghe Doja",
        "Ghidasteu",
        "Ghindari",
        "Ghinesti",
        "Giulus",
        "Giurgis",
        "Glajarie",
        "Glodeni",
        "Gogan",
        "Goreni",
        "Gornesti",
        "Gradini",
        "Grausorul",
        "Grebenisu de Campie",
        "Grindeni",
        "Groapa Radaii",
        "Gruisor",
        "Gurghiu",
        "Habic",
        "Hadareni",
        "Hagau",
        "Haranglab",
        "Hartau",
        "Herepea",
        "Herghelia",
        "Hetiur",
        "Hodac",
        "Hodaia",
        "Hodosa",
        "Iara de Mures",
        "Ibanesti",
        "Ibanesti-Padure",
        "Icland",
        "Iclandu Mare",
        "Iclanzel",
        "Ideciu de Jos",
        "Ideciu de Sus",
        "Idicel",
        "Idicel-Padure",
        "Idiciu",
        "Idrifaia",
        "Iernut",
        "Iernuteni",
        "Ihod",
        "Ilieni",
        "Iliesi",
        "Ilioara",
        "Iod",
        "Isla",
        "Istan-Tau",
        "Istihaza",
        "Ivanesti",
        "Jabenita",
        "Jacodu",
        "Jacu",
        "Lapusna",
        "Larga",
        "Lascud",
        "Laslau Mare",
        "Laslau Mic",
        "Laureni",
        "Lechincioara",
        "Lechinta",
        "Lefaia",
        "Lenis",
        "Leordeni",
        "Leorinta",
        "Leorinta-Saulia",
        "Lepindea",
        "Lint",
        "Livezeni",
        "Logig",
        "Lotu",
        "Ludus",
        "Luieriu",
        "Lunca",
        "Lunca Bradului",
        "Lunca Muresului",
        "Macicasesti",
        "Madaras",
        "Madaraseni",
        "Magherani",
        "Magherus",
        "Maia",
        "Maiad",
        "Maioresti",
        "Malaesti",
        "Maldaoci",
        "Malea",
        "Marasesti",
        "Marculeni",
        "Matrici",
        "Merisor",
        "Merisoru",
        "Mestera",
        "Mica",
        "Miercurea Nirajului",
        "Mihai Viteazu",
        "Mihesu de Campie",
        "Milasel",
        "Mirigioaia",
        "Mitresti",
        "Moara de Jos",
        "Mogoaia",
        "Moisa",
        "Morareni",
        "Moresti",
        "Morut",
        "Mosuni",
        "Mura Mare",
        "Mura Mica",
        "Mureni",
        "Mureseni",
        "Murgesti",
        "Nadasa",
        "Nades",
        "Nandra",
        "Nazna",
        "Neagra",
        "Neaua",
        "Negrenii de Campie",
        "Nicolesti",
        "Nima Milaselului",
        "Nima Raciului",
        "Oarba de Mures",
        "Obarsie",
        "Odrihei",
        "Ogra",
        "Onuca",
        "Ormenis",
        "Oroiu",
        "Orosia",
        "Orsova",
        "Orsova-Padure",
        "Ozd",
        "Pacureni",
        "Padurea",
        "Padureni",
        "Paingeni",
        "Panet",
        "Papiu Ilarian",
        "Parau Crucii",
        "Parau Mare",
        "Pasareni",
        "Paucisoara",
        "Pauloaia",
        "Peris",
        "Petea",
        "Petelea",
        "Petrilaca",
        "Petrilaca de Mures",
        "Pietris",
        "Pipea",
        "Poarta",
        "Poduri",
        "Pogaceaua",
        "Poienita",
        "Porumbac",
        "Porumbeni",
        "Pripoare",
        "Pusta",
        "Racamet",
        "Raciu",
        "Ranta",
        "Rapa de Jos",
        "Rastolita",
        "Razoare",
        "Recea",
        "Reghin",
        "Remetea",
        "Rigmani",
        "Rora",
        "Rosiori",
        "Roteni",
        "Roua",
        "Rusii-Munti",
        "Sabed",
        "Sacadat",
        "Sacalu de Padure",
        "Sacareni",
        "Saes",
        "Salard",
        "Salasuri",
        "Salcud",
        "Sambrias",
        "Sancraiu de Mures",
        "Sandru",
        "Sangeorgiu de Campie",
        "Sangeorgiu de Mures",
        "Sangeorgiu de Padure",
        "Sanger",
        "Sangeru de Padure",
        "Saniacob",
        "Sanisor",
        "Sanmarghita",
        "Sanmartinu de Campie",
        "Sanmihai de Padure",
        "Sanpaul",
        "Sanpetru de Campie",
        "Sansimion",
        "Santana de Mures",
        "Santioana",
        "Santioana de Mures",
        "Santu",
        "Sanvasii",
        "Sapartoc",
        "Sarateni",
        "Sardu Nirajului",
        "Sarmasel",
        "Sarmasel-Gara",
        "Sarmasu",
        "Saschiz",
        "Satu Nou",
        "Saulia",
        "Saulita",
        "Sausa",
        "Scurta",
        "Sebes",
        "Seleus",
        "Senereus",
        "Serbeni",
        "Seuca",
        "Seulia de Mures",
        "Sfantu Gheorghe",
        "Sicele",
        "Sighisoara",
        "Silea Nirajului",
        "Sincai",
        "Sincai-Fanate",
        "Soard",
        "Socolu de Campie",
        "Soimus",
        "Solocma",
        "Solovastru",
        "Somostelnic",
        "Soromiclea",
        "Sovata",
        "Stanceni",
        "Stefanca",
        "Stefaneaca",
        "Stejarenii",
        "Stejeris",
        "Sub Padure",
        "Suplac",
        "Suseni",
        "Suveica",
        "Tablaseni",
        "Tampa",
        "Targu Mures",
        "Tarnaveni",
        "Tau",
        "Taureni",
        "Teleac",
        "Tigmandru",
        "Tiptelnic",
        "Tireu",
        "Tirimia",
        "Tirimioara",
        "Tisieu",
        "Titiana",
        "Toaca",
        "Tofalau",
        "Toldal",
        "Tonciu",
        "Topa",
        "Torba",
        "Trei Sate",
        "Troita",
        "Tusinu",
        "Uila",
        "Ulies",
        "Ungheni",
        "Uricea",
        "Urisiu de Jos",
        "Urisiu de Sus",
        "Ursoaia",
        "Vadas",
        "Vadu",
        "Vaidacuta",
        "Vaideiu",
        "Valea",
        "Valea Albestiului",
        "Valea Daii",
        "Valea Fratiei",
        "Valea Glodului",
        "Valea Iclandului",
        "Valea Izvoarelor",
        "Valea Larga",
        "Valea Mare",
        "Valea Padurii",
        "Valea Rece",
        "Valea Sanmartinului",
        "Valea Sanpetrului",
        "Valea Sapartocului",
        "Valea Sasului",
        "Valea Seaca",
        "Valea Surii",
        "Valea Uliesului",
        "Valea Ungurului",
        "Valea Uriesului",
        "Valeni",
        "Valenii",
        "Valenii de Mures",
        "Valisoara",
        "Valureni",
        "Vanatori",
        "Vargata",
        "Vatava",
        "Venchi",
        "Veta",
        "Vetca",
        "Vidrasau",
        "Viforoasa",
        "Viilor",
        "Viisoara",
        "Visinelu",
        "Voiniceni",
        "Voivodeni",
        "Vulcan",
        "Zagar",
        "Zapodea",
        "Zau de Campie",
        "Zimti"
      ],
      "Neamt": [
        "Adjudeni",
        "Agapia",
        "Agarcia",
        "Almas",
        "Aramesti",
        "Aramoaia",
        "Ardeluta",
        "Averesti",
        "Bahna",
        "Bahna Mare",
        "Bahnisoara",
        "Balanesti",
        "Baltatesti",
        "Balusesti",
        "Baneasa",
        "Baratca",
        "Barcanesti",
        "Bargauani",
        "Barjoveni",
        "Barnadu",
        "Barticesti",
        "Basta",
        "Batranesti",
        "Betesti",
        "Bicaz",
        "Bicaz-Chei",
        "Bicazu Ardelean",
        "Bira",
        "Bisericani",
        "Bistricioara",
        "Bistrita",
        "Blebea",
        "Boboiesti",
        "Bodesti",
        "Bodestii de Jos",
        "Boghicea",
        "Bogzesti",
        "Boistea",
        "Borca",
        "Bordea",
        "Borlesti",
        "Bornis",
        "Borseni",
        "Botesti",
        "Bozieni",
        "Bozienii de Sus",
        "Bradu",
        "Brasauti",
        "Brates",
        "Breaza",
        "Britcani",
        "Brosteni",
        "Brusturi",
        "Bucium",
        "Budesti",
        "Buhalnita",
        "Buhonca",
        "Bunghi",
        "Buruienesti",
        "Busmei",
        "Butnaresti",
        "Caciulesti",
        "Calugareni",
        "Candesti",
        "Capsa",
        "Carlig",
        "Carligi",
        "Casaria",
        "Causeni",
        "Cazaci",
        "Ceahlau",
        "Certieni",
        "Chicerea",
        "Chilia",
        "Chilii",
        "Chintinici",
        "Chiriteni",
        "Ciornei",
        "Ciritei",
        "Ciurea",
        "Climesti",
        "Cordun",
        "Corhana",
        "Corni",
        "Costisa",
        "Cotu Vames",
        "Cracaoani",
        "Cracaul Negru",
        "Craiesti",
        "Cuci",
        "Cuejdiu",
        "Curechistea",
        "Cut",
        "Damuc",
        "Danesti",
        "Darloaia",
        "David",
        "Davideni",
        "Deleni",
        "Doamna",
        "Dobreni",
        "Dochia",
        "Dodeni",
        "Doina",
        "Dolhesti",
        "Doljesti",
        "Dornesti",
        "Draganesti",
        "Dragomiresti",
        "Dragova",
        "Dreptu",
        "Dulcesti",
        "Dumbrava",
        "Dumbrava Deal",
        "Dumbrava Rosie",
        "Dusesti",
        "Farcasa",
        "Faurei",
        "Filioara",
        "Frumosu",
        "Frunzeni",
        "Gadinti",
        "Galu",
        "Garcina",
        "Ghelaiesti",
        "Gheraesti",
        "Gheraestii Noi",
        "Gherman",
        "Ghidion",
        "Ghigoiesti",
        "Ghindaoani",
        "Girov",
        "Giulesti",
        "Giurgeni",
        "Gorun",
        "Gosmani",
        "Grinties",
        "Grosi",
        "Grozavesti",
        "Grumazesti",
        "Gura Vaii",
        "Hamzoaia",
        "Hangu",
        "Hanul Ancutei",
        "Hartesti",
        "Hartop",
        "Hlapesti",
        "Hociungi",
        "Hoisesti",
        "Holm",
        "Homiceni",
        "Horia",
        "Huisurez",
        "Humulesti",
        "Humulestii Noi",
        "Icusesti",
        "Ingaresti",
        "Ion Creanga",
        "Itrinesti",
        "Iucsa",
        "Ivanes",
        "Izvoare",
        "Izvoru",
        "Izvoru Muntelui",
        "Izvorul Alb",
        "Leghin",
        "Liliac",
        "Linsesti",
        "Luminis",
        "Lunca",
        "Lunca Moldovei",
        "Lutca",
        "Madei",
        "Magazia",
        "Manastirea Neamt",
        "Manoaia",
        "Margineni",
        "Marmureni",
        "Mastacan",
        "Mesteacan",
        "Micsunesti",
        "Miron Costin",
        "Mitocu Balan",
        "Moldoveni",
        "Moreni",
        "Muncelu",
        "Muncelu de Jos",
        "Munteni",
        "Neagra",
        "Nechit",
        "Negresti",
        "Negritesti",
        "Negulesti",
        "Nemtisor",
        "Netezi",
        "Nisiporesti",
        "Nistria",
        "Oantu",
        "Oglinzi",
        "Oniceni",
        "Ortasti",
        "Oslobeni",
        "Padureni",
        "Pancesti",
        "Pangaracior",
        "Pangarati",
        "Paraul Carjei",
        "Paraul Fagului",
        "Paraul Mare",
        "Paraul Pantei",
        "Pastraveni",
        "Pataligeni",
        "Patricheni",
        "Petricani",
        "Petru Voda",
        "Piatra Soimului",
        "Piatra-Neamt",
        "Pietrosu",
        "Pildesti",
        "Pipirig",
        "Plaiesu",
        "Plugari",
        "Pluton",
        "Podoleni",
        "Poiana",
        "Poiana Cracaoani",
        "Poiana Humei",
        "Poiana Largului",
        "Poiana Teiului",
        "Poienari",
        "Poieni",
        "Poienile Oancei",
        "Poloboc",
        "Popesti",
        "Potoci",
        "Prajesti",
        "Preluca",
        "Preutesti",
        "Pustieta",
        "Radeni",
        "Rasca",
        "Raucesti",
        "Razboieni",
        "Razboienii de Jos",
        "Recea",
        "Rediu",
        "Rocna",
        "Roman",
        "Romani",
        "Roseni",
        "Rosiori",
        "Rotunda",
        "Roznov",
        "Ruginesti",
        "Ruginoasa",
        "Ruseni",
        "Sabaoani",
        "Sabasa",
        "Sacaleni",
        "Sacalusesti",
        "Sagna",
        "Sarata",
        "Savesti",
        "Savinesti",
        "Scaricica",
        "Schitu Tarcau",
        "Secu",
        "Secuieni",
        "Secuienii Noi",
        "Silistea",
        "Simionesti",
        "Slobozia",
        "Socea",
        "Soci",
        "Soimaresti",
        "Solca",
        "Sovoaia",
        "Spiesti",
        "Spiridonesti",
        "Stanca",
        "Stanita",
        "Stefan cel Mare",
        "Stejaru",
        "Straja",
        "Tabara",
        "Talpa",
        "Talpalai",
        "Tamaseni",
        "Tarcau",
        "Tardenii Mici",
        "Targu Neamt",
        "Tarpesti",
        "Tarzia",
        "Tasca",
        "Tazlau",
        "Telec",
        "Tetcani",
        "Tibucani",
        "Tibucanii de Jos",
        "Ticos",
        "Ticos-Floarea",
        "Timisesti",
        "Todireni",
        "Tolici",
        "Topoliceni",
        "Topolita",
        "Totoiesti",
        "Traian",
        "Trei Fantani",
        "Trifesti",
        "Tupilati",
        "Turturesti",
        "Tutcanii din Deal",
        "Tutcanii din Vale",
        "Uncesti",
        "Ungheni",
        "Unghi",
        "Urecheni",
        "Vad",
        "Vadurele",
        "Vaduri",
        "Valea Alba",
        "Valea Arini",
        "Valea Enei",
        "Valea Mare",
        "Valea Seaca",
        "Valea Ursului",
        "Valeni",
        "Vanatori-Neamt",
        "Varatec",
        "Veja",
        "Versesti",
        "Viisoara",
        "Vladiceni",
        "Vladnicele",
        "Vulpasesti",
        "Zanesti",
        "Zvoranesti"
      ],
      "Olt": [
        "Afumati",
        "Albesti",
        "Alimanesti",
        "Alunisu",
        "Arcesti",
        "Arcesti Cot",
        "Arvateasca",
        "Babiciu",
        "Bacea",
        "Bagesti",
        "Balanesti",
        "Baldovinesti",
        "Baleasa",
        "Bals",
        "Baltati",
        "Balteni",
        "Barasti",
        "Barastii de Cepturi",
        "Barastii de Vede",
        "Barbalai",
        "Barca",
        "Barcanesti",
        "Barsestii de Sus",
        "Barza",
        "Batareni",
        "Batia",
        "Bechet",
        "Beculesti",
        "Belgun",
        "Beria de Jos",
        "Beria de Sus",
        "Berindei",
        "Bircii",
        "Bistrita Noua",
        "Blaj",
        "Bobicesti",
        "Bobu",
        "Bondrea",
        "Boroesti",
        "Brancoveni",
        "Branet",
        "Brastavatu",
        "Brebeni",
        "Brosteni",
        "Bucinisu",
        "Bucinisu Mic",
        "Buicesti",
        "Bulimanu",
        "Burdulesti",
        "Busca",
        "Buta",
        "Butoi",
        "Buzesti",
        "Calinesti",
        "Calui",
        "Campu Mare",
        "Campu Parului",
        "Candelesti",
        "Caracal",
        "Carlogani",
        "Carstani",
        "Catanele",
        "Cazanesti",
        "Cepari",
        "Cepesti",
        "Cerbeni",
        "Cezieni",
        "Chelbesti",
        "Cherlestii din Deal",
        "Cherlestii Mosteni",
        "Chilia",
        "Chilii",
        "Chintesti",
        "Chiteasca",
        "Cilieni",
        "Ciocanesti",
        "Cioflanu",
        "Cioraca",
        "Cioroiasu",
        "Cioroiu",
        "Cireasov",
        "Ciuresti",
        "Cocorasti",
        "Cojgarei",
        "Colibasi",
        "Colonesti",
        "Comanca",
        "Comanesti",
        "Comani",
        "Comanita",
        "Constantinesti",
        "Corabia",
        "Corbeni",
        "Corbu",
        "Corlatesti",
        "Cornatelu",
        "Coteana",
        "Coteni",
        "Cotorbesti",
        "Craciunei",
        "Crampoia",
        "Creti",
        "Criva de Jos",
        "Criva de Sus",
        "Crusovu",
        "Cucueti",
        "Cungrea",
        "Curtisoara",
        "Cuza Voda",
        "Damburile",
        "Daneasa",
        "Davidesti",
        "Dejesti",
        "Deleni",
        "Deveselu",
        "Dienci",
        "Doanca",
        "Doba",
        "Dobretu",
        "Dobriceni",
        "Dobrosloveni",
        "Dobroteasa",
        "Dobrotinet",
        "Dobrun",
        "Donesti",
        "Draganesti-Olt",
        "Draghiceni",
        "Dranovatu",
        "Dumitresti",
        "Enosesti",
        "Fagetelu",
        "Falcoiu",
        "Farcasele",
        "Farcasu de Jos",
        "Floru",
        "Frasinet Gara",
        "Frasinetu",
        "Frunzaru",
        "Ganeasa",
        "Garcov",
        "Gavanesti",
        "Ghimpati",
        "Ghimpeteni",
        "Ghimpetenii Noi",
        "Ghiosani",
        "Giuvarasti",
        "Gostavatu",
        "Govora",
        "Gradinari",
        "Gradinile",
        "Gradistea",
        "Greci",
        "Greeresti",
        "Grojdibodu",
        "Gropsani",
        "Grozavesti",
        "Gruiu",
        "Gubandru",
        "Guesti",
        "Gura Caluiu",
        "Gura Padinii",
        "Horezu",
        "Hotarani",
        "Hotaru",
        "Ianca",
        "Ianca Noua",
        "Iancu Jianu",
        "Ibanesti",
        "Icoana",
        "Ionicesti",
        "Ipotesti",
        "Isaci",
        "Izbiceni",
        "Izvoarele",
        "Izvoru",
        "Jieni",
        "Jitaru",
        "Launele",
        "Lazaresti",
        "Leleasca",
        "Leotesti",
        "Liiceni",
        "Linia din Vale",
        "Lisa",
        "Lunca",
        "Magura",
        "Malu Rosu",
        "Mamura",
        "Mandra",
        "Manulesti",
        "Mardale",
        "Margaritesti",
        "Margheni",
        "Margineni Slobozia",
        "Maruntei",
        "Mereni",
        "Mierlestii de Sus",
        "Mierlicesti",
        "Miesti",
        "Mihaesti",
        "Mihailesti Popesti",
        "Milcoveni",
        "Milcovu din Deal",
        "Milcovu din Vale",
        "Mircesti",
        "Mirila",
        "Mogosesti",
        "Momaiu",
        "Morunesti",
        "Morunglav",
        "Mosteni",
        "Motoesti",
        "Movileni",
        "Navargeni",
        "Negreni",
        "Nicolae Titulescu",
        "Obarsia",
        "Obarsia Noua",
        "Oboga",
        "Ociogi",
        "Olari",
        "Oltisoru",
        "Oporelu",
        "Optasani",
        "Optasi",
        "Orlea",
        "Orlea Noua",
        "Osica de Jos",
        "Osica de Sus",
        "Ostrov",
        "Otestii de Jos",
        "Otestii de Sus",
        "Parscoveni",
        "Peretu",
        "Perieti",
        "Pescaresti",
        "Pestra",
        "Petculesti",
        "Piatra",
        "Piatra-Olt",
        "Pielcani",
        "Pietris",
        "Pietrisu",
        "Piscani",
        "Plaviceanca",
        "Plaviceni",
        "Plesoiu",
        "Plopsorelu",
        "Poboru",
        "Poganu",
        "Poiana",
        "Poiana Mare",
        "Popesti",
        "Potcoava",
        "Potcoava Falcoeni",
        "Potelu",
        "Potlogeni",
        "Potopinu",
        "Preotesti",
        "Prisaca",
        "Priseaca",
        "Proaspeti",
        "Profa",
        "Racovita",
        "Radesti",
        "Radomiresti",
        "Raitiu",
        "Recea",
        "Redea",
        "Redisoara",
        "Resca",
        "Rescuta",
        "Romana",
        "Rosienii Mari",
        "Rosienii Mici",
        "Rotunda",
        "Rudari",
        "Runcu Mare",
        "Rusanesti",
        "Rusanestii de Sus",
        "Rusciori",
        "Salcia",
        "Saltanesti",
        "Samburesti",
        "Satu Nou",
        "Scarisoara",
        "Schitu",
        "Schitu Deleni",
        "Schitu din Deal",
        "Schitu din Vale",
        "Scorbura",
        "Scornicesti",
        "Seaca",
        "Serbanesti",
        "Serbanestii de Sus",
        "Simniceni",
        "Sinesti",
        "Slatina",
        "Slatioara",
        "Slaveni",
        "Soparlita",
        "Spataru",
        "Spineni",
        "Sprancenata",
        "Stanuleasa",
        "Stavaru",
        "Stefan cel Mare",
        "Stejaru",
        "Stoborasti",
        "Stoenesti",
        "Stoicanesti",
        "Strejesti",
        "Strejestii de Sus",
        "Strugurelu",
        "Studina",
        "Studinita",
        "Stupina",
        "Suica",
        "Surpeni",
        "Tabaci",
        "Tabonu",
        "Tatulesti",
        "Teis",
        "Teius",
        "Teiusu",
        "Teslui",
        "Tia Mare",
        "Tirisneag",
        "Tomeni",
        "Tonesti",
        "Topana",
        "Traian",
        "Trepteni",
        "Trufinesti",
        "Tudor Vladimirescu",
        "Tufaru",
        "Tufeni",
        "Turia",
        "Ulmet",
        "Ulmi",
        "Ungureni",
        "Uria",
        "Ursa",
        "Ursi",
        "Ursoaia",
        "Urzica",
        "Vadastra",
        "Vadastrita",
        "Valcele",
        "Valcelele de Sus",
        "Valea Fetei",
        "Valea lui Alb",
        "Valea Mare",
        "Valea Merilor",
        "Valea Satului",
        "Valea Soarelui",
        "Valeni",
        "Vanesti",
        "Vartopu",
        "Verguleasa",
        "Vineti",
        "Visina",
        "Visina Noua",
        "Vitanesti",
        "Vitomiresti",
        "Vladila",
        "Vladila Noua",
        "Vladuleni",
        "Vlaici",
        "Vlangaresti",
        "Voineasa",
        "Vulpeni",
        "Vulpesti",
        "Vulturesti",
        "Zanoaga",
        "Zorleasca"
      ],
      "Prahova": [
        "Adunati",
        "Albesti-Muru",
        "Albesti-Paleologu",
        "Albinari",
        "Alunis",
        "Antofiloaia",
        "Apostolache",
        "Aricestii Rahtivani",
        "Aricestii Zeletin",
        "Arionestii Noi",
        "Arionestii Vechi",
        "Arva",
        "Azuga",
        "Baba Ana",
        "Baicoi",
        "Balta Doamnei",
        "Baltesti",
        "Baltita",
        "Banesti",
        "Bara",
        "Baraitaru",
        "Barcanesti",
        "Barzila",
        "Batesti",
        "Batrani",
        "Belciug",
        "Berceni",
        "Bertea",
        "Bighilin",
        "Blejoi",
        "Bobicesti",
        "Boboci",
        "Bobolia",
        "Bodesti",
        "Bogdanesti",
        "Boldesti",
        "Boldesti-Scaeni",
        "Bordenii Mari",
        "Bordenii Mici",
        "Bosilcesti",
        "Bozieni",
        "Bradet",
        "Bratasanca",
        "Bratesti",
        "Brazii de Jos",
        "Brazii de Sus",
        "Breaza de Jos",
        "Breaza de Sus",
        "Brebu Manastirei",
        "Brebu Megiesesc",
        "Buchilasi",
        "Bucov",
        "Buda",
        "Bughea de Jos",
        "Bugnea de Sus",
        "Bustenari",
        "Busteni",
        "Butuci",
        "Buzota",
        "Calinesti",
        "Calugareni",
        "Campina",
        "Cap Rosu",
        "Carbunari",
        "Carbunesti",
        "Carjari",
        "Cartierul Dambu",
        "Catina",
        "Catunu",
        "Ceptura de Jos",
        "Ceptura de Sus",
        "Cerasu",
        "Cernesti",
        "Cheia",
        "Cherba",
        "Chesnoiu",
        "Chiciureni",
        "Chiojdeanca",
        "Chiritesti",
        "Chitorani",
        "Cioceni",
        "Ciocrac",
        "Cioranii de Jos",
        "Cioranii de Sus",
        "Ciresanu",
        "Ciupelnita",
        "Coada Izvorului",
        "Coada Malului",
        "Coceana",
        "Cocorastii Caplii",
        "Cocorastii Colt",
        "Cocorastii Grind",
        "Cocorastii Mislii",
        "Cocosesti",
        "Colceag",
        "Coltu de Jos",
        "Comarnic",
        "Conduratu",
        "Corlatesti",
        "Cornu de Jos",
        "Cornu de Sus",
        "Coserele",
        "Coslegi",
        "Cosmina de Jos",
        "Cosmina de Sus",
        "Costeni",
        "Cotofenesti",
        "Crangurile",
        "Crivina",
        "Cuib",
        "Curcubeu",
        "Curmatura",
        "Dambu",
        "Darvari",
        "Ditesti",
        "Dobrota",
        "Doftana",
        "Draganeasa",
        "Draganesti",
        "Draghicesti",
        "Drajna de Jos",
        "Drajna de Sus",
        "Dumbrava",
        "Dumbravesti",
        "Ezeni",
        "Facaieni",
        "Faget",
        "Fagetu",
        "Fanari",
        "Fantanele",
        "Fefelei",
        "Filipestii de Padure",
        "Filipestii de Targ",
        "Floresti",
        "Frasinet",
        "Fulga de Jos",
        "Fulga de Sus",
        "Fundeni",
        "Gageni",
        "Galmeia",
        "Gavanel",
        "Gheaba",
        "Gherghita",
        "Ghighiu",
        "Ghinoaica",
        "Ghiocel",
        "Ghioldum",
        "Ghiosesti",
        "Glod",
        "Goga",
        "Gogeasca",
        "Gorgota",
        "Gornet",
        "Gornet-Cricov",
        "Goruna",
        "Gradistea",
        "Gresia",
        "Grosani",
        "Gura Beliei",
        "Gura Crivatului",
        "Gura Vadului",
        "Gura Vitioarei",
        "Habud",
        "Harsa",
        "Hatcarau",
        "Homoraciu",
        "Iazu",
        "Independenta",
        "Inotesti",
        "Iordacheanu",
        "Irimesti",
        "Izesti",
        "Izvoarele",
        "Izvoru",
        "Jercalai",
        "Jugureni",
        "Lacu Turcului",
        "Lapos",
        "Laposel",
        "Liliesti",
        "Lipanesti",
        "Livadea",
        "Loloiasca",
        "Lopatnita",
        "Lunca Mare",
        "Lunca Prahovei",
        "Lutu Rosu",
        "Magula",
        "Magura",
        "Magurele",
        "Magureni",
        "Malaestii de Jos",
        "Malaestii de Sus",
        "Malaiesti",
        "Malamuc",
        "Malu Rosu",
        "Malu Vanat",
        "Manastirea Suzana",
        "Maneciu-Pamanteni",
        "Maneciu-Ungureni",
        "Manesti",
        "Marginea Padurii",
        "Marginenii de Jos",
        "Marlogea",
        "Maruntis",
        "Matita",
        "Mehedinta",
        "Melicesti",
        "Merdeala",
        "Meri",
        "Minieri",
        "Miresu Mare",
        "Miresu Mic",
        "Miroslavesti",
        "Mislea",
        "Mizil",
        "Moara",
        "Moara Domneasca",
        "Moara Noua",
        "Mocesti",
        "Nedelea",
        "Negoiesti",
        "Nevesteasca",
        "Nisipoasa",
        "Nistoresti",
        "Novacesti",
        "Nucet",
        "Nucsoara de Jos",
        "Nucsoara de Sus",
        "Ocina de Jos",
        "Ocina de Sus",
        "Odaile",
        "Ogretin",
        "Olari",
        "Olarii Vechi",
        "Ologeni",
        "Olteni",
        "Orzoaia de Jos",
        "Orzoaia de Sus",
        "Ostrovu",
        "Pacureti",
        "Pacuri",
        "Palanca",
        "Pantazi",
        "Parepa-Rusani",
        "Paulesti",
        "Paulestii Noi",
        "Persunari",
        "Piatra",
        "Piatra Mica",
        "Pietriceaua",
        "Pietricica",
        "Pietrisu",
        "Pietrosani",
        "Pioresti",
        "Pisculesti",
        "Pitigoi",
        "Plai",
        "Plaietu",
        "Plaiu",
        "Plaiu Campinei",
        "Plaiu Cornului",
        "Plavia",
        "Pleasa",
        "Ploiesti",
        "Ploiestiori",
        "Plopeni",
        "Plopu",
        "Podenii Noi",
        "Podenii Vechi",
        "Podgoria",
        "Podu Cheii",
        "Podu Corbului",
        "Podu lui Galben",
        "Podu Lung",
        "Podu Ursului",
        "Podu Vadului",
        "Podu Valeni",
        "Podurile",
        "Poiana",
        "Poiana Campina",
        "Poiana Copaceni",
        "Poiana Mare",
        "Poiana Mierlei",
        "Poiana Tapului",
        "Poiana Trestiei",
        "Poiana Varbilau",
        "Poienarii Apostoli",
        "Poienarii Burchii",
        "Poienarii Rali",
        "Poienarii Vechi",
        "Poienile",
        "Popesti",
        "Posada",
        "Posestii Ungureni",
        "Posestii-Pamanteni",
        "Potigrafu",
        "Prajani",
        "Predeal",
        "Predesti",
        "Priseaca",
        "Provita de Jos",
        "Provita de Sus",
        "Puchenii Mari",
        "Puchenii Mici",
        "Puchenii Mosneni",
        "Puscasi",
        "Rachieri",
        "Radila",
        "Rafov",
        "Ragman",
        "Rahova",
        "Romanesti",
        "Rotarea",
        "Rotari",
        "Salcia",
        "Salciile",
        "Salcioara",
        "Sangeru",
        "Sarari",
        "Saratel",
        "Sarca",
        "Satu de Sus",
        "Satu Nou",
        "Satucu",
        "Schela",
        "Schiau",
        "Schiulesti",
        "Scorteni",
        "Scurtesti",
        "Secaria",
        "Seciu",
        "Seciuri",
        "Sfacaru",
        "Sfarleanca",
        "Sicrita",
        "Silistea",
        "Silistea Dealului",
        "Sinaia",
        "Sipotu",
        "Sirna",
        "Slanic",
        "Slavu",
        "Slon",
        "Soimari",
        "Soimesti",
        "Sotrile",
        "Stancesti",
        "Starchiojd",
        "Stefesti",
        "Stejaru",
        "Stoenesti",
        "Straosti",
        "Strejnicu",
        "Stubeiu",
        "Surani",
        "Surdesti",
        "Talea",
        "Tantareni",
        "Tarculesti",
        "Targsoru Nou",
        "Targsoru Vechi",
        "Tariceni",
        "Tarlesti",
        "Tarsoreni",
        "Tatarai",
        "Tatarani",
        "Tataru",
        "Teisani",
        "Telega",
        "Tesila",
        "Tinosu",
        "Tintea",
        "Tiparesti",
        "Tisa",
        "Tohani",
        "Tomsani",
        "Tontesti",
        "Traisteni",
        "Trenu",
        "Trestienii de Jos",
        "Trestienii de Sus",
        "Trestioara",
        "Tufani",
        "Tufeni",
        "Tulburea",
        "Tulburea Valeni",
        "Udresti",
        "Ulmi",
        "Ungureni",
        "Urlati",
        "Urleta",
        "Vadu Parului",
        "Vadu Sapat",
        "Valcanesti",
        "Valcelele",
        "Valea Anei",
        "Valea Bobului",
        "Valea Borului",
        "Valea Bradetului",
        "Valea Bradului",
        "Valea Calugareasca",
        "Valea Crangului",
        "Valea Cricovului",
        "Valea Cucului",
        "Valea Dulce",
        "Valea Larga",
        "Valea Lespezii",
        "Valea Mantei",
        "Valea Mieilor",
        "Valea Nicovani",
        "Valea Nucetului",
        "Valea Oprii",
        "Valea Orlei",
        "Valea Pietrei",
        "Valea Plopului",
        "Valea Poienii",
        "Valea Popii",
        "Valea Scheilor",
        "Valea Screzii",
        "Valea Seaca",
        "Valea Seman",
        "Valea Stalpului",
        "Valea Stupinii",
        "Valea Tarsei",
        "Valea Tocii",
        "Valea Unghiului",
        "Valea Urloii",
        "Valea Ursoii",
        "Valenii de Munte",
        "Varbila",
        "Varbilau",
        "Varfurile",
        "Varnita",
        "Vistieru",
        "Vitioara de Sus",
        "Zahanaua",
        "Zalhanaua",
        "Zambroaia",
        "Zamfira",
        "Zanoaga",
        "Zmeuret"
      ],
      "Salaj": [
        "Adalin",
        "Aghires",
        "Agrij",
        "Aleus",
        "Almasu",
        "Alunis",
        "Archid",
        "Babeni",
        "Babiu",
        "Badacin",
        "Badon",
        "Baica",
        "Balan",
        "Ban",
        "Banisor",
        "Barsa",
        "Barsau Mare",
        "Barsauta",
        "Benesat",
        "Bercea",
        "Bezded",
        "Bic",
        "Bilghez",
        "Biusa",
        "Bizusa Bai",
        "Bobota",
        "Bocsa",
        "Bocsita",
        "Bodia",
        "Bogdana",
        "Boghis",
        "Borla",
        "Borza",
        "Bozies",
        "Bozna",
        "Braglez",
        "Brebi",
        "Brusturi",
        "Buciumi",
        "Bulgari",
        "Buzas",
        "Calacea",
        "Camar",
        "Campia",
        "Capalna",
        "Carastelec",
        "Ceaca",
        "Cehei",
        "Cehu Silvaniei",
        "Cerisa",
        "Cernuc",
        "Chechis",
        "Chendrea",
        "Chendremal",
        "Cheud",
        "Chichisa",
        "Chiesd",
        "Chilioara",
        "Chizeni",
        "Ciglean",
        "Ciocmani",
        "Ciula",
        "Ciumarna",
        "Ciureni",
        "Cizer",
        "Clit",
        "Colonia Sighetu Silvaniei",
        "Cormenis",
        "Coseiu",
        "Cosniciu de Jos",
        "Cosniciu de Sus",
        "Cozla",
        "Crasna",
        "Creaca",
        "Criseni",
        "Cristelec",
        "Cristolt",
        "Cristoltel",
        "Cristur Criseni",
        "Cublesu",
        "Cuceu",
        "Cuciulat",
        "Cutis",
        "Cuzaplac",
        "Dabaceni",
        "Deja",
        "Deleni",
        "Dersida",
        "Diosod",
        "Doba",
        "Dobrin",
        "Dobrocina",
        "Doh",
        "Dolheni",
        "Dolu",
        "Domnin",
        "Dragu",
        "Drighiu",
        "Dumuslau",
        "Fabrica",
        "Fagetu",
        "Falcusa",
        "Fantanele",
        "Fantanele Rus",
        "Fetindia",
        "Fildu de Jos",
        "Fildu de Mijloc",
        "Fildu de Sus",
        "Firminis",
        "Fizes",
        "Fodora",
        "Francenii de Piatra",
        "Fufez",
        "Galaseni",
        "Galgau",
        "Galgau Almasului",
        "Galpaia",
        "Garbou",
        "Garceiu",
        "Giurtelecu Simleului",
        "Glod",
        "Gostila",
        "Gura Vladesei",
        "Guruslau",
        "Halmasd",
        "Hasmas",
        "Hereclean",
        "Hida",
        "Horoatu Cehului",
        "Horoatu Crasnei",
        "Hurez",
        "Huseni",
        "Husia",
        "Huta",
        "Iaz",
        "Ileanda",
        "Ilisua",
        "Inau",
        "Ip",
        "Jac",
        "Jebucu",
        "Jibou",
        "Lazuri",
        "Lemniu",
        "Lesmir",
        "Letca",
        "Lompirt",
        "Lozna",
        "Luminisu",
        "Lupoaia",
        "Maeriste",
        "Magura",
        "Mal",
        "Maladia",
        "Maleni",
        "Marca",
        "Marca Huta",
        "Marin",
        "Mesesenii de Jos",
        "Mesesenii de Sus",
        "Mesteacanu",
        "Mierta",
        "Miluani",
        "Mineu",
        "Mirsid",
        "Moiad",
        "Moigrad-Porolissum",
        "Motis",
        "Muncel",
        "Nadis",
        "Naimon",
        "Napradea",
        "Negreni",
        "Notig",
        "Nusfalau",
        "Padureni",
        "Paduris",
        "Panic",
        "Pausa",
        "Peceiu",
        "Pericei",
        "Periceiu Mic",
        "Perii Vadului",
        "Petrindu",
        "Petrinzel",
        "Pirosa",
        "Plesca",
        "Plopis",
        "Poarta Salajului",
        "Podisu",
        "Poiana Blenchii",
        "Poiana Magura",
        "Poiana Ontii",
        "Poienita",
        "Popeni",
        "Popteleac",
        "Port",
        "Preluci",
        "Preoteasa",
        "Pria",
        "Prodanesti",
        "Purcaret",
        "Pusta",
        "Racas",
        "Rastoci",
        "Rastolt",
        "Rastoltu Desert",
        "Ratin",
        "Ratovei",
        "Recea",
        "Recea Mica",
        "Rogna",
        "Romanasi",
        "Romita",
        "Rona",
        "Ruginoasa",
        "Rus",
        "Sag",
        "Salajeni",
        "Salatig",
        "Samsud",
        "Sancraiu Almasului",
        "Sancraiu Silvaniei",
        "Sangeorgiu de Meses",
        "Sanmihaiu Almasului",
        "Sanpetru Almasului",
        "Santa Maria",
        "Sarbi",
        "Sarmasag",
        "Sasa",
        "Seredeiu",
        "Sfaras",
        "Sici",
        "Sighetu Silvaniei",
        "Simisna",
        "Simleu Silvaniei",
        "Soimus",
        "Soimuseni",
        "Solomon",
        "Solona",
        "Somes Guruslau",
        "Somes-Odorhei",
        "Stana",
        "Starciu",
        "Stoboru",
        "Stupini",
        "Sub Cetate",
        "Sumal",
        "Surduc",
        "Sutoru",
        "Tamasa",
        "Tarmure",
        "Taudu",
        "Testioara",
        "Tetisu",
        "Tihau",
        "Toplita",
        "Tranis",
        "Trestia",
        "Treznea",
        "Turbuta",
        "Tusa",
        "Ugrutiu",
        "Uileacu Simleului",
        "Ulciug",
        "Vadurele",
        "Valcau de Jos",
        "Valcau de Sus",
        "Valea Ciurenilor",
        "Valea Hranei",
        "Valea Lesului",
        "Valea Loznei",
        "Valea Lunga",
        "Valea Pomilor",
        "Valeni",
        "Valisoara",
        "Var",
        "Varsolt",
        "Vartesca",
        "Verveghiu",
        "Viile Jacului",
        "Voivodeni",
        "Zalau",
        "Zalha",
        "Zalnoc",
        "Zauan",
        "Zauan Bai",
        "Zimbor"
      ],
      "Satu Mare": [
        "Acas",
        "Aciua",
        "Adrian",
        "Ady Endre",
        "Agris",
        "Aliceni",
        "Aliza",
        "Amati",
        "Ambud",
        "Andrid",
        "Apa",
        "Apateu",
        "Ardud",
        "Ardud-Vii",
        "Atea",
        "Baba Novac",
        "Babasesti",
        "Babesti",
        "Babta",
        "Barsau de Jos",
        "Barsau de Sus",
        "Batarci",
        "Becheni",
        "Beltiug",
        "Bercu",
        "Bercu Nou",
        "Berea",
        "Berindan",
        "Berveni",
        "Bicau",
        "Bixad",
        "Blaja",
        "Bocicau",
        "Bogdand",
        "Boghis",
        "Boinesti",
        "Bolda",
        "Borlesti",
        "Botiz",
        "Calinesti-Oas",
        "Camarzana",
        "Camin",
        "Capleni",
        "Caraseu",
        "Carei",
        "Cauas",
        "Cean",
        "Cehal",
        "Cehalut",
        "Certeze",
        "Chegea",
        "Chereusa",
        "Chilia",
        "Chisau",
        "Cidreag",
        "Cig",
        "Cionchesti",
        "Ciumesti",
        "Ciuperceni",
        "Coca",
        "Comlausa",
        "Corod",
        "Corund",
        "Craidorolt",
        "Criseni",
        "Crucisor",
        "Cucu",
        "Culciu Mare",
        "Culciu Mic",
        "Cuta",
        "Dacia",
        "Dara",
        "Decebal",
        "Dindesti",
        "Dindestiu Mic",
        "Doba",
        "Dobolt",
        "Dobra",
        "Domanesti",
        "Dorolt",
        "Draguseni",
        "Dumbrava",
        "Eriu Sancrai",
        "Eteni",
        "Foieni",
        "Ganas",
        "Gelu",
        "Gerausa",
        "Ghenci",
        "Gherta Mare",
        "Gherta Mica",
        "Ghilesti",
        "Ghilvaci",
        "Ghirisa",
        "Ghirolt",
        "Giorocuta",
        "Giungi",
        "Giurtelecu Hododului",
        "Halmeu",
        "Halmeu Vii",
        "Hodisa",
        "Hodod",
        "Homorodu de Jos",
        "Homorodu de Mijloc",
        "Homorodu de Sus",
        "Horea",
        "Hotoan",
        "Hrip",
        "Hurezu Mare",
        "Huta Certeze",
        "Ianculesti",
        "Iegheriste",
        "Iojib",
        "Irina",
        "Istrau",
        "Lazuri",
        "Lechinta",
        "Lelei",
        "Lipau",
        "Livada",
        "Livada Mica",
        "Lucaceni",
        "Luna",
        "Lunca Apei",
        "Madaras",
        "Marius",
        "Marna Noua",
        "Martinesti",
        "Medies Raturi",
        "Medies Vii",
        "Mediesu Aurit",
        "Medisa",
        "Mesteacan",
        "Micula",
        "Micula Noua",
        "Mihaieni",
        "Moftinu Mare",
        "Moftinu Mic",
        "Moiseni",
        "Nadisu Hododului",
        "Necopoi",
        "Negresti-Oas",
        "Nisipeni",
        "Noroieni",
        "Oar",
        "Odoreu",
        "Orasu Nou",
        "Orasu Nou-Vii",
        "Orbau",
        "Pasunea Mare",
        "Paulesti",
        "Paulian",
        "Peles",
        "Pelisor",
        "Petea",
        "Petin",
        "Petresti",
        "Pir",
        "Piru Nou",
        "Piscari",
        "Piscolt",
        "Poiana Codrului",
        "Pomi",
        "Portita",
        "Porumbesti",
        "Potau",
        "Prilog",
        "Prilog Vii",
        "Racova",
        "Racsa",
        "Racsa Vii",
        "Radulesti",
        "Ratesti",
        "Ratiu",
        "Remetea Oasului",
        "Resighea",
        "Romanesti",
        "Rosiori",
        "Ruseni",
        "Sacaseni",
        "Sai",
        "Sandra",
        "Sanislau",
        "Sanmiclaus",
        "Santau",
        "Saratura",
        "Sarauad",
        "Sarvazel",
        "Satmarel",
        "Satu Mare",
        "Satu Mic",
        "Sauca",
        "Scarisoara Noua",
        "Secheresa",
        "Ser",
        "Silvas",
        "Sirlau",
        "Socond",
        "Soconzel",
        "Solduba",
        "Someseni",
        "Stana",
        "Sudurau",
        "Supuru de Jos",
        "Supuru de Sus",
        "Tamaseni",
        "Tarna Mare",
        "Tarsolt",
        "Tasnad",
        "Tataresti",
        "Teghea",
        "Terebesti",
        "Tireac",
        "Tiream",
        "Traian",
        "Trip",
        "Tur",
        "Turt",
        "Turt Bai",
        "Turulung",
        "Turulung Vii",
        "Unimat",
        "Urziceni",
        "Urziceni Padure",
        "Vagas",
        "Valea Morii",
        "Valea Seaca",
        "Valea Vinului",
        "Vama",
        "Vanatoresti",
        "Vetis",
        "Vezendiu",
        "Viile Satu Mare",
        "Viisoara"
      ],
      "Sibiu": [
        "Aciliu",
        "Agarbiciu",
        "Agnita",
        "Alamor",
        "Albi",
        "Alma",
        "Alma Vii",
        "Altina",
        "Amnas",
        "Apoldu de Jos",
        "Apoldu de Sus",
        "Apos",
        "Armeni",
        "Arpasu de Jos",
        "Arpasu de Sus",
        "Atel",
        "Avrig",
        "Axente Sever",
        "Barghis",
        "Bazna",
        "Benesti",
        "Biertan",
        "Blajel",
        "Boarta",
        "Bogatu Roman",
        "Boian",
        "Boita",
        "Bradeni",
        "Bradu",
        "Brateiu",
        "Brosteni",
        "Bruiu",
        "Buia",
        "Bungard",
        "Buzd",
        "Carta",
        "Cartisoara",
        "Casolt",
        "Chesler",
        "Chirpar",
        "Cisnadie",
        "Cisnadioara",
        "Colonia Talmaciu",
        "Colonia Tarnava",
        "Colun",
        "Copsa Mare",
        "Copsa Mica",
        "Cornatel",
        "Coves",
        "Crint",
        "Cristian",
        "Curciu",
        "Daia",
        "Darlos",
        "Dealu Frumos",
        "Dobarca",
        "Dumbraveni",
        "Dupus",
        "Ernea",
        "Fantanele",
        "Floresti",
        "Fofeldea",
        "Gales",
        "Gherdeal",
        "Ghijasa de Jos",
        "Ghijasa de Sus",
        "Giacas",
        "Glamboaca",
        "Gura Raului",
        "Gusu",
        "Hamba",
        "Hasag",
        "Hoghilag",
        "Hosman",
        "Iacobeni",
        "Ighisu Nou",
        "Ighisu Vechi",
        "Ilimbav",
        "Jina",
        "Laslea",
        "Lazaret",
        "Loamnes",
        "Lotrioara",
        "Ludos",
        "Mag",
        "Malancrav",
        "Mandra",
        "Marpod",
        "Marsa",
        "Medias",
        "Merghindeal",
        "Metis",
        "Micasasa",
        "Miercurea Sibiului",
        "Mighindoala",
        "Mihaileni",
        "Moardas",
        "Mohu",
        "Mosna",
        "Motis",
        "Movile",
        "Nemsa",
        "Netus",
        "Nocrich",
        "Noistat",
        "Nou",
        "Nou Sasesc",
        "Noul Roman",
        "Nucet",
        "Ocna Sibiului",
        "Orlat",
        "Padureni",
        "Paltin",
        "Paltinis",
        "Pauca",
        "Paucea",
        "Pelisor",
        "Petis",
        "Poiana Sibiului",
        "Poienita",
        "Poplaca",
        "Porumbacu de Jos",
        "Porumbacu de Sus",
        "Presaca",
        "Prislop",
        "Prod",
        "Racovita",
        "Rasinari",
        "Rau Sadului",
        "Ravasel",
        "Retis",
        "Richis",
        "Roandola",
        "Rod",
        "Romanesti",
        "Rosia",
        "Ruja",
        "Rusciori",
        "Rusi",
        "Sacadate",
        "Sacel",
        "Sadinca",
        "Sadu",
        "Salcau",
        "Saliste",
        "Sangatin",
        "Sarata",
        "Saros pe Tarnave",
        "Sasaus",
        "Scoreiu",
        "Sebesu de Jos",
        "Sebesu de Sus",
        "Seica Mare",
        "Seica Mica",
        "Selimbar",
        "Sibiel",
        "Sibiu",
        "Slimnic",
        "Smig",
        "Soala",
        "Somartin",
        "Sorostin",
        "Stejarisu",
        "Stenea",
        "Sura Mare",
        "Sura Mica",
        "Talmacel",
        "Talmaciu",
        "Tapu",
        "Tarnava",
        "Teline",
        "Tichindeal",
        "Tilisca",
        "Toparcea",
        "Turnu Rosu",
        "Valchid",
        "Vale",
        "Valea Lunga",
        "Valea Viilor",
        "Valeni",
        "Vard",
        "Vecerd",
        "Velt",
        "Veseud",
        "Vestem",
        "Vurpar",
        "Zlagna"
      ],
      "Suceava": [
        "Adancata",
        "Antoceni",
        "Arbore",
        "Argel",
        "Argestru",
        "Arghira",
        "Artari",
        "Badeuti",
        "Badragi",
        "Bahna Arin",
        "Baia",
        "Bainet",
        "Baisesti",
        "Balaceana",
        "Balcauti",
        "Balinesti",
        "Bancesti",
        "Banesti",
        "Barasti",
        "Basarabi",
        "Benia",
        "Berchisesti",
        "Beresti",
        "Bilca",
        "Bivolaria",
        "Bobeica",
        "Bodnareni",
        "Bogata",
        "Bogdanesti",
        "Boroaia",
        "Bosanci",
        "Botesti",
        "Botos",
        "Botosana",
        "Botosanita Mare",
        "Botosanita Mica",
        "Botus",
        "Botusel",
        "Boura",
        "Bradatel",
        "Braiesti",
        "Branistea",
        "Brasca",
        "Breaza",
        "Breaza de Sus",
        "Brodina",
        "Brodina de Jos",
        "Brosteni",
        "Bucsoaia",
        "Buda",
        "Budeni",
        "Bulai",
        "Bunesti",
        "Burla",
        "Bursuceni",
        "Cacica",
        "Cajvana",
        "Calafindesti",
        "Calinesti",
        "Calinesti-Vasilache",
        "Calugareni",
        "Camarzani",
        "Campulung Moldovenesc",
        "Capu Campului",
        "Capu Codrului",
        "Carlibaba",
        "Carlibaba Noua",
        "Casoi",
        "Catrinari",
        "Chiliseni",
        "Chiril",
        "Ciocanesti",
        "Ciomartan",
        "Ciprian Porumbescu",
        "Ciumarna",
        "Ciumulesti",
        "Climauti",
        "Clit",
        "Codru",
        "Cojocareni",
        "Cojoci",
        "Colacu",
        "Comanesti",
        "Corlata",
        "Corni",
        "Cornu Luncii",
        "Corocaiesti",
        "Corpaci",
        "Cosna",
        "Costana",
        "Costileva",
        "Costisa",
        "Cotargasi",
        "Cotu Baii",
        "Cotu Dobei",
        "Coverca",
        "Cozanesti",
        "Crucea",
        "Cumparatura",
        "Cununschi",
        "Danila",
        "Darmanesti",
        "Darmoxa",
        "Dealu",
        "Dealu Floreni",
        "Deia",
        "Deleni",
        "Delnita",
        "Delut",
        "Demacusa",
        "Dolhasca",
        "Dolhestii Mici",
        "Dolhestii-Mari",
        "Dorna Candrenilor",
        "Dorna-Arini",
        "Dornesti",
        "Dornisoara",
        "Doroteia",
        "Dragoiasa",
        "Dragoiesti",
        "Dragomirna",
        "Dragosa",
        "Draguseni",
        "Dubiusca",
        "Dumbrava",
        "Dumbraveni",
        "Dumbravita",
        "Ehreste",
        "Falcau",
        "Falticeni",
        "Fantana Mare",
        "Fantanele",
        "Fetesti",
        "Florinta",
        "Forasti",
        "Frasin",
        "Fratautii Noi",
        "Fratautii Vechi",
        "Frumoasa",
        "Frumosu",
        "Fundu Moldovei",
        "Gainesti",
        "Galanesti",
        "Gara",
        "Gara Leu",
        "Gemenea",
        "Gheorghiteni",
        "Giulesti",
        "Giurgesti",
        "Glodu",
        "Gramesti",
        "Granicesti",
        "Grigoresti",
        "Groapa Vladichii",
        "Gropeni",
        "Gulia",
        "Gura Haitii",
        "Gura Humorului",
        "Gura Putnei",
        "Gura Solcii",
        "Haleasa",
        "Hancea",
        "Hantesti",
        "Hartop",
        "Herla",
        "Holda",
        "Holdita",
        "Horodnic de Jos",
        "Horodnic de Sus",
        "Horodniceni",
        "Hreatca",
        "Humoreni",
        "Hurjuieni",
        "Husi",
        "Iacobeni",
        "Iacobesti",
        "Iaslovat",
        "Iaz",
        "Iedu",
        "Iesle",
        "Ilisesti",
        "Ioneasa",
        "Ipotesti",
        "Izvoarele Sucevei",
        "Jacota",
        "Jahalia",
        "Lamaseni",
        "Leucusesti",
        "Lipoveni",
        "Lisaura",
        "Liteni",
        "Lucacesti",
        "Lunca",
        "Luncusoara",
        "Lungeni",
        "Lupcina",
        "Magura",
        "Maidan",
        "Malini",
        "Manastioara",
        "Manastirea Humorului",
        "Maneuti",
        "Manolea",
        "Marginea",
        "Maritei",
        "Mariteia Mica",
        "Mazanaesti",
        "Mereni",
        "Meresti",
        "Mestecanis",
        "Mesteceni",
        "Mihaiesti",
        "Mihoveni",
        "Milisauti",
        "Mironu",
        "Mitocasi",
        "Mitocu Dragomirnei",
        "Moara Carp",
        "Moara Nica",
        "Moisa",
        "Moldova-Sulita",
        "Moldovita",
        "Molid",
        "Movileni",
        "Musenita",
        "Neagra",
        "Neagra Sarului",
        "Negostina",
        "Negrileasa",
        "Nicani",
        "Nigotesti",
        "Nisipitu",
        "Norocu",
        "Obcina",
        "Oniceni",
        "Ortoaia",
        "Osoi",
        "Ostra",
        "Padureni",
        "Paiseni",
        "Paltin",
        "Paltinis",
        "Paltinoasa",
        "Paltinu",
        "Panaci",
        "Paraie",
        "Parau Negrei",
        "Parhauti",
        "Partestii de Jos",
        "Partestii de Sus",
        "Patrauti",
        "Petia",
        "Pietroasa",
        "Pilugani",
        "Plai",
        "Plaiu Sarului",
        "Plavalari",
        "Plesa",
        "Plesesti",
        "Plopeni",
        "Plutonita",
        "Pocoleni",
        "Podeni",
        "Podu Cosnei",
        "Poiana",
        "Poiana Marului",
        "Poiana Micului",
        "Poiana Negrii",
        "Poiana Stampei",
        "Poienari",
        "Poieni-Solca",
        "Poieni-Suceava",
        "Pojorata",
        "Praleni",
        "Praxia",
        "Prelipca",
        "Preutesti",
        "Prisaca Dornei",
        "Probota",
        "Putna",
        "Racova",
        "Radaseni",
        "Radauti",
        "Rasca",
        "Rauteni",
        "Reuseni",
        "Romanesti",
        "Roscani",
        "Rosiori",
        "Rosu",
        "Rotopanesti",
        "Rotunda",
        "Rudesti",
        "Runcu",
        "Rusca",
        "Rusi",
        "Rusii-Manastioara",
        "Sacuta",
        "Sadau",
        "Sadova",
        "Salageni",
        "Salcea",
        "Sarghiesti",
        "Sarisor",
        "Sarisoru Mare",
        "Saru Bucovinei",
        "Sarul Dornei",
        "Sasca Mare",
        "Sasca Mica",
        "Sasca Noua",
        "Satu Mare",
        "Scheia",
        "Securiceni",
        "Serbanesti",
        "Serbauti",
        "Ses",
        "Sesuri",
        "Sfantu Ilie",
        "Silistea",
        "Silistea Noua",
        "Siminicea",
        "Sinca",
        "Siret",
        "Slatina",
        "Slatioara",
        "Slobozia",
        "Slobozia Sucevei",
        "Smida Ungurenilor",
        "Solca",
        "Soldanesti",
        "Solonet",
        "Solonetu Nou",
        "Spataresti",
        "Stamate",
        "Stanca",
        "Stancuta",
        "Stirbat",
        "Straja",
        "Stramtura",
        "Stroiesti",
        "Stulpicani",
        "Suceava",
        "Sucevita",
        "Sunatori",
        "Tarna Mare",
        "Tarnicioara",
        "Tataru",
        "Tautesti",
        "Tesna",
        "Tibau",
        "Tibeni",
        "Tisauti",
        "Todireni",
        "Todiresti",
        "Tolesti",
        "Trei Movile",
        "Udesti",
        "Uidesti",
        "Ulma",
        "Uncesti",
        "Vadu Moldovei",
        "Vadu Negrilesei",
        "Valcelele",
        "Valea Bancului",
        "Valea Bourei",
        "Valea Glodului",
        "Valea Moldovei",
        "Valea Poienei",
        "Valea Putnei",
        "Valea Stanei",
        "Valeni-Stanisoara",
        "Vama",
        "Varatec",
        "Varfu Dealului",
        "Varvata",
        "Vascauti",
        "Vatra Dornei",
        "Vatra Moldovitei",
        "Verbia",
        "Vercicani",
        "Veresti",
        "Vicovu de Jos",
        "Vicovu de Sus",
        "Vicsani",
        "Voievodeasa",
        "Voitinel",
        "Volovat",
        "Vornicenii Mari",
        "Vornicenii Mici",
        "Voronet",
        "Vulturesti",
        "Zaharesti",
        "Zalomestra",
        "Zamostea",
        "Zvoristea"
      ],
      "Teleorman": [
        "Albeni",
        "Albesti",
        "Alexandria",
        "Antonesti",
        "Babaita",
        "Bacalesti",
        "Baciu",
        "Baduleasa",
        "Balaci",
        "Baldovinesti",
        "Balta Sarata",
        "Baneasa",
        "Banov",
        "Barsestii de Jos",
        "Bascoveni",
        "Beciu",
        "Beiu",
        "Belciug",
        "Beuca",
        "Blejesti",
        "Bogdana",
        "Botoroaga",
        "Bragadiru",
        "Branceni",
        "Brancoveanca",
        "Bratasani",
        "Bratcovu",
        "Bratesti",
        "Brebina",
        "Brosteanca",
        "Bujoreni",
        "Bujoru",
        "Burdeni",
        "Butculesti",
        "Butesti",
        "Buzescu",
        "Calinesti",
        "Calmatuiu",
        "Calmatuiu de Sus",
        "Calomfiresti",
        "Calugaru",
        "Caravaneti",
        "Carlomanu",
        "Catunu",
        "Cernetu",
        "Cervenia",
        "Cetatea",
        "Ciolanestii din Deal",
        "Ciolanestii din Vale",
        "Ciuperceni",
        "Ciurari",
        "Ciurari-Deal",
        "Clanita",
        "Comoara",
        "Contesti",
        "Copaceanca",
        "Cosmesti",
        "Cosoaia",
        "Cosoteni",
        "Crangeni",
        "Crangu",
        "Crevenicu",
        "Cucueti",
        "Darvas",
        "Deparati",
        "Didesti",
        "Dobreni",
        "Dobrotesti",
        "Dorobantu",
        "Dracea",
        "Dracesti",
        "Dracsani",
        "Dracsenei",
        "Draganesti de Vede",
        "Draganesti-Vlasca",
        "Draghinesti",
        "Dudu",
        "Dulceanca",
        "Dulceni",
        "Fantanele",
        "Florica",
        "Frasinet",
        "Frumoasa",
        "Furculesti",
        "Galateni",
        "Garagau",
        "Gardesti",
        "Gradisteanca",
        "Gratia",
        "Gresia",
        "Guruieni",
        "Insuratei",
        "Ionascu",
        "Islaz",
        "Izvoarele",
        "Laceni",
        "Lada",
        "Licuriciu",
        "Linia Costii",
        "Lisa",
        "Lita",
        "Ludaneasca",
        "Lunca",
        "Magura",
        "Magura cu Liliac",
        "Maldaeni",
        "Marita",
        "Marzanesti",
        "Mavrodin",
        "Merenii de Jos",
        "Merenii de Sus",
        "Meri",
        "Merisani",
        "Moldoveni",
        "Mosteni",
        "Nanov",
        "Nasturelu",
        "Navodari",
        "Necsesti",
        "Negreni",
        "Negrenii de Sus",
        "Negrenii-Osebiti",
        "Negrilesti",
        "Nenciulesti",
        "Nicolae Balcescu",
        "Obartu",
        "Odobeasca",
        "Olteanca",
        "Olteni",
        "Orbeasca de Jos",
        "Orbeasca de Sus",
        "Paru Rotund",
        "Pauleasca",
        "Peretu",
        "Perii Brosteni",
        "Piatra",
        "Pietrosani",
        "Pleasov",
        "Plopi",
        "Plopii-Slavitesti",
        "Plosca",
        "Poeni",
        "Poiana",
        "Poroschia",
        "Preajba",
        "Prunaru",
        "Prundu",
        "Purani",
        "Puranii de Sus",
        "Putineiu",
        "Radoiesti-Deal",
        "Radoiesti-Vale",
        "Radulesti",
        "Rasmiresti",
        "Rosiori de Vede",
        "Rotaresti",
        "Saceni",
        "Saelele",
        "Salcia",
        "Sarbeni",
        "Sarbenii de Jos",
        "Satu Nou",
        "Satul Vechi",
        "Schitu Poienari",
        "Scrioastea",
        "Scurtu Mare",
        "Scurtu-Slavesti",
        "Seaca",
        "Secara",
        "Segarcea-Deal",
        "Segarcea-Vale",
        "Sericu",
        "Sfintesti",
        "Silistea",
        "Silistea Mica",
        "Silistea-Gumesti",
        "Slavesti",
        "Slobozia Mandra",
        "Smardan",
        "Smardioasa",
        "Socetu",
        "Soimu",
        "Spatarei",
        "Stefeni",
        "Stejaru",
        "Storobaneasa",
        "Suhaia",
        "Talpa Postei",
        "Talpa-Bascoveni",
        "Talpa-Ograzile",
        "Tarnava",
        "Tatarastii de Jos",
        "Tatarastii de Sus",
        "Tavarlau",
        "Tecuci",
        "Teleormanu",
        "Tiganesti",
        "Traian",
        "Trivalea-Mosteni",
        "Troianul",
        "Tudor Vladimirescu",
        "Tunari",
        "Turnu Magurele",
        "Uda-Clocociov",
        "Uda-Paciurea",
        "Udeni",
        "Udupu",
        "Ulmeni",
        "Urluiu",
        "Vacaresti",
        "Vaceni",
        "Valea Ciresului",
        "Valea Parului",
        "Valea Postei",
        "Vanatori",
        "Vartoapele de Jos",
        "Vartoapele de Sus",
        "Vatasi",
        "Vatra",
        "Vedea",
        "Videle",
        "Viile",
        "Viisoara",
        "Vitanesti",
        "Voievoda",
        "Zambreasca",
        "Zimnicea",
        "Zimnicele",
        "Zlata"
      ],
      "Timis": [
        "Albina",
        "Alios",
        "Altringen",
        "Babsa",
        "Bacova",
        "Balint",
        "Balosesti",
        "Banloc",
        "Bara",
        "Barateaz",
        "Barna",
        "Batesti",
        "Bazos",
        "Bazosu Nou",
        "Beba Veche",
        "Becicherecu Mic",
        "Begheiu Mic",
        "Belint",
        "Bencecu de Jos",
        "Bencecu de Sus",
        "Berecuta",
        "Beregsau Mare",
        "Beregsau Mic",
        "Berini",
        "Bethausen",
        "Bichigi",
        "Biled",
        "Birda",
        "Blajova",
        "Bobda",
        "Bodo",
        "Bogda",
        "Boldur",
        "Botesti",
        "Botinesti",
        "Branesti",
        "Breazova",
        "Brestea",
        "Brestovat",
        "Bucovat",
        "Bulgarus",
        "Bulza",
        "Bunea Mare",
        "Bunea Mica",
        "Butin",
        "Buzad",
        "Buzias",
        "Cadar",
        "Calacea",
        "Capat",
        "Carani",
        "Carpinis",
        "Cebza",
        "Cenad",
        "Cenei",
        "Cerna",
        "Cerneteaz",
        "Charlotenburg",
        "Checea",
        "Cheches",
        "Cheglevici",
        "Cherestur",
        "Cheveresu Mare",
        "Chisoda",
        "Chizatau",
        "Ciacova",
        "Ciresu",
        "Ciresu Mic",
        "Cladova",
        "Cliciova",
        "Clopodia",
        "Colonia Bulgara",
        "Colonia Fabricii",
        "Colonia Mica",
        "Comeat",
        "Comlosu Mare",
        "Comlosu Mic",
        "Cornesti",
        "Cosarii",
        "Cosava",
        "Cosevita",
        "Costeiu",
        "Costeiu de Sus",
        "Covaci",
        "Crai Nou",
        "Cralovat",
        "Criciova",
        "Crivina",
        "Crivina de Sus",
        "Crivobara",
        "Cruceni",
        "Curtea",
        "Cutina",
        "Darova",
        "Dejan",
        "Denta",
        "Deta",
        "Dinias",
        "Dobresti",
        "Dolat",
        "Dragoiesti",
        "Dragomiresti",
        "Dragsina",
        "Dragsinesti",
        "Drinova",
        "Dubesti",
        "Duboz",
        "Dudestii Noi",
        "Dudestii Vechi",
        "Dumbrava",
        "Dumbravita",
        "Fadimac",
        "Faget",
        "Farasesti",
        "Fardea",
        "Ferendia",
        "Fibis",
        "Ficatar",
        "Foeni",
        "Folea",
        "Gad",
        "Gaiu Mic",
        "Gataia",
        "Gavojdia",
        "Gelu",
        "Gherman",
        "Ghilad",
        "Ghiroda",
        "Ghizela",
        "Giarmata",
        "Giarmata-Vii",
        "Giera",
        "Giroc",
        "Giulvaz",
        "Gladna Montana",
        "Gladna Romana",
        "Gottlob",
        "Grabat",
        "Granicerii",
        "Grosi",
        "Gruni",
        "Hauzesti",
        "Herendesti",
        "Herneacova",
        "Hezeris",
        "Hisias",
        "Hitias",
        "Hodoni",
        "Hodos",
        "Homojdia",
        "Honorici",
        "Ianova",
        "Icloda",
        "Ictar-Budinti",
        "Iecea Mare",
        "Iecea Mica",
        "Iersnic",
        "Igris",
        "Iohanisfeld",
        "Iosif",
        "Iosifalau",
        "Ivanda",
        "Izvin",
        "Jabar",
        "Jamu Mare",
        "Jdioara",
        "Jebel",
        "Jena",
        "Jimbolia",
        "Jupanesti",
        "Jupani",
        "Juresti",
        "Lapusnic",
        "Latunas",
        "Lenauheim",
        "Leucusesti",
        "Liebling",
        "Livezile",
        "Lovrin",
        "Lucaret",
        "Lugoj",
        "Lugojel",
        "Luncanii de Jos",
        "Luncanii de Sus",
        "Lunga",
        "Macedonia",
        "Maguri",
        "Manastire",
        "Manastiur",
        "Margina",
        "Masloc",
        "Matnicu Mic",
        "Moravita",
        "Mosnita Noua",
        "Mosnita Veche",
        "Murani",
        "Nadas",
        "Nadrag",
        "Nemesesti",
        "Nerau",
        "Nevrincea",
        "Nitchidorf",
        "Obad",
        "Ofsenita",
        "Ohaba Lunga",
        "Ohaba Romana",
        "Ohaba-Forgaci",
        "Olosag",
        "Opatita",
        "Ortisoara",
        "Otelec",
        "Otvesti",
        "Padurani",
        "Padureni",
        "Paniova",
        "Parta",
        "Partos",
        "Paru",
        "Peciu Nou",
        "Percosova",
        "Periam",
        "Pesac",
        "Petroasa Mare",
        "Petroman",
        "Petrovaselo",
        "Pietroasa",
        "Pini",
        "Pischia",
        "Poganesti",
        "Poieni",
        "Pordeanu",
        "Povargina",
        "Pustinis",
        "Rachita",
        "Racovita",
        "Radmanesti",
        "Rauti",
        "Recas",
        "Remetea Mare",
        "Remetea Mica",
        "Remetea-Lunca",
        "Romanesti",
        "Rovinita Mare",
        "Rovinita Mica",
        "Rudicica",
        "Rudna",
        "Sacalaz",
        "Saceni",
        "Sacosu Mare",
        "Sacosu Turcesc",
        "Sag",
        "Salbagel",
        "Salciua Noua",
        "Sanandrei",
        "Sandra",
        "Sangeorge",
        "Sanmartinu Maghiar",
        "Sanmartinu Sarbesc",
        "Sanmihaiu German",
        "Sanmihaiu Roman",
        "Sannicolau Mare",
        "Sanovita",
        "Sanpetru Mare",
        "Sanpetru Mic",
        "Saravale",
        "Sarazani",
        "Sarbova",
        "Satchinez",
        "Sculia",
        "Secas",
        "Seceani",
        "Semlacu Mare",
        "Semlacu Mic",
        "Silagiu",
        "Sinersig",
        "Sintar",
        "Sintesti",
        "Sipet",
        "Soca",
        "Spata",
        "Stamora Germana",
        "Stamora Romana",
        "Stanciova",
        "Stiuca",
        "Sudrias",
        "Surducu Mic",
        "Susani",
        "Sustra",
        "Tapia",
        "Targoviste",
        "Temeresti",
        "Teremia Mare",
        "Teremia Mica",
        "Tes",
        "Timisoara",
        "Tipari",
        "Toager",
        "Tomesti",
        "Tomnatic",
        "Topla",
        "Topolovatu Mare",
        "Topolovatu Mic",
        "Tormac",
        "Traian Vuia",
        "Uihei",
        "Uivar",
        "Uliuc",
        "Unip",
        "Urseni",
        "Utvin",
        "Valcani",
        "Valea Lunga Romana",
        "Varias",
        "Victor Vlad Delamarina",
        "Visag",
        "Vizejdia",
        "Vizma",
        "Voiteg",
        "Vucova",
        "Zgribesti",
        "Zolt",
        "Zorani"
      ],
      "Tulcea": [
        "Agighiol",
        "Alba",
        "Ardealu",
        "Atmagea",
        "Babadag",
        "Baia",
        "Balabancea",
        "Baltenii de Jos",
        "Baltenii de Sus",
        "Beidaud",
        "Bestepe",
        "C.a. Rosetti",
        "Calfa",
        "Camena",
        "Caprioara",
        "Caraorman",
        "Carcaliu",
        "Cardon",
        "Carjelari",
        "Casimcea",
        "Caslita",
        "Cataloi",
        "Caugagia",
        "Ceamurlia de Jos",
        "Ceamurlia de Sus",
        "Ceatalchioi",
        "Cerbu",
        "Cerna",
        "Chilia Veche",
        "Cismeaua Noua",
        "Ciucurova",
        "Closca",
        "Colina",
        "Corugea",
        "Crisan",
        "Daeni",
        "Dorobantu",
        "Dunavatu de Jos",
        "Dunavatu de Sus",
        "Enisala",
        "Fagarasu Nou",
        "Fantana Mare",
        "Fantana Oilor",
        "Floresti",
        "Frecatei",
        "Garvan",
        "General Praporgescu",
        "Gorgova",
        "Greci",
        "Grindu",
        "Haidar",
        "Hamcearca",
        "Horia",
        "I.c.bratianu",
        "Iazurile",
        "Ilganii de Jos",
        "Ilganii de Sus",
        "Isaccea",
        "Iulia",
        "Izvoarele",
        "Jijila",
        "Jurilovca",
        "Lastuni",
        "Letea",
        "Luminita",
        "Lunca",
        "Luncavita",
        "Macin",
        "Magurele",
        "Mahmudia",
        "Malcoci",
        "Maliuc",
        "Mesteru",
        "Mihai Bravu",
        "Mihail Kogalniceanu",
        "Mila 23",
        "Mina Altan Tepe",
        "Mineri",
        "Mircea Voda",
        "Murighiol",
        "Nalbant",
        "Neatarnarea",
        "Nicolae Balcescu",
        "Niculitel",
        "Nifon",
        "Nufaru",
        "Ostrov",
        "Ostrovu Tataru",
        "Panduru",
        "Parches",
        "Pardina",
        "Partizani",
        "Patlageanca",
        "Peceneaga",
        "Periprava",
        "Piatra",
        "Plauru",
        "Plopul",
        "Posta",
        "Rachelu",
        "Rahman",
        "Randunica",
        "Razboieni",
        "Revarsarea",
        "Sabangia",
        "Salceni",
        "Salcioara",
        "Sambata Noua",
        "Sarichioi",
        "Sarighiol de Deal",
        "Sarinasuf",
        "Satu Nou",
        "Sfantu Gheorghe",
        "Sfistofca",
        "Slava Cercheza",
        "Slava Rusa",
        "Smardan",
        "Somova",
        "Stanca",
        "Stejaru",
        "Sulina",
        "Tatanir",
        "Telita",
        "Tichilesti",
        "Topolog",
        "Traian",
        "Trestenic",
        "Tudor Vladimirescu",
        "Tulcea",
        "Turcoaia",
        "Turda",
        "Uzlina",
        "Vacareni",
        "Valea Nucarilor",
        "Valea Teilor",
        "Vasile Alecsandri",
        "Victoria",
        "Visina",
        "Visterna",
        "Vulturu",
        "Zebil"
      ],
      "Valcea": [
        "Afanata",
        "Aldesti",
        "Alunu",
        "Amarasti",
        "Andreiesti",
        "Aninoasa",
        "Aranghel",
        "Aricioaia",
        "Armasesti",
        "Arsanca",
        "Auresti",
        "Avramesti",
        "Babeni",
        "Babeni-Oltetu",
        "Babuesti",
        "Badeni",
        "Baiasa",
        "Baiasu",
        "Bajenari",
        "Balaciu",
        "Balcesti",
        "Balomireasa",
        "Balota",
        "Balsoara",
        "Baltateni",
        "Balteni",
        "Balutoaia",
        "Banesti",
        "Bantesti",
        "Barbarigeni",
        "Barbatesti",
        "Barbuceni",
        "Barcanele",
        "Barcanesti",
        "Barlogu",
        "Baroiu",
        "Barsesti",
        "Barsoiu",
        "Barza",
        "Barzesti",
        "Batasani",
        "Becsani",
        "Benesti",
        "Berbesti",
        "Bercioiu",
        "Beresti",
        "Berislavesti",
        "Bistrita",
        "Blanoiu",
        "Blejani",
        "Blidari",
        "Bocsa",
        "Bodesti",
        "Bogdanesti",
        "Boisoara",
        "Bonciu",
        "Bondoci",
        "Borosesti",
        "Botorani",
        "Bradisor",
        "Bradu-Clocotici",
        "Bratia din Deal",
        "Bratia din Vale",
        "Bratovesti",
        "Brezoi",
        "Brosteni",
        "Buciumeni",
        "Bucsani",
        "Buda",
        "Budele",
        "Budesti",
        "Budurasti",
        "Bujoreni",
        "Bulagei",
        "Buleta",
        "Bumbuesti",
        "Bunesti",
        "Bungetani",
        "Burdalesti",
        "Butanu",
        "Buzdugan",
        "Caciulata",
        "Cainenii Mari",
        "Cainenii Mici",
        "Caligi",
        "Calimanesti",
        "Calina",
        "Calinesti",
        "Capu Dealului",
        "Carcadiesti",
        "Carlogani",
        "Carstanesti",
        "Casa Veche",
        "Catetu",
        "Cazanesti",
        "Ceretu",
        "Cermegesti",
        "Cerna",
        "Cernelele",
        "Cernisoara",
        "Cetateaua",
        "Cheia",
        "Cherasti",
        "Chiceni",
        "Chirculesti",
        "Chiricesti",
        "Cioboti",
        "Ciocaltei",
        "Ciocanari",
        "Cioponesti",
        "Ciorasti",
        "Ciortesti",
        "Ciresu",
        "Ciresul",
        "Ciucheti",
        "Ciumagi",
        "Ciungetu",
        "Ciutesti",
        "Coasta",
        "Coasta Cerbului",
        "Coasta Mare",
        "Cocoru",
        "Colelia",
        "Coltesti",
        "Comanca",
        "Condoiesti",
        "Contea",
        "Copacelu",
        "Copaceni",
        "Corbii din Vale",
        "Corbu",
        "Cornet",
        "Cosani",
        "Cosota",
        "Costesti",
        "Crangu",
        "Cremenari",
        "Creteni",
        "Cucesti",
        "Cuci",
        "Cucoiu",
        "Cuculesti",
        "Cueni",
        "Curaturile",
        "Curtea",
        "Daesti",
        "Damteni",
        "Dancai",
        "Dangesti",
        "Dealu Alunis",
        "Dealu Bisericii",
        "Dealu Corni",
        "Dealu Glameia",
        "Dealu Launele",
        "Dealu Malului",
        "Dealu Mare",
        "Dealu Scheiului",
        "Dealu Valeni",
        "Dejoi",
        "Deleni",
        "Delureni",
        "Dezrobiti",
        "Diaconesti",
        "Dianu",
        "Diculesti",
        "Dimulesti",
        "Dobresti",
        "Dobricea",
        "Dobriceni",
        "Dobrusa",
        "Dosu Raului",
        "Dozesti",
        "Draganesti",
        "Draganu",
        "Dragasani",
        "Dragioiu",
        "Dragoesti",
        "Dragulesti",
        "Dumbrava",
        "Dumbravesti",
        "Facai",
        "Fartatesti",
        "Fauresti",
        "Fedelesoiu",
        "Feteni",
        "Firesti",
        "Firijba",
        "Fiscalia",
        "Folestii de Jos",
        "Folestii de Sus",
        "Fotesti",
        "Francesti",
        "Francesti-Coasta",
        "Frasina",
        "Fumureni",
        "Fundatura",
        "Gageni",
        "Gainesti",
        "Galicea",
        "Galtofani",
        "Ganesti",
        "Gantulei",
        "Garnicet",
        "Garnicetu",
        "Gatejesti",
        "Gaujani",
        "Gavanesti",
        "Geamana",
        "Genuneni",
        "Ghindari",
        "Ghiobesti",
        "Ghioroiu",
        "Gibesti",
        "Ginerica",
        "Giulesti",
        "Giulestii de Sus",
        "Giurgiuveni",
        "Giuroiu",
        "Glavile",
        "Glodu",
        "Golotreni",
        "Goranu",
        "Gorunesti",
        "Govora",
        "Gradistea",
        "Greblesti",
        "Greci",
        "Gropeni",
        "Grosi",
        "Gruieri",
        "Gruiu",
        "Gruiu Lupului",
        "Guguianca",
        "Gura Crucilor",
        "Gura Suhasului",
        "Gura Vaii",
        "Gurguiata",
        "Gurisoara",
        "Gusoeni",
        "Gusoianca",
        "Herasti",
        "Horezu",
        "Hotarasa",
        "Hotarele",
        "Hotaroaia",
        "Iacovile",
        "Ifrimesti",
        "Igoiu",
        "Ilaciu",
        "Ionesti",
        "Irimesti",
        "Izbasesti",
        "Izvorasu",
        "Izvoru",
        "Izvoru Rece",
        "Jarostea",
        "Jiblea Noua",
        "Jiblea Veche",
        "Lacusteni",
        "Lacustenii de Jos",
        "Lacustenii de Sus",
        "Ladesti",
        "Lalosu",
        "Launele de Jos",
        "Lespezi",
        "Linia",
        "Linia Dealului",
        "Linia Hanului",
        "Linia pe Vale",
        "Livadia",
        "Livezi",
        "Lunca",
        "Lungesti",
        "Lupoaia",
        "Lupuiesti",
        "Maciuceni",
        "Madulari",
        "Magura",
        "Magureni",
        "Malaia",
        "Maldaresti",
        "Maldarestii de Jos",
        "Malu",
        "Malu Alb",
        "Malu Vartop",
        "Mamu",
        "Manailesti",
        "Maneasa",
        "Mangureni",
        "Manicea",
        "Marcea",
        "Marcusu",
        "Margineni",
        "Maricesti",
        "Marita",
        "Mateesti",
        "Mazararu",
        "Mazili",
        "Mecea",
        "Meieni",
        "Meresesti",
        "Mierea",
        "Mihaesti",
        "Mijati",
        "Mijlocu",
        "Milcoiu",
        "Milesti",
        "Milostea",
        "Miresti",
        "Mitrofani",
        "Mlaceni",
        "Modoia",
        "Mogesti",
        "Mogosesti",
        "Mologesti",
        "Mosoroasa",
        "Mosteni",
        "Mrenesti",
        "Muereasca",
        "Muereasca de Sus",
        "Munteni",
        "Neghinesti",
        "Negraia",
        "Negreni",
        "Negrulesti",
        "Nemoiu",
        "Nenciulesti",
        "Netesti",
        "Nicolesti",
        "Nisipi",
        "Obarsia",
        "Obislavu",
        "Obogeni",
        "Obrocesti",
        "Ocnita",
        "Ocracu",
        "Olanesti",
        "Olanu",
        "Olteanca",
        "Olteni",
        "Oltetani",
        "Oltetu",
        "Opatesti",
        "Orlesti",
        "Ostroveni",
        "Otesani",
        "Otetelisu",
        "Oveselu",
        "Padina",
        "Paduretu",
        "Palanga",
        "Paraienii de Jos",
        "Paraienii de Mijloc",
        "Paraienii de Sus",
        "Parausani",
        "Pasarei",
        "Pascoaia",
        "Pasculesti",
        "Patesti",
        "Pausa",
        "Pausesti",
        "Pausesti-Maglasi",
        "Pausesti-Otasau",
        "Perisani",
        "Pertesti",
        "Pesceana",
        "Pietrari",
        "Pietrarii de Sus",
        "Pietreni",
        "Pietrisu",
        "Pietroasa",
        "Piscu Mare",
        "Piscu Pietrei",
        "Piscu Scoartei",
        "Pleasa",
        "Plesesti",
        "Plesoiu",
        "Podeni",
        "Poenari",
        "Poenita",
        "Poiana",
        "Poienari",
        "Pojogi-Cerna",
        "Popesti",
        "Portaresti",
        "Prajila",
        "Predesti",
        "Preotesti",
        "Priba",
        "Priloage",
        "Pripoara",
        "Pripoare",
        "Priporu",
        "Procopoaia",
        "Prodanesti",
        "Proieni",
        "Prundeni",
        "Racovita",
        "Racu",
        "Radacinesti",
        "Ramesti",
        "Ramnicu Valcea",
        "Rapa Caramizii",
        "Rapanesti",
        "Ratalesti",
        "Rau Vadului",
        "Raureni",
        "Robaia",
        "Robesti",
        "Roesti",
        "Romanesti",
        "Romani",
        "Romanii de Jos",
        "Romanii de Sus",
        "Rosia",
        "Rosiile",
        "Rosioara",
        "Rosoveni",
        "Rotarasti",
        "Ruda",
        "Rugetu",
        "Runcu",
        "Rusanesti",
        "Saioci",
        "Salatrucel",
        "Salistea",
        "Sanbotin",
        "Sarbi",
        "Sarsanesti",
        "Sarulesti",
        "Sascioara",
        "Satu Poieni",
        "Scaiosi",
        "Scarisoara",
        "Scaueni",
        "Schitu",
        "Scorusu",
        "Scundu",
        "Seaca",
        "Seciu",
        "Serbaneasa",
        "Serbanesti",
        "Silea",
        "Sinesti",
        "Sirineasa",
        "Slatioara",
        "Slatioarele",
        "Slavitesti",
        "Snamana",
        "Solicesti",
        "Sotani",
        "Sparleni",
        "Spinu",
        "Stanculesti",
        "Stanesti",
        "Stanesti-Lunca",
        "Stanomiru",
        "Stefanesti",
        "Stirbesti",
        "Stoenesti",
        "Stoicanesti",
        "Stoiculesti",
        "Stoilesti",
        "Stolniceni",
        "Strachinesti",
        "Streminoasa",
        "Stroesti",
        "Stuparei",
        "Sub Deal",
        "Suiesti",
        "Surdoiu",
        "Suricaru",
        "Surpatele",
        "Surpati",
        "Susani",
        "Suseni",
        "Suta",
        "Sutesti",
        "Tanasesti",
        "Tanislavi",
        "Targu Gangulesti",
        "Tatarani",
        "Teica",
        "Teiu",
        "Teiul",
        "Teiusu",
        "Telechesti",
        "Tepesti",
        "Tepsenari",
        "Tetoiu",
        "Tighina",
        "Tina",
        "Tisa",
        "Titesti",
        "Titireci",
        "Tomsani",
        "Troian",
        "Trundin",
        "Tufanii",
        "Tulei-Campeni",
        "Turburea",
        "Turcesti",
        "Tutulesti",
        "Tuturu",
        "Udresti",
        "Ulmetel",
        "Ulmetu",
        "Ursani",
        "Ursi",
        "Ursoaia",
        "Urzica",
        "Usurei",
        "Vaideeni",
        "Valea Alunisului",
        "Valea Babei",
        "Valea Balceasca",
        "Valea Caselor",
        "Valea Cheii",
        "Valea Gradistei",
        "Valea lui Stan",
        "Valea Lunga",
        "Valea Macesului",
        "Valea Mare",
        "Valea Raului",
        "Valea Scheiului",
        "Valea Ursului",
        "Valea Valeni",
        "Valea Viei",
        "Valeni",
        "Varateci",
        "Varatica",
        "Varatici",
        "Varleni",
        "Vatasesti",
        "Verdea",
        "Vetelu",
        "Viisoara",
        "Vladesti",
        "Vladuceni",
        "Vladulesti",
        "Voicesti",
        "Voicestii din Vale",
        "Voiculeasa",
        "Voineasa",
        "Voinesita",
        "Vulpuesti",
        "Zarneni",
        "Zarnesti",
        "Zatreni",
        "Zatrenii de Sus",
        "Zavideni",
        "Zavoieni",
        "Zgubea",
        "Zlatarei",
        "Zmeuratu"
      ],
      "Vaslui": [
        "1 Decembrie",
        "Albesti",
        "Albina",
        "Albita",
        "Alexandru Vlahuta",
        "Armaseni",
        "Armasoaia",
        "Arsita",
        "Arsura",
        "Averesti",
        "Avramesti",
        "Babusa",
        "Babuta",
        "Bacani",
        "Bacaoani",
        "Bacesti",
        "Badeana",
        "Bahnari",
        "Baile Dranceni",
        "Balesti",
        "Baltateni",
        "Baltati",
        "Balteni",
        "Balteni-Deal",
        "Banca",
        "Bancesti",
        "Barbosi",
        "Barlad",
        "Barlalesti",
        "Bartalus-Mocani",
        "Bartalus-Razesi",
        "Barzesti",
        "Bejenesti",
        "Belcesti",
        "Belzeni",
        "Benesti",
        "Bereasa",
        "Berezeni",
        "Blagesti",
        "Blesca",
        "Bobesti",
        "Bogdana",
        "Bogdana-Voloseni",
        "Bogdanesti",
        "Bogdanita",
        "Bogesti",
        "Bolati",
        "Borodesti",
        "Botesti",
        "Botoaia",
        "Botoi",
        "Bousori",
        "Bozia",
        "Bradesti",
        "Brahasoaia",
        "Brodoc",
        "Broscosesti",
        "Brosteni",
        "Buda",
        "Budesti",
        "Budu Cantemir",
        "Buhaiesti",
        "Bulboaca",
        "Bumbata",
        "Bunesti",
        "Bursuci",
        "Buscata",
        "Butucaria",
        "Calimanesti",
        "Calugareni",
        "Cantalaresti",
        "Capotesti",
        "Capusneni",
        "Carja",
        "Carjoani",
        "Cartibasi",
        "Cazanesti",
        "Cepesti",
        "Cetatuia",
        "Chersacosu",
        "Chetresti",
        "Chetrosu",
        "Chilieni",
        "Chircesti",
        "Chitcani",
        "Chitoc",
        "Cioatele",
        "Ciocani",
        "Ciofeni",
        "Ciortolom",
        "Ciuperca",
        "Codaesti",
        "Codreni",
        "Condrea",
        "Copaceana",
        "Corbu",
        "Corni-Albesti",
        "Corobanesti",
        "Corodesti",
        "Coroiesti",
        "Coroiestii de Sus",
        "Coroiu",
        "Cosca",
        "Cosesti",
        "Costesti",
        "Cotic",
        "Cozmesti",
        "Craciunesti",
        "Crang",
        "Crangu Nou",
        "Crasna",
        "Crasnaseni",
        "Cretesti",
        "Cretestii de Sus",
        "Cristesti",
        "Crivesti",
        "Cujba",
        "Cursesti-Deal",
        "Cursesti-Vale",
        "Curteni",
        "Danesti",
        "Davidesti",
        "Dealu Mare",
        "Dealu Secarii",
        "Delea",
        "Deleni",
        "Delesti",
        "Dinga",
        "Doagele",
        "Dobroslovesti",
        "Docaneasa",
        "Docani",
        "Dodesti",
        "Dragesti",
        "Dragomanesti",
        "Dragomiresti",
        "Dranceni",
        "Draxeni",
        "Drujesti",
        "Duda",
        "Dumasca",
        "Dumbraveni",
        "Dumesti",
        "Dumestii Vechi",
        "Emil Racovita",
        "Epureni",
        "Falciu",
        "Fantana Blanarului",
        "Fantanele",
        "Fastaci",
        "Fedesti",
        "Feresti",
        "Floreni",
        "Floresti",
        "Focsa",
        "Focseasca",
        "Frasinu",
        "Fruntiseni",
        "Fulgu",
        "Fundatura",
        "Fundatura Mare",
        "Fundatura Mica",
        "Fundu Vaii",
        "Gagesti",
        "Galtesti",
        "Ganesti",
        "Gara Banca",
        "Gara Docaneasa",
        "Gara Rosiesti",
        "Gara Talasman",
        "Garceni",
        "Gardesti",
        "Gavanu",
        "Ghergheleu",
        "Gherghesti",
        "Ghermanesti",
        "Ghicani",
        "Ghireasca",
        "Giurcani",
        "Giurgesti",
        "Glodeni",
        "Grajdeni",
        "Grivita",
        "Grumezoaia",
        "Gugesti",
        "Gura Albesti",
        "Gura Idrici",
        "Gura Vaii",
        "Gusitei",
        "Halaresti",
        "Halta Dodesti",
        "Harsova",
        "Harsoveni",
        "Hoceni",
        "Hordila",
        "Hordilesti",
        "Horga",
        "Horoiata",
        "Hreasca",
        "Huc",
        "Hupca",
        "Hurdugi",
        "Husi",
        "Iana",
        "Iaz",
        "Ibanesti",
        "Idrici",
        "Iezer",
        "Iezerel",
        "Igesti",
        "Ivanesti",
        "Ivesti",
        "Jigalia",
        "Lacu Babei",
        "Lalesti",
        "Latesti",
        "Laza",
        "Lazu",
        "Leosti",
        "Lipovat",
        "Lunca",
        "Lunca Banului",
        "Lunca Veche",
        "Lupesti",
        "Macresti",
        "Malaiesti",
        "Malusteni",
        "Manastirea",
        "Manjesti",
        "Mantu",
        "Manzatesti",
        "Manzati",
        "Maraseni",
        "Marasesti",
        "Mascurei",
        "Miclesti",
        "Mihail Kogalniceanu",
        "Mircesti",
        "Mireni",
        "Mitoc",
        "Moara Domneasca",
        "Moara Grecilor",
        "Morareni",
        "Moreni",
        "Movileni",
        "Muntenesti",
        "Muntenii de Jos",
        "Muntenii de Sus",
        "Murgeni",
        "Musata",
        "Negresti",
        "Obarseni",
        "Obarsenii Lingurari",
        "Odaia Bogdana",
        "Odaia Bursucani",
        "Oltenesti",
        "Oprisita",
        "Orgoiesti",
        "Osesti",
        "Oteleni",
        "Otetoaia",
        "Pacuraresti",
        "Padureni",
        "Pahna",
        "Pahnesti",
        "Paltinis",
        "Parpanita",
        "Parvesti",
        "Peicani",
        "Perieni",
        "Plopeni",
        "Plopi",
        "Plopoasa",
        "Plotonesti",
        "Pochidia",
        "Podeni",
        "Podu Oprii",
        "Podu Petris",
        "Pogana",
        "Poganesti",
        "Pogonesti",
        "Poiana",
        "Poiana lui Alexa",
        "Poiana Pietrei",
        "Poienesti",
        "Poienesti-Deal",
        "Polocin",
        "Popeni",
        "Popesti",
        "Portari",
        "Posta Elan",
        "Pribesti",
        "Protopopesti",
        "Puiesti",
        "Pungesti",
        "Puntiseni",
        "Puscasi",
        "Putu Olarului",
        "Racova",
        "Racovita",
        "Radaesti",
        "Radeni",
        "Radesti",
        "Raducani",
        "Raduiesti",
        "Rafaila",
        "Raiu",
        "Ranceni",
        "Ranzesti",
        "Rapsa",
        "Rascani",
        "Rasesti",
        "Rasnita",
        "Ratesu Cuzei",
        "Rebricea",
        "Recea",
        "Rediu",
        "Rediu Galian",
        "Rosiesti",
        "Rosiori",
        "Rotari",
        "Rugaria",
        "Rusca",
        "Rusi",
        "Salceni",
        "Salcioara",
        "Sarateni",
        "Saratu",
        "Sarbi",
        "Sasova",
        "Satu Nou",
        "Sauca",
        "Schineni",
        "Schinetea",
        "Schitu",
        "Secuia",
        "Semenea",
        "Serbotesti",
        "Silistea",
        "Simila",
        "Similisoara",
        "Sipeni",
        "Siscani",
        "Slobozia",
        "Soci",
        "Sofieni",
        "Sofronesti",
        "Solesti",
        "Soparleni",
        "Stancaseni",
        "Stanilesti",
        "Stefan cel Mare",
        "Stejaru",
        "Stioborani",
        "Stoisesti",
        "Stramtura-Mitoc",
        "Stroiesti",
        "Stuhulet",
        "Suceveni",
        "Suletea",
        "Suseni",
        "Tabalaesti",
        "Tacuta",
        "Talpigeni",
        "Tanacu",
        "Tarzii",
        "Tatarani",
        "Tatomiresti",
        "Teisoru",
        "Telejna",
        "Tibanestii Buhlii",
        "Tifu",
        "Todireni",
        "Todiresti",
        "Tomesti",
        "Tomsa",
        "Toporasti",
        "Trestiana",
        "Trohan",
        "Tufestii de Jos",
        "Tulesti",
        "Tunsesti",
        "Tupilati",
        "Tutcani",
        "Tutova",
        "Ulea",
        "Uncesti",
        "Untesti",
        "Urdesti",
        "Uricari",
        "Urlati",
        "Ursoaia",
        "Vadurile",
        "Valcele",
        "Valea Grecului",
        "Valea lui Bosie",
        "Valea lui Darie",
        "Valea Lunga",
        "Valea Lupului",
        "Valea Mare",
        "Valea Oanei",
        "Valea Popii",
        "Valea Seaca",
        "Valea Silistei",
        "Valea Targului",
        "Valeni",
        "Vaslui",
        "Verdes",
        "Vetrisoaia",
        "Viisoara",
        "Viltotesti",
        "Vinderei",
        "Vinetesti",
        "Visinari",
        "Vizureni",
        "Vladesti",
        "Vladia",
        "Voinesti",
        "Vovriesti",
        "Vulpaseni",
        "Vulturesti",
        "Vutcani",
        "Zapodeni",
        "Zgura",
        "Zizinca",
        "Zorleni"
      ],
      "Vrancea": [
        "Adjud",
        "Adjudu Vechi",
        "Alexandru Vlahuta",
        "Andreiasu de Jos",
        "Andreiasu de Sus",
        "Anghelesti",
        "Argea",
        "Armeni",
        "Arsita",
        "Arva",
        "Bahnele",
        "Balanesti",
        "Balesti",
        "Balta Ratei",
        "Barsesti",
        "Batcari",
        "Batinesti",
        "Beciu",
        "Belciugele",
        "Bicestii de Jos",
        "Bicestii de Sus",
        "Bichesti",
        "Biliesti",
        "Bizighesti",
        "Blidari",
        "Bodesti",
        "Boghesti",
        "Boghestii de Sus",
        "Bogza",
        "Bolotesti",
        "Bontesti",
        "Bordeasca Noua",
        "Bordeasca Veche",
        "Bordesti",
        "Bordestii de Jos",
        "Botarlau",
        "Bradacesti",
        "Bradetu",
        "Brosteni",
        "Buda",
        "Budesti",
        "Burca",
        "Burcioaia",
        "Caiata",
        "Calienii Noi",
        "Calienii Vechi",
        "Calimaneasa",
        "Calimanesti",
        "Campineanca",
        "Campuri",
        "Candesti",
        "Carligele",
        "Carsochesti-Corabita",
        "Catauti",
        "Ceardac",
        "Cerbu",
        "Chiojdeni",
        "Chiricani",
        "Chitcani",
        "Ciolanesti",
        "Ciorani",
        "Ciorasti",
        "Ciuslea",
        "Clipicesti",
        "Cocosari",
        "Codresti",
        "Colacu",
        "Copacesti",
        "Corbita",
        "Cornetu",
        "Coroteni",
        "Costisa",
        "Costisa de Sus",
        "Cotesti",
        "Covrag",
        "Coza",
        "Crucea de Jos",
        "Crucea de Sus",
        "Dalhauti",
        "Dealu Cucului",
        "Dealu Sarii",
        "Dealul Lung",
        "Diochetirediu",
        "Doaga",
        "Domnesti-Sat",
        "Domnesti-Targ",
        "Dragosloveni",
        "Dumbrava",
        "Dumbraveni",
        "Dumitresti",
        "Dumitrestii de Sus",
        "Dumitrestii-Fata",
        "Dupa Magura",
        "Fagetu",
        "Faraoanele",
        "Farcas",
        "Faurei",
        "Feldioara",
        "Fetesti",
        "Fetig",
        "Fitionesti",
        "Focsani",
        "Frecatei",
        "Gagesti",
        "Galbeni",
        "Galoiesti",
        "Garoafa",
        "Ghebari",
        "Ghimicesti",
        "Gogoiu",
        "Golesti",
        "Golestii de Sus",
        "Gologanu",
        "Gresu",
        "Groapa Tufei",
        "Gugesti",
        "Gura Calitei",
        "Gura Vaii",
        "Hangulesti",
        "Haret",
        "Haulisca",
        "Holbanesti",
        "Homocea",
        "Hotaru",
        "Igesti",
        "Iresti",
        "Iugani",
        "Ivancesti",
        "Izvoarele",
        "Jaristea",
        "Jgheaburi",
        "Jiliste",
        "Jitia",
        "Jitia de Jos",
        "Jorasti",
        "Lacu lui Baban",
        "Lamotesti",
        "Largaseni",
        "Lastuni",
        "Lepsa",
        "Lespezi",
        "Liesti",
        "Livada",
        "Livezile",
        "Lojnita",
        "Luncile",
        "Lupoaia",
        "Magura",
        "Mahriu",
        "Maicanesti",
        "Maluri",
        "Manastioara",
        "Mandresti-Moldova",
        "Mandresti-Munteni",
        "Maracini",
        "Marasesti",
        "Marasti",
        "Martinesti",
        "Matacina",
        "Mera",
        "Mesteacanu",
        "Mihalceni",
        "Milcovel",
        "Milcovul",
        "Mircestii Noi",
        "Mircestii Vechi",
        "Modruzeni",
        "Moraresti",
        "Motnau",
        "Movilita",
        "Muncei",
        "Muncelu",
        "Nanesti",
        "Naruja",
        "Neculele",
        "Negrilesti",
        "Neicu",
        "Nereju",
        "Nereju Mic",
        "Nistoresti",
        "Obrejita",
        "Ochesesti",
        "Odobasca",
        "Odobesti",
        "Olareni",
        "Olesesti",
        "Olteni",
        "Oreavu",
        "Padureni",
        "Paltin",
        "Panciu",
        "Patrascani",
        "Paulesti",
        "Paunesti",
        "Pavalari",
        "Petreanu",
        "Petresti",
        "Pietroasa",
        "Piscu Radului",
        "Piscu Reghiului",
        "Pitulusa",
        "Placinteni",
        "Plesesti",
        "Plopu",
        "Ploscuteni",
        "Plostina",
        "Podu Lacului",
        "Podu Narujei",
        "Podu Schiopului",
        "Podu Stoica",
        "Poduri",
        "Podurile",
        "Poenile",
        "Poiana",
        "Poiana Cristei",
        "Poiana Stoichii",
        "Poienita",
        "Popesti",
        "Prahuda",
        "Precistanu",
        "Prisaca",
        "Prisecani",
        "Pufesti",
        "Putna",
        "Rachitasu",
        "Rachitosu",
        "Racoasa",
        "Radacinesti",
        "Radulesti",
        "Raiuti",
        "Ramniceanca",
        "Ramniceni",
        "Rasca",
        "Rastoaca",
        "Rebegari",
        "Reghiu",
        "Repedea",
        "Romanesti",
        "Roscari",
        "Rosioara",
        "Rotilestii Mari",
        "Rotilestii Mici",
        "Rucareni",
        "Ruget",
        "Ruginesti",
        "Sahastru",
        "Salcia Noua",
        "Salcia Veche",
        "Sarbi",
        "Satu Nou",
        "Scafari",
        "Scanteia",
        "Seciu",
        "Serbanesti",
        "Serbesti",
        "Sihlea",
        "Siminoc",
        "Sindrilari",
        "Siretu",
        "Siscani",
        "Slimnic",
        "Slobozia Botesti",
        "Slobozia Bradului",
        "Slobozia Ciorasti",
        "Sotarcari",
        "Spatareasa",
        "Spinesti",
        "Spulber",
        "Strajescu",
        "Straoane",
        "Stupina",
        "Suraia",
        "Tabucesti",
        "Tamboesti",
        "Tanasari",
        "Tanasoaia",
        "Taratu",
        "Tataranu",
        "Tataru",
        "Tepa",
        "Terchesti",
        "Tichiris",
        "Tifesti",
        "Tinoasa",
        "Tipau",
        "Tisita",
        "Titila",
        "Tojanii de Jos",
        "Tojanii de Sus",
        "Topesti",
        "Trestia",
        "Trestieni",
        "Trotusanu",
        "Tulburea",
        "Tulnici",
        "Tutu",
        "Ungureni",
        "Unirea",
        "Urechesti",
        "Ursoaia",
        "Vadu Rosca",
        "Vajaitoarea",
        "Valcani",
        "Valcele",
        "Valcelele",
        "Valea Beciului",
        "Valea Cotesti",
        "Valea Mica",
        "Valea Milcovului",
        "Valea Neagra",
        "Valea Sarii",
        "Valeni",
        "Vanatori",
        "Varnita",
        "Varsatura",
        "Vartescoiu",
        "Verdea",
        "Vetresti-Herastrau",
        "Vidra",
        "Viisoara",
        "Vintileasca",
        "Vitanesti",
        "Vitanestii de Sub Magura",
        "Vizantea Manastireasca",
        "Vizantea Razaseasca",
        "Vladnicu de Jos",
        "Vladnicu de Sus",
        "Voetin",
        "Voloscani",
        "Vrancioaia",
        "Vulcaneasa",
        "Vulturu"
      ]
    }
  }
};
